<template>
  <div
    :class="{ hidden: !hasCaption, block: hasCaption }"
    class="flex flex-col w-[98%] lg:w-[95%] xl:w-[95%] 2xl:w-[90%] items-center justify-center space-y-3 pt-3"
  >
    <!-- tranlate cost calculation -->
    <div
      v-if="originalText.length != 0 && !isFromNotification"
      class="container py-2 items-center justify-center flex flex-col pb-8"
    >
      <!-- <p
        v-if="!computePricing && balanceNotEnough"
        class="text-base pl-4 text-[#2152B6] font-medium text-center"
      >
        {{
          $t(
            "translating-this-text-will-result-in-a-charge-of-texttranslationcost-for-transcription-services",
            { textTranslationCost }
          )
        }}
      </p> -->
      <!-- <div
        v-if="balanceNotEnough && !computePricing"
        class="text-base pl-4 text-red-600 font-medium text-center"
      >
        <p class="text-base pl-4 text-red-600 font-medium">
          {{ $t("your-balance-is-insufficient-please-recharge-to-continue") }}
        </p>
        <button @click="navToPayment">
          {{ $t("clicking-here") }}
        </button>
      </div> -->

      <!-- <p
        v-if="computePricing"
        class="text-base pl-4 text-[#2152B6] font-medium"
      >
        {{ $t("calculating-text-translation-cost-please-wait-0") }}
      </p> -->
    </div>
    <!-- <p class="text-subDark font-semibold text-xl pb-10">
      {{ $t("what-would-you-like-to-transcribe") }}
    </p> -->
    <!-- languages panel -->
    <div
      class="bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-center relative mt-14"
    >
      <div
        class="absolute flex flex-row items-center justify-center mx-auto min-h-20 w-full -translate-y-7 md:-translate-y-5"
      >
        <button
          type="button"
          @click="showTextTab = true"
          :aria-pressed="showTextTab"
          :aria-label="$t('text')"
          class="flex relative w-[50%] justify-end mb-12 md:mb-0 border-0 bg-transparent p-0 cursor-pointer rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4867C8] focus-visible:ring-offset-2"
        >
          <div
            :class="{
              'bg-[#4867C8] text-white': showTextTab,
              'bg-[#EEEEEE] text-black': !showTextTab,
            }"
            class="w-[65%] sm:w-[50%] md:w-[50%] lg:w-[40%] xl:w-[30%] 2xl:w-[25%] font-medium h-10 rounded-full px-4 flex items-center text-xs md:text-lg pointer-events-none"
          >
            {{ $t("text") }}
          </div>
          <div
            :class="{
              'bg-[#4867C8] text-white': showTextTab,
              'bg-[#EEEEEE] text-black': !showTextTab,
              '-translate-x-[20px]': locale != 'ar',
              'translate-x-[20px]': locale === 'ar',
            }"
            class="h-[55px] w-[55px] md:h-[100px] md:w-[100px] rounded-full border-[5px] border-white transform -translate-y-[10px] md:-translate-y-[30px] flex items-center justify-center shrink-0 pointer-events-none"
          >
            <img src="../../../assets/images/home/voice.svg" class="w-10" alt="" />
          </div>
        </button>
        <button
          type="button"
          @click="showTextTab = false"
          :aria-pressed="!showTextTab"
          :aria-label="$t('captions')"
          class="flex relative w-[50%] justify-start items-start mb-12 md:mb-0 border-0 bg-transparent p-0 cursor-pointer rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4867C8] focus-visible:ring-offset-2"
        >
          <div
            :class="{
              'bg-[#4867C8] text-white': !showTextTab,
              'bg-[#D6D6D6] text-black': showTextTab,
              'translate-x-[20px]': locale != 'ar',
              '-translate-x-[20px]': locale === 'ar',
            }"
            class="h-[55px] w-[55px] md:h-[100px] md:w-[100px] rounded-full border-[5px] border-white transform -translate-y-[10px] md:-translate-y-[30px] flex items-center justify-center shrink-0 pointer-events-none"
          >
            <img
              src="../../../assets/images/home/closed-caption.svg"
              class="w-10"
              alt=""
            />
          </div>
          <div
            :class="{
              'bg-[#4867C8] text-white': !showTextTab,
              'bg-[#EEEEEE] text-black': showTextTab,
            }"
            class="w-[65%] sm:w-[50%] md:w-[50%] lg:w-[40%] xl:w-[30%] 2xl:w-[25%] font-medium h-10 rounded-full px-4 flex items-center justify-end text-xs md:text-lg text-nowrap pointer-events-none"
          >
            {{ $t("captions") }}
          </div>
        </button>
      </div>
      <!-- <p class="text-[#061B44] font-semibold text-xl pt-12">
        {{ $t("language-settings") }}
      </p> -->
      <div
        class="flex flex-row items-center justify-end text-nowrap mx-auto w-auto pt-10"
      >
        <!-- first language button -->
        <div
          class="flex flex-col sm:flex-row items-center justify-center w-full"
        >
          <div
            class="flex items-center gap-1.5"
            :class="{ 'flex-row-reverse': locale === 'ar' }"
          >
            <i
              class="pi pi-globe text-[#061B44] opacity-85 flex-shrink-0 text-sm sm:text-base lg:text-lg leading-none"
              aria-hidden="true"
            ></i>
            <p
              class="text-[#061B44] font-semibold text-xs sm:text-sm lg:text-lg"
            >
              {{ removeParentheses(originalLanguage.langName) }}
            </p>
          </div>
        </div>
        <!-- translate button -->
        <div class="flex flex-row items-center justify-center">
          <button
            @click="() => (showTextTab ? translateText() : translateCaptions())"
            :class="{ 
              'opacity-70 cursor-not-allowed': balanceNotEnough || (isTranslatingCaptions && !showTextTab),
              'bg-subDark text-white border-subDark': showTextTab && isMultiLanguageMode && selectedTargetLanguages.length > 0,
              'border-subBlue bg-subBlue bg-opacity-10': showTextTab && translationHint && translationHint.trim().length > 0 && !balanceNotEnough && !(showTextTab && isMultiLanguageMode && selectedTargetLanguages.length > 0)
            }"
            :disabled="balanceNotEnough || (showTextTab && isMultiLanguageMode && selectedTargetLanguages.length === 0) || (isTranslatingCaptions && !showTextTab)"
            class="relative flex flex-row items-center justify-center text-slate-800 border-2 border-slate-700 px-2 sm:px-10 py-1 rounded-lg font-semibold text-sm md:text-base transition-all duration-200 hover:shadow-md"
          >
            <p class="flex items-center space-x-2" :class="{ 'space-x-reverse': locale === 'ar' }">
              <span
                v-if="isTranslatingCaptions && !showTextTab"
                class="inline-block w-4 h-4 border-2 border-slate-500 border-t-transparent rounded-full animate-spin"
                aria-hidden="true"
              ></span>
              <span>{{ isTranslatingCaptions && !showTextTab ? $t("translating-captions") : $t("translate") }}</span>
              <!-- Hint Active Indicator on Button -->
              <span
                v-if="showTextTab && translationHint && translationHint.trim().length > 0"
                class="flex items-center space-x-1 bg-subBlue text-white rounded-full px-2 py-0.5 text-xs font-bold"
                :class="{ 'space-x-reverse': locale === 'ar' }"
                :title="$t('translation-with-context') || 'Translation will use context hint'"
              >
                <i class="pi pi-lightbulb" style="font-size: 0.75rem"></i>
                <span>{{ $t("context") || "Context" }}</span>
              </span>
              <!-- Multi-language count badge -->
              <span
                v-if="showTextTab && isMultiLanguageMode && selectedTargetLanguages.length > 0"
                class="bg-white text-subDark rounded-full px-2 py-0.5 text-xs font-bold"
              >
                {{ selectedTargetLanguages.length }}
              </span>
            </p>
          </button>
          <!-- Context Hint Button - Simple Icon Next to Translate Button -->
          <button
            @click.stop="showHintPopup = !showHintPopup"
            :class="{ 
              'text-slate-900 bg-slate-100': translationHint && translationHint.trim().length > 0,
              'text-slate-400 hover:text-slate-600 hover:bg-slate-50': !translationHint || translationHint.trim().length === 0,
              'mr-2 ml-0': locale === 'ar',
              'ml-2': locale !== 'ar'
            }"
            class="relative flex items-center justify-center w-8 h-8 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-1"
            :title="translationHint && translationHint.trim().length > 0 
              ? ($t('context-hint-active') || 'Context Hint Active - Click to edit') 
              : ($t('add-context-hint') || 'Add Context Hint for Better Translation')"
          >
            <i
              class="pi pi-lightbulb"
              :style="{ fontSize: '1rem' }"
            ></i>
            <span
              v-if="translationHint && translationHint.trim().length > 0"
              class="absolute -top-0.5 -right-0.5 bg-slate-900 text-white rounded-full w-2.5 h-2.5 flex items-center justify-center"
            >
              <span class="text-[8px]">✓</span>
            </span>
          </button>
        </div>
        <!-- second language button -->
        <div class="relative flex flex-row items-center justify-center w-full">
          <button
            @click="isTargetListOpen = !isTargetListOpen"
            :class="{ 'space-x-reverse': locale === 'ar' }"
            class="flex flex-col sm:flex-row items-center justify-center space-x-2"
          >
            <div
              class="flex items-center gap-1.5"
              :class="{ 'flex-row-reverse': locale === 'ar' }"
            >
              <i
                class="pi pi-globe text-[#061B44] opacity-85 flex-shrink-0 text-sm sm:text-base lg:text-lg leading-none"
                aria-hidden="true"
              ></i>
              <p
                class="text-[#061B44] font-semibold text-xs sm:text-sm lg:text-lg"
              >
                {{ removeParentheses(translationLanguage.langName) }}
              </p>
            </div>
            <img
              src="../../../assets/images/audio/02.svg"
              alt=""
              class="w-[14%] lg:w-[5%] text-white fill-white"
            />
          </button>
          <div
            v-if="isTargetListOpen"
            class="overlay z-50"
            @click="closeList"
          >
            <div
              class="overlay-content is-language-picker-overlay flex flex-col items-stretch min-w-[80%] w-[90%] max-w-5xl h-[min(85vh,900px)] max-h-[85vh] min-h-0 overflow-hidden"
              @click.stop
            >
              <div
                :class="{ 'space-x-reverse': locale === 'ar' }"
                class="flex-shrink-0 flex flex-row flex-wrap gap-2 md:gap-0 md:space-x-4 w-full items-center justify-center min-h-10 py-3"
              >
                <input
                  v-model="searchQuery"
                  @input="filteredLanguages"
                  type="text"
                  :placeholder="$t('search-for-a-language')"
                  class="pl-1 md:pl-4 bg-white border border-slate-900 rounded-md text-slate-900 text-xs md:text-base font-semibold w-[60%] sm:w-[40%] h-10"
                />
                <!-- Toggle switch for single/multi selection mode -->
                <div
                  :class="{ 'space-x-reverse': locale === 'ar' }"
                  class="flex flex-row items-center space-x-2 px-2 border border-slate-300 rounded-lg h-10"
                >
                  <span class="text-slate-900 font-semibold text-xs md:text-sm">
                    {{ $t("single-select") }}
                  </span>
                  <label class="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      :checked="isMultiLanguageMode"
                      @change="isMultiLanguageMode = !isMultiLanguageMode"
                      class="sr-only peer"
                    />
                    <div
                      class="w-11 h-6 bg-gray-300 rounded-full peer peer-focus:ring-2 peer-focus:ring-subDark peer-checked:bg-subDark peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"
                    ></div>
                  </label>
                  <span class="text-slate-900 font-semibold text-xs md:text-sm">
                    {{ $t("multi-select") }}
                  </span>
                </div>
                <!-- Context Hint Button in Language Selection -->
                <button
                  @click.stop="showHintPopup = !showHintPopup"
                  :class="{ 
                    'bg-slate-900 text-white border-slate-900': translationHint && translationHint.trim().length > 0,
                    'bg-white border-slate-400 text-slate-700 hover:bg-slate-50': !translationHint || translationHint.trim().length === 0
                  }"
                  class="flex flex-row items-center justify-center gap-1.5 border-2 rounded-lg px-3 py-1.5 h-10 font-medium text-xs md:text-sm transition-all duration-200 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-1"
                  :title="translationHint && translationHint.trim().length > 0 
                    ? ($t('context-hint-active') || 'Context Hint Active - Click to edit') 
                    : ($t('add-context-hint') || 'Add Context Hint for Better Translation')"
                >
                  <i class="pi pi-lightbulb" style="font-size: 0.9rem"></i>
                  <span class="whitespace-nowrap hidden sm:inline">
                    {{ $t("context-hint") || "Context" }}
                  </span>
                  <span
                    v-if="translationHint && translationHint.trim().length > 0"
                    class="ml-0.5 bg-white text-slate-900 rounded-full px-1.5 py-0.5 text-xs font-bold shadow-sm"
                  >
                    ✓
                  </span>
                </button>
                <button
                  @click="closeList"
                  class="bg-white border border-slate-900 rounded-md text-slate-900 text-base md:text-lg font-bold py-1 px-8 h-10"
                >
                  {{ $t("close") }}
                </button>
              </div>
              <!-- Quick Access: Languages with existing translations -->
              <div
                v-if="searchQuery.length === 0 && availableTranslatedLanguages.length > 0"
                class="flex-shrink-0 py-3 border-b border-gray-300 w-full px-1 max-h-[min(22vh,220px)] min-h-0 overflow-y-auto"
              >
                <p class="text-xs md:text-sm font-semibold text-gray-600 mb-2">
                  {{ $t("languages-with-translations") || "Languages with Translations" }}
                </p>
                <div
                  :class="{ 'space-x-reverse': locale === 'ar' }"
                  class="flex flex-row flex-wrap gap-2"
                >
                  <button
                    v-for="lang in availableTranslatedLanguages"
                    :key="lang.langCode"
                    @click="selectTargetLanguage(lang)"
                    class="flex items-center gap-2 bg-green-50 hover:bg-green-100 text-green-700 px-3 py-1.5 rounded-full text-sm font-medium border border-green-300 transition-colors"
                  >
                    <i
                      class="pi pi-globe text-green-600 flex-shrink-0"
                      style="font-size: 0.875rem"
                      aria-hidden="true"
                    ></i>
                    <span>{{ lang.langName }}</span>
                    <i class="pi pi-check-circle text-green-600" style="font-size: 0.875rem"></i>
                  </button>
                </div>
              </div>
              <!-- Selected languages display (multi-select mode) -->
              <div
                v-if="isMultiLanguageMode"
                class="flex-shrink-0 w-full px-4 py-3 mb-2 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 shadow-sm max-h-[min(28vh,280px)] min-h-0 overflow-y-auto"
              >
                <div class="flex items-center justify-between mb-2">
                  <p class="text-xs md:text-sm font-semibold text-blue-700">
                    {{ $t("selected-languages") || "Selected Languages" }}
                  </p>
                  <span 
                    v-if="selectedTargetLanguages.length > 0"
                    class="text-xs md:text-sm font-bold text-blue-600 bg-white px-2 py-1 rounded-full border border-blue-300"
                  >
                    {{ selectedTargetLanguages.length }}
                  </span>
                  <span 
                    v-else
                    class="text-xs md:text-sm font-medium text-gray-500 italic"
                  >
                    {{ $t("no-languages-selected") || "None selected" }}
                  </span>
                </div>
                <div
                  v-if="selectedTargetLanguages.length > 0"
                  :class="{ 'space-x-reverse': locale === 'ar' }"
                  class="flex flex-row flex-wrap gap-2"
                >
                  <span
                    v-for="lang in selectedTargetLanguages"
                    :key="lang.langCode"
                    class="flex items-center gap-2 bg-white text-subDark px-3 py-1.5 rounded-full text-sm font-medium border border-blue-300 shadow-sm hover:shadow-md transition-shadow"
                  >
                    <i
                      class="pi pi-globe text-subDark opacity-70 flex-shrink-0"
                      style="font-size: 0.875rem"
                      aria-hidden="true"
                    ></i>
                    <span>{{ lang.langName }}</span>
                    <i
                      v-if="hasTranslation(lang.langCode)"
                      class="pi pi-check-circle text-green-600"
                      style="font-size: 0.875rem"
                      :title="$t('translation-available') || 'Translation available'"
                    ></i>
                  </span>
                </div>
                <p 
                  v-else
                  class="text-xs md:text-sm text-gray-500 italic text-center py-2"
                >
                  {{ $t("select-languages-to-translate") || "Select one or more languages to translate" }}
                </p>
              </div>
              <ul
                class="py-1 flex-1 min-h-0 w-full grid grid-cols-1 md:grid-cols-3 2xl:grid-cols-4 gap-4 overflow-y-auto overscroll-contain"
              >
                <li
                  v-for="lang in myLanguagesList"
                  :key="lang.langName"
                  :class="{
                    'space-x-reverse': locale === 'ar',
                    'opacity-50 cursor-not-allowed': isMultiLanguageMode && originalLanguage.langCode && lang.langCode === originalLanguage.langCode,
                    'cursor-pointer hover:bg-gray-50': isMultiLanguageMode && (!originalLanguage.langCode || lang.langCode !== originalLanguage.langCode),
                  }"
                  @click="isMultiLanguageMode && (!originalLanguage.langCode || lang.langCode !== originalLanguage.langCode) ? selectTargetLanguage(lang) : null"
                  class="flex flex-row space-x-2 items-center px-2 py-2 rounded-md transition-colors"
                >
                  <!-- Checkbox for multi-select mode -->
                  <input
                    v-if="isMultiLanguageMode"
                    type="checkbox"
                    :checked="selectedTargetLanguages.some((l) => l.langCode === lang.langCode)"
                    :disabled="!!(originalLanguage.langCode && lang.langCode === originalLanguage.langCode)"
                    @change="selectTargetLanguage(lang)"
                    @click.stop
                    class="w-4 h-4 text-subBlue border-gray-300 rounded focus:ring-subBlue disabled:opacity-40 disabled:cursor-not-allowed"
                  />
                  <i
                    class="pi pi-globe text-gray-400 flex-shrink-0"
                    style="font-size: 0.875rem"
                    aria-hidden="true"
                  ></i>
                  <a
                    @click.stop="selectTargetLanguage(lang)"
                    :class="{
                      'font-bold text-subBlue': !isMultiLanguageMode && translationLanguage.langCode === lang.langCode,
                      'opacity-50': isMultiLanguageMode && selectedTargetLanguages.some((l) => l.langCode === lang.langCode),
                      'bg-green-50 border-l-4 border-green-500 pl-3': hasTranslation(lang.langCode) && !isMultiLanguageMode,
                      'bg-blue-50': hasTranslation(lang.langCode) && isMultiLanguageMode,
                      'text-gray-400': isMultiLanguageMode && originalLanguage.langCode && lang.langCode === originalLanguage.langCode,
                    }"
                    class="block px-4 py-2 text-gray-800 font-semibold cursor-pointer rounded-md transition-colors flex-1"
                  >
                    <span class="flex items-center gap-2">
                      <span class="truncate">{{ lang.langName }}</span>
                      <i
                        v-if="hasTranslation(lang.langCode)"
                        class="pi pi-check-circle text-green-600 flex-shrink-0"
                        style="font-size: 0.875rem"
                        :title="$t('translation-available') || 'Translation available'"
                      ></i>
                      <i
                        v-if="isMultiLanguageMode && originalLanguage.langCode && lang.langCode === originalLanguage.langCode"
                        class="pi pi-info-circle text-gray-400 flex-shrink-0"
                        style="font-size: 0.875rem"
                        :title="$t('same-as-original-language') || 'Same as original language'"
                      ></i>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div
            v-if="fontFamilyListShow"
            class="overlay z-50"
            @click="showFontFamilyList"
          >
            <div class="overlay-content flex flex-col relative w-[95%] lg:w-[85%] xl:w-[70%] max-h-[1000px]" @click.stop>
              <p class="text-[#061B44] font-semibold text-xl pb-2 text-center">
                {{ $t("select-a-font") }}
              </p>
              <input
                v-model="searchQuery"
                type="text"
                :placeholder="$t('search-font')"
                class="border p-2 mb-4 rounded-md w-full"
              />
              <ul
                class="py-1 h-75vh grid grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 gap-4 overflow-y-auto"
              >
                <li
                  v-for="font in filteredFonts"
                  :key="font.name"
                  :class="{ 'space-x-reverse': locale === 'ar' }"
                  class="flex flex-row space-x-2"
                >
                  <a
                    @click="updatePreviewFont(font.name, font.files.regular)"
                    :class="{
                      'border-subBlue bg-subBlue bg-opacity-15': font.name === selectedPreviewFont,
                    }"
                    class="block px-4 py-2 text-xs md:text-base text-gray-800 font-medium cursor-pointer border border-slate-500 p-2 rounded-md w-full"
                    :style="{ fontFamily: font.name }"
                  >
                    {{ font.name }}
                  </a>
                </li>
              </ul>
              <div class="flex flex-col space-y-2 pt-2">
                <p class="text-slate-900 font-medium text-lg text-center">
                  {{ $t("preview") }}
                </p>
                <p
                  :style="{ fontFamily: selectedPreviewFont }"
                  class="text-slate-900 font-normal text-xs md:text-base border border-slate-700 p-2 min-w-full rounded-md bg-subBlue bg-opacity-15 text-wrap text-start"
                >
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                </p>
                <div
                  :class="{ 'space-x-reverse': locale === 'ar' }"
                  class="flex flex-row md:space-x-2 justify-between md:justify-end pt-2"
                >
                  <button
                    @click="showFontFamilyList"
                    class="bg-white border border-slate-900 rounded-md text-slate-900 text-sm md:text-lg font-bold py-1 px-8 h-10"
                  >
                    {{ $t("close") }}
                  </button>
                  <button
                    @click="
                      selectedPreviewFont != null
                        ? applyFont(selectedPreviewFont)
                        : null
                    "
                    class="bg-subDark border border-slate-900 rounded-md text-white text-sm md:text-lg font-bold py-1 px-8 h-10"
                  >
                    {{ $t("apply-font") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- translation language gridview -->
          <div
            v-if="fontFamilyListShowCaptions"
            class="overlay z-50"
            @click="showFontFamilyListCaptions"
          >
            <div class="overlay-content flex flex-col relative w-[95%] lg:w-[85%] xl:w-[70%] max-h-[1000px]" @click.stop>
              <p class="text-[#061B44] font-semibold text-xl pb-2 text-center">
                {{ $t("select-a-font") }}
              </p>
              <input
                v-model="searchQuery"
                type="text"
                :placeholder="$t('search-font')"
                class="border p-2 mb-4 rounded-md w-full"
              />
              <ul
                class="py-1 h-75vh grid grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 gap-4 overflow-y-auto"
              >
                <li
                  v-for="font in filteredFonts"
                  :key="font.name"
                  :class="{ 'space-x-reverse': locale === 'ar' }"
                  class="flex flex-row space-x-2"
                >
                  <a
                    @click="updatePreviewFontCaptions(font.name, font.files.regular)"
                    :class="{
                      'border-subBlue bg-subBlue bg-opacity-15': font.name === selectedPreviewFontCaption,
                    }"
                    class="block px-4 py-2 text-xs md:text-base text-gray-800 font-medium cursor-pointer border border-slate-500 p-2 rounded-md w-full"
                    :style="{ fontFamily: font.name }"
                  >
                    {{ font.name }}
                  </a>
                </li>
              </ul>
              <div class="flex flex-col space-y-2 pt-2">
                <p class="text-slate-900 font-medium text-lg text-center">
                  {{ $t("preview") }}
                </p>
                <p
                  :style="{ fontFamily: selectedPreviewFontCaption }"
                  class="text-slate-900 font-normal text-xs md:text-base border border-slate-700 p-2 min-w-full rounded-md bg-subBlue bg-opacity-15 text-wrap text-start"
                >
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit.
                </p>
                <div
                  :class="{ 'space-x-reverse': locale === 'ar' }"
                  class="flex flex-row md:space-x-2 justify-between md:justify-end pt-2"
                >
                  <button
                    @click="showFontFamilyListCaptions"
                    class="bg-white border border-slate-900 rounded-md text-slate-900 text-sm md:text-lg font-bold py-1 px-8 h-10"
                  >
                    {{ $t("close") }}
                  </button>
                  <button
                    @click="
                      selectedPreviewFontCaption != null
                        ? applyFontCaptions(selectedPreviewFontCaption)
                        : null
                    "
                    class="bg-subDark border border-slate-900 rounded-md text-white text-sm md:text-lg font-bold py-1 px-8 h-10"
                  >
                    {{ $t("apply-font") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div></div>
    <div class="flex flex-col-reverse xl:flex-row w-full">
      <!-- player panel -->
      <div class="flex flex-col w-full xl:w-[55%] xl:pr-4 space-y-4">
        <div
          class="w-full"
          id="videoContainer"
          :class="{ hidden: !mountPlayer }"
        >
          <div id="ytPlayer"></div>
          <div
            v-if="isCaptionOn"
            :style="{
              backgroundColor: !useCaptionBackground
                ? 'rgba(0,0,0,0)'
                : pickedBackgroundColor,
            }"
            class="captionContainer"
          >
            <ul
              :style="{
                color: pickedColorCaptions,
                fontFamily: fontFamilyCaptions,
              }"
              :class="fontSizeClassCaptions"
              class="text-center text-2xl"
            >
              <li v-for="caption in currentCaptions" :key="caption.start">
                <p v-html="caption.text"></p>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="w-full text-nowrap flex flex-col items-start bg-white border rounded-lg p-1 py-4 space-y-2"
        >
          <div class="flex flex-wrap gap-x-2 gap-y-2">
            <p
              class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
            >
              {{ $t("language") }}:
            </p>
            <button
              @click="isCaptionsLangsDropOpen = !isCaptionsLangsDropOpen"
              class="flex items-center gap-2 px-4 py-2 text-sm text-slate-900 font-bold bg-white border border-gray-300 rounded-md shadow-sm"
            >
              <i
                class="pi pi-globe text-slate-900 font-bold"
                style="font-size: 1rem"
              ></i>
              <span>
                {{ removeParentheses(activeCaptionLang) }}
              </span>
              <i
                :class="[
                  'pi',
                  isCaptionsLangsDropOpen ? 'pi-chevron-up' : 'pi-chevron-down',
                  'text-[#061B44] font-bold',
                ]"
                style="font-size: 0.75rem"
              ></i>
            </button>
            <div
              v-if="isCaptionsLangsDropOpen"
              class="absolute z-10 mt-1 min-w-32 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto"
              @click.stop
            >
              <hr class="border-gray-200" />
              <ul>
                <li
                  v-for="cc in availableCaptions"
                  :key="cc.language"
                  @click="toggleCaption(cc.language)"
                  class="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-blue-50 hover:text-blue-900"
                  :class="{
                    'bg-blue-50 text-blue-900':
                      activeCaptionLang === cc.language,
                  }"
                >
                  <i
                    class="pi pi-globe text-gray-500"
                    style="font-size: 1rem"
                  ></i>
                  <span>{{ removeParentheses(cc.language) }}</span>
                  <i
                    v-if="activeCaptionLang === cc.language"
                    class="pi pi-check ml-auto text-blue-600"
                    style="font-size: 1rem"
                  ></i>
                </li>
              </ul>
            </div>
          </div>
          <div class="flex flex-wrap gap-x-2 gap-y-2">
            <p
              class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
            >
              {{ $t("font") }}:
            </p>
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row items-center space-x-1 px-2 border border-slate-300 h-10 rounded-lg"
            >
              <p class="text-slate-900 font-bold text-xs 2xl:text-sm">
                {{ $t("font-size") }}
              </p>
              <button
                @click="decreaseFontCaptionsSize"
                class="text-lg text-slate-900 font-bold border-slate-700 px-4 rounded-lg"
              >
                <
              </button>
              <p class="text-base font-semibold text-slate-900">
                {{ fontSizePercentCaptions }}%
              </p>
              <button
                @click="increaseCaptionsFontSize"
                class="text-lg text-slate-900 font-bold border-slate-700 px-4 rounded-lg flex items-center justify-center"
              >
                >
              </button>
            </div>
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              @click="showFontFamilyListCaptions"
              class="flex flex-row items-center cursor-pointer space-x-1 px-2 border border-slate-300 h-10 rounded-lg"
            >
              <p class="text-slate-900 font-bold text-xs 2xl:text-sm">
                {{ $t("font") }}
              </p>
              <button
                class="flex justify-start items-center h-8 bg-white border-slate-700 rounded-lg w-min px-4"
              >
                <p class="text-slate-900 font-semibold text-xs">
                  {{ cutLongText(fontFamilyCaptions, 17) }}
                </p>
              </button>
            </div>
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row items-center space-x-1 px-2 border border-slate-300 h-10 rounded-lg"
            >
              <p class="text-slate-900 font-bold text-xs 2xl:text-sm">
                {{ $t("font-color") }}
              </p>
              <div
                class="border-slate-700 rounded-lg flex items-center justify-center px-4 py-1"
              >
                <color-picker
                  v-model:pureColor="pickedColorCaptions"
                  format="hex"
                  shape="circle"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-wrap gap-x-2 gap-y-2">
            <p
              class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
            >
              {{ $t("caption") }}:
            </p>
            <div
              class="flex flex-row items-center space-x-1 px-2 border border-slate-300 h-10 rounded-lg"
            >
              <p class="text-slate-900 font-bold text-xs 2xl:text-sm">
                {{ $t("background-color") }}
              </p>
              <div></div>
              <div
                class="border-slate-700 rounded-lg flex items-center justify-center px-4 py-1"
              >
                <color-picker
                  v-model:pureColor="pickedBackgroundColor"
                  format="hex"
                  shape="circle"
                />
              </div>
            </div>
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row items-center space-x-1 px-2 border border-slate-300 h-10 rounded-lg"
            >
              <p class="text-[#061B44] font-bold text-xs 2xl:text-sm">
                {{ $t("transparent-background") }}
              </p>
              <label class="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  v-model="useCaptionBackground"
                  class="sr-only peer"
                />
                <div
                  class="w-10 h-6 bg-gray-400 rounded-full peer-focus:ring-subDark peer-checked:bg-subDark peer-checked:after:translate-x-full peer-checked:after:border-gray-500 after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all focus:outline-none"
                ></div>
              </label>
            </div>
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row items-center space-x-1 px-2 border border-slate-300 h-10 rounded-lg"
            >
              <p class="text-slate-900 font-bold text-xs 2xl:text-sm">
                {{ $t("show-captions-cc") }}
              </p>
              <label class="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  v-model="isCaptionOn"
                  class="sr-only peer"
                />
                <div
                  class="w-10 h-6 bg-gray-400 rounded-full peer-focus:ring-subDark peer-checked:bg-subDark peer-checked:after:translate-x-full peer-checked:after:border-gray-500 after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all focus:outline-none"
                ></div>
              </label>
            </div>
          </div>
          <div class="flex flex-wrap gap-x-2 gap-y-2">
            <p
              class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
            >
              {{ $t("dubbing") }}:
            </p>
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="flex flex-row items-center cursor-pointer space-x-1 px-2 border border-slate-300 h-10 rounded-lg relative"
            >
              <p class="text-slate-900 font-bold text-xs 2xl:text-sm">
                {{ $t("caption-dubbing") }}
              </p>
              <label class="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  :checked="dubbingEnabled"
                  @change="handleDubbingToggle"
                  class="sr-only peer"
                />
                <div
                  class="w-10 h-6 bg-gray-400 rounded-full peer-focus:ring-green-500 peer-checked:bg-green-500 peer-checked:after:translate-x-full peer-checked:after:border-green-500 after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all focus:outline-none"
                ></div>
              </label>
              <!-- <div
              class="text-white text-xs absolute -mt-10 font-semibold bg-red-500 rounded-md px-2"
            >
              {{ $t('beta') }}
            </div> -->
            </div>
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              @click="() => toggleCachedDubbingPop(true)"
              class="flex flex-row items-center cursor-pointer space-x-1 px-2 border border-slate-300 h-10 rounded-lg relative"
            >
              <p class="text-slate-900 font-bold text-xs 2xl:text-sm">
                {{ $t("view-captions-and-dubbing") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- texts panel -->
      <div
        v-if="showTextTab"
        class="bg-gray-50 border-[1.5px] rounded-xl w-full xl:w-[45%] h-auto p-2 flex flex-col items-start space-y-2 justify-start"
      >
        <div
          v-if="!editingTexts && showSavedText"
          class="flex flex-row items-center justify-start space-x-1"
        >
          <svg
            width="24"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            fill="#061B44"
          >
            <path
              d="M2.305,11.235a1,1,0,0,1,1.414.024l3.206,3.319L14.3,7.289A1,1,0,0,1,15.7,8.711l-8.091,8a1,1,0,0,1-.7.289H6.9a1,1,0,0,1-.708-.3L2.281,12.649A1,1,0,0,1,2.305,11.235ZM20.3,7.289l-7.372,7.289-.263-.273a1,1,0,1,0-1.438,1.39l.966,1a1,1,0,0,0,.708.3h.011a1,1,0,0,0,.7-.289l8.091-8A1,1,0,0,0,20.3,7.289Z"
            ></path>
          </svg>
          <p class="pb-2 text-[#061B44] font-medium text-sm h-6 lg:text-base">
            {{ $t("saved") }}
          </p>
        </div>
        <div
          v-else-if="editingTexts"
          class="flex flex-row items-center justify-center space-x-1"
        >
          <p class="pb-2 text-[#061B44] font-medium text-sm h-6 lg:text-base">
            {{ t("saving") }}
          </p>
        </div>
        <!-- text containers -->
        <div
          id="textPanel"
          class="flex flex-col justify-between pt-1 xl:space-y-2 w-full"
        >
          <!-- original text container -->
          <div class="flex flex-col items-start container w-full space-y-1">
            <div
              class="flex flex-row items-center justify-start space-x-2 bg-gray-200 px-1 h-10 rounded-md w-full"
            >
              <button
                @click="toggleShowOrinialSummarized(false)"
                :class="{
                  'bg-white text-subDark': !showOriginalSummarized,
                  'bg-gray-200 text-gray-500': showOriginalSummarized,
                }"
                class="font-normal text-sm md:text-xl w-full md:min-w-44 border-[1px] rounded-md py-[2px] px-2 flex items-center justify-center"
              >
                <p>{{ $t("source-text") }}</p>
              </button>
              <button
                @click="toggleShowOrinialSummarized(true)"
                :class="{
                  'bg-white text-subDark': showOriginalSummarized,
                  'bg-gray-200 text-gray-500': !showOriginalSummarized,
                }"
                class="font-normal text-sm md:text-xl w-full md:min-w-44 border-[1px] rounded-md py-[2px] px-2 flex items-center justify-center"
              >
                <p>{{ $t("summarized-text") }}</p>
              </button>
            </div>
            <!-- text to speech panel -->
            <div
              class="bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-start"
            >
              <div
                id="ttsPanel"
                class="rounded-xl w-full h-auto flex flex-col items-start justify-start my-1 space-y-2"
              >
                <!-- <div
                  :class="{ 'pl-1': locale === 'ar' }"
                  class="flex flex-row items-center"
                >
                  <svg
                    width="24"
                    height="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 23l-9.309-6h-5.691v-10h5.691l9.309-6v22zm-9-15.009v8.018l8 5.157v-18.332l-8 5.157zm14.228-4.219c2.327 1.989 3.772 4.942 3.772 8.229 0 3.288-1.445 6.241-3.77 8.229l-.708-.708c2.136-1.791 3.478-4.501 3.478-7.522s-1.342-5.731-3.478-7.522l.706-.706zm-2.929 2.929c1.521 1.257 2.476 3.167 2.476 5.299 0 2.132-.955 4.042-2.476 5.299l-.706-.706c1.331-1.063 2.182-2.729 2.182-4.591 0-1.863-.851-3.529-2.184-4.593l.708-.708zm-12.299 1.299h-4v8h4v-8z"
                    />
                  </svg>
                </div> -->
                <div class="flex flex-wrap gap-x-2 gap-y-2">
                  <p
                    class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
                  >
                    {{ t("voice-over") }}:
                  </p>
                  <div
                    class="flex flex-row border p-2 border-slate-700 rounded-md h-10"
                  >
                    <div
                      :class="{ 'space-x-reverse': locale === 'ar' }"
                      class="flex flex-row items-center justify-center space-x-2 px-2"
                    >
                      <input
                        id="none-checkbox"
                        type="checkbox"
                        value="none"
                        @change="selectOnlyThis($event)"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                      />
                      <label
                        for="none-checkbox"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >{{ $t("none") }}</label
                      >
                    </div>
                    <div
                      :class="{ 'space-x-reverse': locale === 'ar' }"
                      class="flex flex-row items-center justify-center space-x-2 px-2"
                    >
                      <input
                        id="female-checkbox"
                        type="checkbox"
                        value="female"
                        @change="selectOnlyThis($event)"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                      />
                      <img
                        src="../../../assets/images/youtube/female.svg"
                        alt=""
                        class="w-3"
                      />
                      <label
                        for="female-checkbox"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >{{ $t("female") }}</label
                      >
                    </div>
                    <div
                      :class="{ 'space-x-reverse': locale === 'ar' }"
                      class="flex flex-row items-center justify-center space-x-2 px-2"
                    >
                      <input
                        id="male-checkbox"
                        type="checkbox"
                        value="male"
                        @change="selectOnlyThis($event)"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                      />
                      <img
                        src="../../../assets/images/youtube/male.svg"
                        alt=""
                        class="w-3"
                      />
                      <label
                        for="male-checkbox"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >{{ $t("male") }}</label
                      >
                    </div>
                  </div>
                  <button
                    @click="() => speakText(false)"
                    :class="{ 'opacity-40': showOriginalSummarized }"
                    class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
                  >
                    <div
                      v-if="
                        isPlaying &&
                        !isAudioLoading &&
                        playOriginalAudio &&
                        !playTranslationAudio
                      "
                    >
                      <svg
                        width="24"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M2 2h20v20h-20z" />
                      </svg>
                    </div>
                    <div
                      v-else-if="
                        isAudioLoading &&
                        playOriginalAudio &&
                        !playTranslationAudio
                      "
                    >
                      <svg
                        width="20"
                        height="20"
                        aria-hidden="true"
                        class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                    <div v-else>
                      <svg
                        width="24"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 17v-10l9 5.146-9 4.854z"
                        />
                      </svg>
                    </div>
                    <div class="px-1 lg:hidden"></div>
                    <p
                      :class="{ 'pr-2': locale === 'ar' }"
                      class="font-semibold text-xs lg:text-sm"
                    >
                      {{ $t("play") }}
                    </p>
                  </button>
                  <div
                    class="flex flex-row border md:p-2 border-slate-700 rounded-md h-10 items-center"
                  >
                    <p
                      class="ms-2 text-nowrap text-xs md:text-sm font-medium text-gray-900"
                    >
                      {{ $t("playback-speed") }}
                    </p>
                    <p
                      class="w-7 text-xs text-end font-bold text-blue-600 px-1"
                    >
                      {{ playbackSpeed }}x
                    </p>
                    <input
                      type="range"
                      min="0.5"
                      max="2"
                      step="0.25"
                      v-model="playbackSpeed"
                      list="speed-markers"
                      class="ms-2 w-36 md:w-44 h-6 accent-blue-600"
                      @input="setPlaybackSpeed(playbackSpeed)"
                    />
                  </div>
                  <audio
                    ref="audioElement"
                    controls
                    :class="{ 'opacity-70 pointer-events-none': !audioContent }"
                    class="h-10"
                  >
                    <source ref="audioSource" src="" type="audio/mpeg" />
                  </audio>
                </div>
                <!-- <button
                  @click="() => downloadAudioFile(false)"
                  :class="{ 'opacity-40': showOriginalSummarized }"
                  class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
                >
                  <div v-if="isAudioDownloading && playOriginalAudio">
                    <svg
                      width="20"
                      height="20"
                      aria-hidden="true"
                      class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  </div>
                  <div v-else>
                    <svg
                      width="24"
                      height="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.5 8h1v7.826l2.5-3.076.753.665-3.753 4.585-3.737-4.559.737-.677 2.5 3.064v-7.828zm7 12h-13c-2.481 0-4.5-2.019-4.5-4.5 0-2.178 1.555-4.038 3.698-4.424l.779-.14.043-.79c.185-3.447 3.031-6.146 6.48-6.146 3.449 0 6.295 2.699 6.479 6.146l.043.79.78.14c2.142.386 3.698 2.246 3.698 4.424 0 2.481-2.019 4.5-4.5 4.5m.979-9.908c-.212-3.951-3.473-7.092-7.479-7.092s-7.267 3.141-7.479 7.092c-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408"
                      />
                    </svg>
                  </div>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("download-audio") }}
                  </p>
                </button> -->
                <div class="flex flex-wrap gap-x-2 gap-y-2">
                  <p
                    class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
                  >
                    {{ $t("summary") }}:
                  </p>
                  <button
                    @click="summarizeText(true)"
                    class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
                  >
                    <svg
                      v-if="summarizingOriginalText"
                      aria-hidden="true"
                      class="inline w-4 text-gray-200 animate-spin fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    <img
                      v-else
                      src="../../../assets/icons/robot.svg"
                      alt=""
                      class="h-6 text-black fill-black"
                    />
                    <p
                      :class="{ 'pr-2': locale === 'ar' }"
                      class="text-[#061B44] font-semibold text-xs lg:text-sm"
                    >
                      {{ $t("summarize") }}
                    </p>
                  </button>
                  <div class="flex flex-row items-center space-x-1">
                    <div class="flex flex-col items-center w-[150px] h-10">
                      <div class="flex justify-between w-full mb-1">
                        <span class="text-sm font-medium text-gray-700">{{
                          $t("short")
                        }}</span>
                        <span class="text-sm font-medium text-gray-700">{{
                          $t("long")
                        }}</span>
                      </div>
                      <input
                        type="range"
                        v-model="origineTokenValue"
                        :min="minTokens"
                        :max="maxTokens"
                        step="50"
                        class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                        :style="originSliderStyle"
                      />
                    </div>
                    <div class="mt-3 text-sm font-medium text-gray-700">
                      ~ {{ originalSummPercentage }}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="container bg-[#F5F4F4] rounded-xl w-full h-auto p-2 flex flex-col items-center justify-center border border-slate-300"
            >
              <div
                v-if="summarizingOriginalText"
                class="flex items-center justify-center w-full h-40"
              >
                <div class="flex flex-col items-center space-y-3">
                  <svg
                    aria-hidden="true"
                    class="w-8 h-8 text-gray-200 animate-spin fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <p class="text-slate-700 font-medium text-sm">{{ $t("summarizing") }}</p>
                </div>
              </div>
              <textarea
                v-else-if="showOriginalSummarized"
                ref="originalSummarizedTextAreaRef"
                v-model="originalSummarizedText"
                rows="10"
                :style="{ color: pickedColor, fontFamily: fontFamily }"
                :class="computedOriginalClass"
                :dir="ys.originalLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
                class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
              ></textarea>
              <textarea
                v-else
                ref="originalTextAreaRef"
                v-model="originalText"
                rows="10"
                :style="{ color: pickedColor, fontFamily: fontFamily }"
                :class="computedOriginalClass"
                :dir="ys.originalLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
                class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
              ></textarea>
              <div
                :class="{ 'lg:space-x-reverse': locale === 'ar' }"
                class="container flex flex-col lg:flex-row items-center justify-start space-y-2 lg:space-y-0 py-2 lg:space-x-2"
              >
                <button
                  @click="toggleDownloadTypes"
                  class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <img
                    src="../../../assets/images/audio/04.png"
                    alt=""
                    class="h-3 lg:h-5"
                  />
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("download") }}
                  </p>
                </button>
                <button
                  @click="copyText(true)"
                  class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <img
                    src="../../../assets/images/audio/05.png"
                    alt=""
                    class="h-3 lg:h-5"
                  />
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("Copy") }}
                  </p>
                </button>
                <button
                  @click="openFindReplace('text', 'original')"
                  :class="{ 'opacity-40': showOriginalSummarized }"
                  class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <svg
                    width="20"
                    height="20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="text-[#061B44]"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("find-replace") }}
                  </p>
                </button>
                <button
                  @click="resetText(true)"
                  :class="{ 'opacity-40': showOriginalSummarized }"
                  class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <svg
                    width="24"
                    height="24"
                    xmlns="http://www.w3.org/2000/svg"
                    class="fill-[#061B44]"
                  >
                    <path
                      d="M12 0c-3.31 0-6.291 1.353-8.459 3.522l-2.48-2.48-1.061 7.341 7.437-.966-2.489-2.488c1.808-1.808 4.299-2.929 7.052-2.929 5.514 0 10 4.486 10 10s-4.486 10-10 10c-3.872 0-7.229-2.216-8.89-5.443l-1.717 1.046c2.012 3.803 6.005 6.397 10.607 6.397 6.627 0 12-5.373 12-12s-5.373-12-12-12z"
                    />
                  </svg>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("discard-changes") }}
                  </p>
                </button>
              </div>
            </div>
          </div>
          <!-- divider -->
          <div class="px-4"></div>
          <!-- translated text container -->
          <div class="flex flex-col items-center container w-full space-y-1">
            <div class="flex flex-row justify-between w-full">
              <div
                class="flex flex-row items-center justify-start space-x-2 bg-gray-200 px-1 h-10 rounded-md w-full"
              >
                <button
                  @click="toggleShowTranslatedSummarized(false)"
                  :class="{
                    'bg-white text-subDark': !showTranslatedSummarized,
                    'bg-gray-200 text-gray-500': showTranslatedSummarized,
                  }"
                  class="font-normal text-sm md:text-xl w-full md:min-w-44 border-[1px] rounded-md py-[2px] px-2 flex items-center justify-center"
                >
                  {{ $t("translated-text-0") }}
                </button>
                <button
                  @click="toggleShowTranslatedSummarized(true)"
                  :class="{
                    'bg-white text-subDark': showTranslatedSummarized,
                    'bg-gray-200 text-gray-500': !showTranslatedSummarized,
                  }"
                  class="font-normal text-sm md:text-xl w-full md:min-w-44 border-[1px] rounded-md py-[2px] px-2 flex items-center justify-center"
                >
                  <p>{{ $t("summarized-text") }}</p>
                </button>
              </div>
              <div
                v-if="showTranslatedSummarized"
                class="relative inline-block"
              >
                <button
                  @click="
                    isSummarizedLangsDropOpen = !isSummarizedLangsDropOpen
                  "
                  class="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <i
                    class="pi pi-globe text-gray-500"
                    style="font-size: 1rem"
                  ></i>
                  <span>
                    {{ getLanguageName(selectedSummarizedLanguage) }}
                  </span>
                  <i
                    :class="[
                      'pi',
                      isSummarizedLangsDropOpen
                        ? 'pi-chevron-up'
                        : 'pi-chevron-down',
                      'text-gray-500',
                    ]"
                    style="font-size: 0.75rem"
                  ></i>
                </button>
                <div
                  v-if="isSummarizedLangsDropOpen"
                  class="absolute z-10 mt-1 min-w-32 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto"
                  @click.stop
                >
                  <hr class="border-gray-200" />
                  <ul>
                    <li
                      v-for="language in translatedSummarizesLangs"
                      :key="language"
                      @click="selectTranslatedSummaryLang(language)"
                      class="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-blue-50 hover:text-blue-900"
                      :class="{
                        'bg-blue-50 text-blue-900':
                          selectedSummarizedLanguage === language.id,
                      }"
                    >
                      <i
                        class="pi pi-globe text-gray-500"
                        style="font-size: 1rem"
                      ></i>
                      <span>{{ getLanguageName(language) }}</span>
                      <i
                        v-if="selectedSummarizedLanguage === language"
                        class="pi pi-check ml-auto text-blue-600"
                        style="font-size: 1rem"
                      ></i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- text to speech panel -->
            <div
              class="bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-start"
            >
              <div
                id="ttsPanel"
                class="rounded-xl w-full h-auto flex flex-col items-start justify-start my-1 space-y-2"
              >
                <div class="flex flex-wrap gap-x-2 gap-y-2">
                  <p
                    class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
                  >
                    {{ t("voice-over") }}:
                  </p>
                <div
                  class="flex flex-row border p-2 border-slate-700 rounded-md h-10"
                >
                    <div
                      :class="{ 'space-x-reverse': locale === 'ar' }"
                      class="flex flex-row items-center justify-center space-x-2 px-2"
                    >
                      <input
                        id="none-checkbox-translated"
                        type="checkbox"
                        value="none"
                        @change="selectOnlyThisTranslation($event)"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                      />
                      <label
                        for="none-checkbox-translated"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >{{ $t("none") }}</label
                      >
                    </div>
                    <div
                      :class="{ 'space-x-reverse': locale === 'ar' }"
                      class="flex flex-row items-center justify-center space-x-2 px-2"
                    >
                      <input
                        id="female-checkbox-translated"
                        type="checkbox"
                        value="female"
                        @change="selectOnlyThisTranslation($event)"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                      />
                      <img
                        src="../../../assets/images/youtube/female.svg"
                        alt=""
                        class="w-3"
                      />
                      <label
                        for="female-checkbox-translated"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >{{ $t("female") }}</label
                      >
                    </div>
                    <div
                      :class="{ 'space-x-reverse': locale === 'ar' }"
                      class="flex flex-row items-center justify-center space-x-2 px-2"
                    >
                      <input
                        id="male-checkbox-translated"
                        type="checkbox"
                        value="male"
                        @change="selectOnlyThisTranslation($event)"
                        class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                      />
                      <img
                        src="../../../assets/images/youtube/male.svg"
                        alt=""
                        class="w-3"
                      />
                      <label
                        for="male-checkbox-translated"
                        class="ms-2 text-sm font-medium text-gray-900"
                        >{{ $t("male") }}</label
                      >
                    </div>
                  </div>
                  <button
                    @click="() => speakText(true)"
                    :class="{ 'opacity-40': showTranslatedSummarized }"
                    class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
                  >
                    <div
                      v-if="
                        isPlaying &&
                        !isAudioLoading &&
                        playTranslationAudio &&
                        !playOriginalAudio
                      "
                    >
                      <!-- stop -->
                      <svg
                        width="24"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M2 2h20v20h-20z" />
                      </svg>
                    </div>
                    <div
                      v-else-if="
                        isAudioLoading &&
                        playTranslationAudio &&
                        !playOriginalAudio
                      "
                    >
                      <!-- loading -->
                      <svg
                        width="20"
                        height="20"
                        aria-hidden="true"
                        class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                    <div v-else>
                      <!-- start -->
                      <svg
                        width="24"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-3 17v-10l9 5.146-9 4.854z"
                        />
                      </svg>
                    </div>
                    <div class="px-1 lg:hidden"></div>
                    <p
                      :class="{ 'pr-2': locale === 'ar' }"
                      class="font-semibold text-xs lg:text-sm"
                    >
                      {{ $t("play") }}
                    </p>
                  </button>
                  <div
                    class="flex flex-row border md:p-2 border-slate-700 rounded-md h-10 items-center"
                  >
                    <p
                      class="ms-2 text-nowrap text-xs md:text-sm font-medium text-gray-900"
                    >
                      {{ $t("playback-speed") }}
                    </p>
                    <p
                      class="w-7 text-xs text-end font-bold text-blue-600 px-1"
                    >
                      {{ playbackSpeedTranslated }}x
                    </p>
                    <input
                      type="range"
                      min="0.5"
                      max="2"
                      step="0.25"
                      v-model="playbackSpeedTranslated"
                      list="speed-markers"
                      class="ms-2 w-36 md:w-44 h-6 accent-blue-600"
                      @input="
                        setPlaybackSpeedTranslated(playbackSpeedTranslated)
                      "
                    />
                  </div>
                  <audio
                    ref="audioElementTranslated"
                    controls
                    :class="{ 'opacity-70 pointer-events-none': !audioContentTranslated }"
                    class="h-10"
                  >
                    <source
                      ref="audioSourceTranslated"
                      src=""
                      type="audio/mpeg"
                    />
                  </audio>
                </div>
                <!-- <button
                  @click="() => downloadAudioFile(true)"
                  :class="{ 'opacity-40': showTranslatedSummarized }"
                  class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
                >
                  <div v-if="isAudioDownloading && !playOriginalAudio">
                    <svg
                      width="20"
                      height="20"
                      aria-hidden="true"
                      class="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                  </div>
                  <div v-else>
                    <svg
                      width="24"
                      height="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.5 8h1v7.826l2.5-3.076.753.665-3.753 4.585-3.737-4.559.737-.677 2.5 3.064v-7.828zm7 12h-13c-2.481 0-4.5-2.019-4.5-4.5 0-2.178 1.555-4.038 3.698-4.424l.779-.14.043-.79c.185-3.447 3.031-6.146 6.48-6.146 3.449 0 6.295 2.699 6.479 6.146l.043.79.78.14c2.142.386 3.698 2.246 3.698 4.424 0 2.481-2.019 4.5-4.5 4.5m.979-9.908c-.212-3.951-3.473-7.092-7.479-7.092s-7.267 3.141-7.479 7.092c-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408"
                      />
                    </svg>
                  </div>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("download-audio") }}
                  </p>
                </button> -->
                <div class="flex flex-wrap gap-x-2 gap-y-2">
                  <p
                    class="text-slate-900 font-bold text-xs 2xl:text-sm w-20 lg:w-32 flex items-center px-2"
                  >
                    {{ $t("summary") }}:
                  </p>
                  <button
                    @click="summarizeText(false)"
                    class="flex justify-center items-center space-x-2 lg:space-x-4 px-4 border border-slate-700 h-10 rounded-lg"
                  >
                    <svg
                      v-if="summarizingTranslatedText"
                      aria-hidden="true"
                      class="inline w-4 text-gray-200 animate-spin fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    <img
                      v-else
                      src="../../../assets/icons/robot.svg"
                      alt=""
                      class="h-6 text-black fill-black"
                    />
                    <p
                      :class="{ 'pr-2': locale === 'ar' }"
                      class="text-[#061B44] font-semibold text-xs lg:text-sm"
                    >
                      {{ $t("summarize") }}
                    </p>
                  </button>
                  <div class="flex flex-row space-x-1 items-center">
                    <div class="flex flex-col items-center w-[150px] h-10">
                      <div class="flex justify-between w-full mb-1">
                        <span class="text-sm font-medium text-gray-700">{{
                          $t("short")
                        }}</span>
                        <span class="text-sm font-medium text-gray-700">{{
                          $t("long")
                        }}</span>
                      </div>
                      <input
                        type="range"
                        v-model="translatedTokenValue"
                        :min="minTokens"
                        :max="maxTokens"
                        step="50"
                        class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                        :style="translatedSliderStyle"
                      />
                    </div>
                    <div class="mt-3 text-sm font-medium text-gray-700">
                      ~ {{ translatedSummPercentage }}%
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="container bg-[#F5F4F4] rounded-xl w-full h-auto p-2 flex flex-col items-center justify-center border border-slate-300"
            >
              <div
                v-if="summarizingTranslatedText"
                class="flex items-center justify-center w-full h-40"
              >
                <div class="flex flex-col items-center space-y-3">
                  <svg
                    aria-hidden="true"
                    class="w-8 h-8 text-gray-200 animate-spin fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <p class="text-slate-700 font-medium text-sm">{{ $t("summarizing") }}</p>
                </div>
              </div>
              <textarea
                v-else-if="showTranslatedSummarized"
                ref="translatedSummarizedTextAreaRef"
                v-model="translatedSummarizedText"
                rows="10"
                :style="{ color: pickedColor, fontFamily: fontFamily }"
                :class="computedTranslatedClass"
                :dir="ys.translationLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
                class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
              ></textarea>
              <textarea
                v-else
                ref="translatedTextAreaRef"
                v-model="translatedText"
                rows="10"
                :style="{ color: pickedColor, fontFamily: fontFamily }"
                :class="computedTranslatedClass"
                :dir="ys.translationLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
                class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
              ></textarea>
              <div
                :class="{ 'lg:space-x-reverse': locale === 'ar' }"
                class="container flex flex-col lg:flex-row items-center justify-start py-2 space-y-2 lg:space-y-0 lg:space-x-2"
              >
                <button
                  @click="toggleDownloadTranslatedTypes"
                  class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <img
                    src="../../../assets/images/audio/04.png"
                    alt=""
                    class="h-3 lg:h-5"
                  />
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("download") }}
                  </p>
                </button>
                <button
                  @click="copyText(false)"
                  class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <img
                    src="../../../assets/images/audio/05.png"
                    alt=""
                    class="h-3 lg:h-5"
                  />
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("Copy") }}
                  </p>
                </button>
                <button
                  @click="openFindReplace('text', 'translated')"
                  :class="{ 'opacity-40': showTranslatedSummarized }"
                  class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <svg
                    width="20"
                    height="20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="text-[#061B44]"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("find-replace") }}
                  </p>
                </button>
                <button
                  @click="resetText(false)"
                  :class="{ 'opacity-40': showTranslatedSummarized }"
                  class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <svg
                    width="24"
                    height="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 0c-3.31 0-6.291 1.353-8.459 3.522l-2.48-2.48-1.061 7.341 7.437-.966-2.489-2.488c1.808-1.808 4.299-2.929 7.052-2.929 5.514 0 10 4.486 10 10s-4.486 10-10 10c-3.872 0-7.229-2.216-8.89-5.443l-1.717 1.046c2.012 3.803 6.005 6.397 10.607 6.397 6.627 0 12-5.373 12-12s-5.373-12-12-12z"
                    />
                  </svg>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("discard-changes") }}
                  </p>
                </button>
              </div>
              <div
                v-if="showDownloadTypes"
                class="overlay z-50"
                @click="toggleDownloadTypes"
              >
                <div class="overlay-content relative" @click.stop>
                  <p
                    class="text-[#061B44] font-semibold text-xl pb-4 text-center"
                  >
                    {{ $t("download-as") }}
                  </p>
                  <ul
                    class="py-1 h-75vh grid grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto pb-4"
                  >
                    <li
                      v-for="type in supportFileDownloadTypes"
                      :key="type"
                      class="flex flex-row space-x-2 hover:bg-[#4867C8] hover:bg-opacity-10"
                    >
                      <a
                        @click="downloadFileAs(type, true)"
                        class="block px-4 py-2 text-gray-800 font-semibold cursor-pointer border border-slate-700 rounded-md w-full text-center"
                      >
                        {{ type }}
                      </a>
                    </li>
                  </ul>
                  <div
                    @click="showDownloadTypes = false"
                    class="absolute right-0 top-0 bg-[#4867C8] p-2 rounded-bl-2xl rounded-tr-md cursor-pointer"
                  >
                    <img
                      src="../../../assets/images/audio/close.svg"
                      class="w-6 fill-white text-white invert"
                    />
                  </div>
                </div>
              </div>
              <div
                v-if="showDownloadTranslatedTypes"
                class="overlay z-50"
                @click="toggleDownloadTranslatedTypes"
              >
                <div class="overlay-content relative" @click.stop>
                  <p
                    class="text-[#061B44] font-semibold text-xl pb-4 text-center"
                  >
                    {{ $t("download-as") }}
                  </p>
                  <ul
                    class="py-1 h-75vh grid grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto pb-4"
                  >
                    <li
                      v-for="type in supportFileDownloadTypes"
                      :key="type"
                      class="flex flex-row space-x-2 hover:bg-[#4867C8] hover:bg-opacity-10"
                    >
                      <div v-if="type === 'json'"></div>
                      <a
                        v-else
                        @click="downloadFileAs(type, false)"
                        class="block px-4 py-2 text-gray-800 font-semibold cursor-pointer border border-slate-700 rounded-md w-full text-center"
                      >
                        {{ type }}
                      </a>
                    </li>
                  </ul>
                  <div
                    @click="showDownloadTranslatedTypes = false"
                    class="absolute right-0 top-0 bg-[#4867C8] p-2 rounded-bl-2xl rounded-tr-md cursor-pointer"
                  >
                    <img
                      src="../../../assets/images/audio/close.svg"
                      class="w-6 fill-white text-white invert"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- font handler -->
        <div
          class="bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-center"
        >
          <p class="text-[#061B44] font-semibold text-xl">
            {{ $t("font-settings") }}
          </p>
          <div
            id="fontPanel"
            class="flex flex-wrap w-full items-center gap-x-2 space-y-4 lg:space-y-0"
          >
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="w-full flex flex-wrap justify-start gap-x-2 md:gap-x-0 gap-y-2 md:gap-y-0 md:space-x-1 lg:space-x-4 rounded-full"
            >
              <div
                :class="{ 'space-x-reverse': locale === 'ar' }"
                class="flex flex-row items-center space-x-2 border border-slate-500 px-4 h-10 rounded-lg"
              >
                <p class="text-[#061B44] font-bold text-xs lg:text-sm">
                  {{ $t("font-size") }}
                </p>
                <button
                  @click="decreaseFontSize"
                  class="text-xl text-[#061B44] font-bold"
                >
                  <
                </button>
                <p class="text-lg font-semibold text-[#061B44]">
                  {{ fontSizePercent }}%
                </p>
                <button
                  @click="increaseFontSize"
                  class="text-xl text-[#061B44] font-bold"
                >
                  >
                </button>
              </div>
              <div
                :class="{ 'space-x-reverse': locale === 'ar' }"
                class="flex flex-row items-center space-x-2 border border-slate-500 px-4 h-10 rounded-lg"
              >
                <p class="text-[#061B44] font-bold text-xs lg:text-sm">
                  {{ $t("font-color") }}
                </p>
                <color-picker
                  v-model:pureColor="pickedColor"
                  format="hex"
                  shape="circle"
                />
              </div>
              <button
                @click="showFontFamilyList"
                class="flex flex-row justify-center items-center border border-slate-500 px-4 h-10 rounded-lg"
              >
                <p
                  :class="{ 'pl-2': locale === 'ar', 'pr-2': locale !== 'ar' }"
                  class="text-[#061B44] font-bold text-xs lg:text-sm"
                >
                  {{ $t("font") }}
                </p>
                <p class="text-[#061B44] font-medium text-xs lg:text-sm">
                  {{ fontFamily }}
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- captions panel -->
      <div
        v-if="!showTextTab"
        class="bg-gray-50 border-[1.5px] rounded-xl w-full xl:w-[45%] h-auto p-2 flex flex-col items-start space-y-2 justify-start"
      >
        <div
          v-if="!editingSubtitles && showSubtitlesText"
          class="flex flex-row items-center justify-start space-x-1"
        >
          <svg
            width="24"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            fill="#061B44"
          >
            <path
              d="M2.305,11.235a1,1,0,0,1,1.414.024l3.206,3.319L14.3,7.289A1,1,0,0,1,15.7,8.711l-8.091,8a1,1,0,0,1-.7.289H6.9a1,1,0,0,1-.708-.3L2.281,12.649A1,1,0,0,1,2.305,11.235ZM20.3,7.289l-7.372,7.289-.263-.273a1,1,0,1,0-1.438,1.39l.966,1a1,1,0,0,0,.708.3h.011a1,1,0,0,0,.7-.289l8.091-8A1,1,0,0,0,20.3,7.289Z"
            ></path>
          </svg>
          <p class="pb-2 text-[#061B44] font-medium text-sm h-6 lg:text-base">
            {{ $t("saved") }}
          </p>
        </div>
        <div
          v-else-if="editingSubtitles"
          class="flex flex-row items-center justify-center space-x-1"
        >
          <p class="pb-2 text-[#061B44] font-medium text-sm h-6 lg:text-base">
            {{ $t("saving") }}
          </p>
        </div>
        <!-- edit caption panel -->
        <div
          id="srtPanel"
          class="flex flex-col md:flex-row xl:flex-col justify-between pt-1 space-y-2 md:space-y-0 xl:space-y-2 w-full"
        >
          <!-- original text container -->
          <div
            class="flex flex-col items-start md:items-center container w-full space-y-1"
          >
            <p class="text-[#061B44] font-semibold text-sm md:text-xl">
              {{ $t("source-captions") }}
            </p>
            <!-- Speaker Diarization Display - Toggleable panel -->
            <div
              v-if="!showTextTab && parsedCaptionsWithSpeakers.length > 0"
              class="bg-white rounded-xl w-full max-w-full h-auto p-4 mb-4 flex flex-col items-start justify-center border-2 border-blue-300 shadow-md"
              style="width: 100%;"
            >
              <!-- Header with Toggle Button and Color Controls -->
              <div class="flex items-center justify-between w-full mb-3">
                <p class="text-[#061B44] font-semibold text-xs md:text-sm">
                  {{ $t("speaker-diarization") || "Multi-Speaker Detection" }}
                </p>
                <div class="flex items-center space-x-2" :class="{ 'space-x-reverse': locale === 'ar' }">
                  <!-- Color Controls Button -->
                  <button
                    @click.stop="showSpeakerColorControls = !showSpeakerColorControls"
                    class="px-2 py-1 rounded-md text-xs font-medium transition-colors bg-gray-100 text-gray-700 hover:bg-gray-200"
                    :title="$t('speaker-color-settings') || 'Speaker Color Settings'"
                  >
                    🎨
                  </button>
                  <!-- Show/Hide Toggle Button -->
                  <button
                    @click="showSpeakerDiarization = !showSpeakerDiarization"
                    class="flex items-center space-x-1 px-3 py-1.5 rounded-md text-xs font-medium transition-colors"
                    :class="[
                      showSpeakerDiarization 
                        ? 'bg-blue-100 text-blue-700 hover:bg-blue-200' 
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200',
                      { 'space-x-reverse': locale === 'ar' }
                    ]"
                  >
                    <svg 
                      v-if="showSpeakerDiarization"
                      class="w-4 h-4" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                    </svg>
                    <svg 
                      v-else
                      class="w-4 h-4" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                    <span>{{ showSpeakerDiarization ? ($t("hide") || "Hide") : ($t("show") || "Show") }}</span>
                  </button>
                </div>
              </div>
              <!-- Color Controls Panel -->
              <div 
                v-show="showSpeakerColorControls && showSpeakerDiarization" 
                class="w-full mb-3 p-3 bg-gray-50 rounded-lg border border-gray-200"
              >
                <p class="text-xs font-semibold text-gray-700 mb-2">
                  {{ $t("speaker-color-settings") || "Speaker Color Settings" }}
                </p>
                <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2">
                  <div 
                    v-for="speakerNum in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" 
                    :key="speakerNum"
                    class="flex items-center space-x-2"
                    :class="{ 'space-x-reverse': locale === 'ar' }"
                  >
                    <label class="text-xs text-gray-600 min-w-[60px]">
                      {{ $t("speaker") || "Speaker" }} {{ speakerNum }}:
                    </label>
                    <input
                      type="color"
                      :value="getSpeakerColor(speakerNum)"
                      @input="updateSpeakerColor(speakerNum, ($event.target as HTMLInputElement).value)"
                      class="w-8 h-8 rounded border border-gray-300 cursor-pointer"
                    />
                  </div>
                </div>
              </div>
              <!-- Collapsible Content -->
              <div v-show="showSpeakerDiarization" class="w-full">
                <p v-if="!parsedCaptionsWithSpeakers.some(c => c.speakerTag !== null && c.speakerTag !== undefined || (c.words && c.words.some(w => w.speakerTag !== null && w.speakerTag !== undefined)))" 
                   class="text-amber-600 text-xs mb-2 italic bg-amber-50 p-2 rounded">
                  ⚠️ {{ $t("speaker-info-not-available") }}
                </p>
                <div class="w-full max-h-96 overflow-y-auto space-y-2">
                <div
                  v-for="(caption, index) in parsedCaptionsWithSpeakers"
                  :key="index"
                  class="caption-item p-2 rounded-md border-l-4 transition-all duration-200 hover:shadow-sm"
                  :style="{
                    borderLeftColor: getSpeakerColor(caption.speakerTag),
                    backgroundColor: `${getSpeakerColor(caption.speakerTag)}10`
                  }"
                >
                  <div v-if="caption.words && caption.words.length > 0" class="flex flex-wrap gap-1">
                    <span
                      v-for="(wordData, wordIdx) in caption.words"
                      :key="wordIdx"
                      :style="{
                        color: getSpeakerColor(wordData.speakerTag),
                        fontWeight: wordData.speakerTag ? 500 : 400
                      }"
                      class="inline-block"
                    >
                      {{ wordData.word }}
                    </span>
                  </div>
                  <div v-else class="text-slate-700">
                    {{ caption.text }}
                  </div>
                  <div class="flex items-center justify-between mt-2 text-xs">
                    <span 
                      v-if="caption.speakerTag !== null && caption.speakerTag !== undefined" 
                      class="font-bold px-3 py-1.5 rounded-md shadow-sm" 
                      :style="{ 
                        color: 'white',
                        backgroundColor: getSpeakerColor(caption.speakerTag)
                      }"
                    >
                      🎤 {{ $t("speaker") || "Speaker" }} {{ caption.speakerTag }}
                    </span>
                    <span v-else-if="caption.words && caption.words.some(w => w.speakerTag !== null && w.speakerTag !== undefined)" 
                      class="font-bold px-3 py-1.5 rounded-md text-white bg-gradient-to-r from-purple-500 to-pink-500 shadow-sm">
                      🎤 {{ $t("multiple-speakers") || "Multiple Speakers" }}
                    </span>
                    <span v-else class="font-medium px-3 py-1.5 rounded-md text-slate-600 bg-slate-200">
                      🎤 {{ $t("speaker-unknown") || "Speaker Unknown" }}
                    </span>
                    <span class="text-slate-500 ml-2">
                      {{ caption.start }} → {{ caption.dur }}
                    </span>
                  </div>
                </div>
                </div>
              </div>
            </div>
            <div
              class="container bg-[#F5F4F4] rounded-xl w-full h-auto p-2 flex flex-col items-center justify-center border border-slate-300"
            >
              <textarea
                ref="webvttTextArea1"
                @scroll="syncScroll('webvttTextArea2')"
                v-model="originalVideoSubtitle"
                rows="10"
                :style="{ color: pickedColor, fontFamily: fontFamily }"
                :class="computedOriginalClass"
                :dir="ys.originalLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
                class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
              ></textarea>
              <div
                :class="{ 'lg:space-x-reverse': locale === 'ar' }"
                class="container flex flex-col lg:flex-row items-center justify-start py-4 space-y-2 lg:space-y-0 lg:space-x-2"
              >
                <button
                  @click="toggleDownloadSRTTypes"
                  class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <img
                    src="../../../assets/images/audio/04.png"
                    alt=""
                    class="h-3 lg:h-5"
                  />
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("download") }}
                  </p>
                </button>
                <button
                  @click="copySubtitle(true)"
                  class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <img
                    src="../../../assets/images/audio/05.png"
                    alt=""
                    class="h-3 lg:h-5"
                  />
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("Copy") }}
                  </p>
                </button>
                <button
                  @click="openFindReplace('caption', 'original')"
                  class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <svg
                    width="20"
                    height="20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="text-[#061B44]"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("find-replace") }}
                  </p>
                </button>
                <button
                  @click="resetSubtitle(true)"
                  class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <svg
                    width="24"
                    height="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 0c-3.31 0-6.291 1.353-8.459 3.522l-2.48-2.48-1.061 7.341 7.437-.966-2.489-2.488c1.808-1.808 4.299-2.929 7.052-2.929 5.514 0 10 4.486 10 10s-4.486 10-10 10c-3.872 0-7.229-2.216-8.89-5.443l-1.717 1.046c2.012 3.803 6.005 6.397 10.607 6.397 6.627 0 12-5.373 12-12s-5.373-12-12-12z"
                    />
                  </svg>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("discard-changes") }}
                  </p>
                </button>
              </div>
            </div>
          </div>
          <!-- divider -->
          <div class="px-4"></div>
          <!-- translated text container -->
          <div
            class="flex flex-col items-start md:items-center container w-full space-y-1"
          >
            <p class="text-[#061B44] font-semibold text-sm md:text-xl">
              {{ $t("translated-captions") }}
            </p>
            <!-- Speaker Diarization Display for Translated Captions - Toggleable panel -->
            <div
              v-if="!showTextTab && translatedCaptionsWithSpeakers.length > 0"
              class="bg-white rounded-xl w-full max-w-full h-auto p-4 mb-4 flex flex-col items-start justify-center border-2 border-blue-300 shadow-md"
              style="width: 100%;"
            >
              <div class="flex items-center justify-between w-full mb-3">
                <p class="text-[#061B44] font-semibold text-xs md:text-sm">
                  {{ $t("speaker-diarization") || "Multi-Speaker Detection" }} ({{ $t("translated") || "Translated" }})
                </p>
                <div class="flex items-center space-x-2" :class="{ 'space-x-reverse': locale === 'ar' }">
                  <button
                    @click.stop="showTranslatedSpeakerColorControls = !showTranslatedSpeakerColorControls"
                    class="px-2 py-1 rounded-md text-xs font-medium transition-colors bg-gray-100 text-gray-700 hover:bg-gray-200"
                    :title="$t('speaker-color-settings') || 'Speaker Color Settings'"
                  >
                    🎨
                  </button>
                  <button
                    @click="showTranslatedSpeakerDiarization = !showTranslatedSpeakerDiarization"
                    class="flex items-center space-x-1 px-3 py-1.5 rounded-md text-xs font-medium transition-colors"
                    :class="[
                      showTranslatedSpeakerDiarization 
                        ? 'bg-blue-100 text-blue-700 hover:bg-blue-200' 
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200',
                      { 'space-x-reverse': locale === 'ar' }
                    ]"
                  >
                    <svg 
                      v-if="showTranslatedSpeakerDiarization"
                      class="w-4 h-4" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                    </svg>
                    <svg 
                      v-else
                      class="w-4 h-4" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                    <span>{{ showTranslatedSpeakerDiarization ? ($t("hide") || "Hide") : ($t("show") || "Show") }}</span>
                  </button>
                </div>
              </div>
              <div 
                v-show="showTranslatedSpeakerColorControls && showTranslatedSpeakerDiarization" 
                class="w-full mb-3 p-3 bg-gray-50 rounded-lg border border-gray-200"
              >
                <p class="text-xs font-semibold text-gray-700 mb-2">
                  {{ $t("speaker-color-settings") || "Speaker Color Settings" }}
                </p>
                <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2">
                  <div 
                    v-for="speakerNum in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" 
                    :key="speakerNum"
                    class="flex items-center space-x-2"
                    :class="{ 'space-x-reverse': locale === 'ar' }"
                  >
                    <label class="text-xs text-gray-600 min-w-[60px]">
                      {{ $t("speaker") || "Speaker" }} {{ speakerNum }}:
                    </label>
                    <input
                      type="color"
                      :value="getSpeakerColor(speakerNum)"
                      @input="updateSpeakerColor(speakerNum, ($event.target as HTMLInputElement).value)"
                      class="w-8 h-8 rounded border border-gray-300 cursor-pointer"
                    />
                  </div>
                </div>
              </div>
              <div v-show="showTranslatedSpeakerDiarization" class="w-full">
                <p v-if="!translatedCaptionsWithSpeakers.some(c => c.speakerTag !== null && c.speakerTag !== undefined || (c.words && c.words.some(w => w.speakerTag !== null && w.speakerTag !== undefined)))" 
                   class="text-amber-600 text-xs mb-2 italic bg-amber-50 p-2 rounded">
                  ⚠️ {{ $t("speaker-info-not-available") }}
                </p>
                <div class="w-full max-h-96 overflow-y-auto space-y-2">
                <div
                  v-for="(caption, index) in translatedCaptionsWithSpeakers"
                  :key="index"
                  class="caption-item p-2 rounded-md border-l-4 transition-all duration-200 hover:shadow-sm"
                  :style="{
                    borderLeftColor: getSpeakerColor(caption.speakerTag),
                    backgroundColor: `${getSpeakerColor(caption.speakerTag)}10`
                  }"
                >
                  <div v-if="caption.words && caption.words.length > 0" class="flex flex-wrap gap-1">
                    <span
                      v-for="(wordData, wordIdx) in caption.words"
                      :key="wordIdx"
                      :style="{
                        color: getSpeakerColor(wordData.speakerTag),
                        fontWeight: wordData.speakerTag ? 500 : 400
                      }"
                      class="inline-block"
                    >
                      {{ wordData.word }}
                    </span>
                  </div>
                  <div v-else class="text-slate-700">
                    {{ caption.text }}
                  </div>
                  <div class="flex items-center justify-between mt-2 text-xs">
                    <span 
                      v-if="caption.speakerTag !== null && caption.speakerTag !== undefined" 
                      class="font-bold px-3 py-1.5 rounded-md shadow-sm" 
                      :style="{ 
                        color: 'white',
                        backgroundColor: getSpeakerColor(caption.speakerTag)
                      }"
                    >
                      🎤 {{ $t("speaker") || "Speaker" }} {{ caption.speakerTag }}
                    </span>
                    <span v-else-if="caption.words && caption.words.some(w => w.speakerTag !== null && w.speakerTag !== undefined)" 
                      class="font-bold px-3 py-1.5 rounded-md text-white bg-gradient-to-r from-purple-500 to-pink-500 shadow-sm">
                      🎤 {{ $t("multiple-speakers") || "Multiple Speakers" }}
                    </span>
                    <span v-else class="font-medium px-3 py-1.5 rounded-md text-slate-600 bg-slate-200">
                      🎤 {{ $t("speaker-unknown") || "Speaker Unknown" }}
                    </span>
                    <span class="text-slate-500 ml-2">
                      {{ caption.start }} → {{ caption.dur }}
                    </span>
                  </div>
                </div>
                </div>
              </div>
            </div>
            <div
              class="container bg-[#F5F4F4] rounded-xl w-full h-auto p-2 flex flex-col items-center justify-center border border-slate-300"
            >
              <textarea
                ref="webvttTextArea2"
                @scroll="syncScroll('webvttTextArea1')"
                v-model="translatedVideoSubtitle"
                rows="10"
                v-html="translatedVideoSubtitle"
                :style="{ color: pickedColor, fontFamily: fontFamily }"
                :class="computedTranslatedClass"
                :dir="ys.translationLanguage.langCode === 'ar' ? 'rtl' : 'ltr'"
                class="block lg:p-2.5 w-full h-40 font-medium lg:font-semibold outline-none text-slate-900 bg-[#F5F4F4] rounded-lg shadow-sm"
              ></textarea>
              <div
                :class="{ 'lg:space-x-reverse': locale === 'ar' }"
                class="container flex flex-col lg:flex-row items-center justify-start py-4 space-y-2 lg:space-y-0 lg:space-x-2"
              >
                <button
                  @click="toggleDownloadTranslatedSRTTypes"
                  class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <img
                    src="../../../assets/images/audio/04.png"
                    alt=""
                    class="h-3 lg:h-5"
                  />
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("download") }}
                  </p>
                </button>
                <button
                  @click="copySubtitle(false)"
                  class="w-full lg:w-[55%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <img
                    src="../../../assets/images/audio/05.png"
                    alt=""
                    class="h-3 lg:h-5"
                  />
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("Copy") }}
                  </p>
                </button>
                <button
                  @click="openFindReplace('caption', 'translated')"
                  class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <svg
                    width="20"
                    height="20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    class="text-[#061B44]"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("find-replace") }}
                  </p>
                </button>
                <button
                  @click="resetSubtitle(false)"
                  class="w-full lg:w-[45%] flex justify-center items-center lg:space-x-4 bg-white border border-slate-900 h-10 p-2 lg:p-3 rounded-lg"
                >
                  <svg
                    width="24"
                    height="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 0c-3.31 0-6.291 1.353-8.459 3.522l-2.48-2.48-1.061 7.341 7.437-.966-2.489-2.488c1.808-1.808 4.299-2.929 7.052-2.929 5.514 0 10 4.486 10 10s-4.486 10-10 10c-3.872 0-7.229-2.216-8.89-5.443l-1.717 1.046c2.012 3.803 6.005 6.397 10.607 6.397 6.627 0 12-5.373 12-12s-5.373-12-12-12z"
                    />
                  </svg>
                  <div class="px-1 lg:hidden"></div>
                  <p
                    :class="{ 'pr-2': locale === 'ar' }"
                    class="text-[#061B44] font-semibold text-xs lg:text-sm"
                  >
                    {{ $t("discard-changes") }}
                  </p>
                </button>
              </div>
              <div
                v-if="showDownloadSRTTypes"
                class="overlay z-50"
                @click="toggleDownloadSRTTypes"
              >
                <div class="overlay-content relative" @click.stop>
                  <p
                    class="text-[#061B44] font-semibold text-xl pb-4 text-center"
                  >
                    {{ $t("download-as") }}
                  </p>
                  <ul
                    class="py-1 h-75vh grid grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto pb-4"
                  >
                    <li
                      v-for="type in supportFileDownloadSRTTypes"
                      :key="type"
                      class="flex flex-row space-x-2 hover:bg-[#4867C8] hover:bg-opacity-10"
                    >
                      <a
                        @click="downloadFileAs(type, true)"
                        class="block px-4 py-2 text-gray-800 font-semibold cursor-pointer border border-slate-700 rounded-md w-full text-center"
                      >
                        {{ type }}
                      </a>
                    </li>
                  </ul>
                  <div
                    @click="showDownloadSRTTypes = false"
                    class="absolute right-0 top-0 bg-[#4867C8] p-2 rounded-bl-2xl rounded-tr-md cursor-pointer"
                  >
                    <img
                      src="../../../assets/images/audio/close.svg"
                      class="w-6 fill-white text-white invert"
                    />
                  </div>
                  <div
                    @click.stop
                    class="flex flex-row items-center justify-start space-x-2 py-2"
                  >
                    <input
                      id="ignoreTiming-checkbox"
                      type="checkbox"
                      v-model="downloadOnlySentencesSrt"
                      @change="handleIgnoreSrtCheckbox($event)"
                      class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                    <label class="text-base font-medium text-gray-900">{{
                      $t("Download_only_the_extracted_s")
                    }}</label>
                  </div>
                </div>
              </div>
              <div
                v-if="showDownloadTranslatedSRTTypes"
                class="overlay z-50"
                @click="toggleDownloadTranslatedSRTTypes"
              >
                <div class="overlay-content relative" @click.stop>
                  <p
                    class="text-[#061B44] font-semibold text-xl pb-4 text-center"
                  >
                    {{ $t("download-as") }}
                  </p>
                  <ul
                    class="py-1 h-75vh grid grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto pb-4"
                  >
                    <li
                      v-for="type in supportFileDownloadSRTTypes"
                      :key="type"
                      class="flex flex-row space-x-2 hover:bg-[#4867C8] hover:bg-opacity-10"
                    >
                      <a
                        @click="downloadFileAs(type, false)"
                        class="block px-4 py-2 text-gray-800 font-semibold cursor-pointer border border-slate-700 rounded-md w-full text-center"
                      >
                        {{ type }}
                      </a>
                    </li>
                  </ul>
                  <div
                    @click="showDownloadTranslatedSRTTypes = false"
                    class="absolute right-0 top-0 bg-[#4867C8] p-2 rounded-bl-2xl rounded-tr-md cursor-pointer"
                  >
                    <img
                      src="../../../assets/images/audio/close.svg"
                      class="w-6 fill-white text-white invert"
                    />
                  </div>
                  <div
                    @click.stop
                    class="flex flex-row items-center justify-start space-x-2 py-2"
                  >
                    <input
                      id="ignoreTimingTr-checkbox"
                      type="checkbox"
                      v-model="downloadOnlySentencesSrt"
                      @change="handleIgnoreSrtCheckbox($event)"
                      class="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                    />
                    <label class="text-base font-medium text-gray-900">{{
                      $t("Download_only_the_extracted_s")
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- font handler -->
        <div
          class="container bg-gray-50 border-[1.5px] rounded-xl w-full h-auto p-2 flex flex-col items-start space-y-2 justify-center"
        >
          <p class="text-[#061B44] font-semibold text-xl">
            {{ $t("font-settings") }}
          </p>
          <div
            id="fontPanel"
            class="flex flex-col lg:flex-row w-full items-center justify-center space-y-4 lg:space-y-0 lg:space-x-4"
          >
            <div
              :class="{ 'space-x-reverse': locale === 'ar' }"
              class="w-full flex flex-wrap justify-start gap-x-2 md:gap-x-0 gap-y-2 md:gap-y-0 md:space-x-1 lg:space-x-4 rounded-full"
            >
              <div
                :class="{ 'space-x-reverse': locale === 'ar' }"
                class="flex flex-row items-center space-x-2 border border-slate-500 px-4 h-10 rounded-lg"
              >
                <p class="text-[#061B44] font-bold text-xs lg:text-sm">
                  {{ $t("font-size") }}
                </p>
                <button
                  @click="decreaseFontSize"
                  class="text-xl text-[#061B44] font-bold"
                >
                  <
                </button>
                <p class="text-lg font-semibold text-[#061B44]">
                  {{ fontSizePercent }}%
                </p>
                <button
                  @click="increaseFontSize"
                  class="text-xl text-[#061B44] font-bold"
                >
                  >
                </button>
              </div>
              <div
                :class="{ 'space-x-reverse': locale === 'ar' }"
                class="flex flex-row items-center space-x-2 border border-slate-500 px-4 h-10 rounded-lg"
              >
                <p class="text-[#061B44] font-bold text-xs lg:text-sm">
                  {{ $t("font-color") }}
                </p>
                <color-picker
                  v-model:pureColor="pickedColor"
                  format="hex"
                  shape="circle"
                />
              </div>
              <button
                @click="showFontFamilyList"
                class="flex flex-row justify-center items-center border border-slate-500 px-4 h-10 rounded-lg"
              >
                <p
                  :class="{ 'pl-2': locale === 'ar', 'pr-2': locale !== 'ar' }"
                  class="text-[#061B44] font-bold text-xs lg:text-sm"
                >
                  {{ $t("font") }}
                </p>
                <p class="text-[#061B44] font-medium text-xs lg:text-sm">
                  {{ fontFamily }}
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- caption panel -->
    <!--  <div class="flex flex-row items-center justify-center w-full pt-10">
      <div v-for="cc in availableCaptions" :key="cc.language" class="px-2">
        <button
          @click="toggleCaption(cc.language)"
          :class="{
            'bg-green-500 ': activeCaptionLang === cc.language && isCaptionOn,
            'bg-slate-400': activeCaptionLang != cc.language || !isCaptionOn,
          }"
          class="text-white font-semibold text-lg border-2 py-1 px-4 rounded-lg"
        >
          {{ cc.language }}
        </button>
      </div>
      <button
        @click="toggleCaption(false)"
        class="flex flex-col space-x-2 items-center h-12 px-4"
      >
        <svg
          width="36"
          height="36"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          :class="{
            'fill-green-600': isCaptionOn,
            'fill-slate-600': !isCaptionOn,
          }"
        >
          <path
            d="M14.748 11.191c.03.473.084.909.158 1.298-.998.183-1.038-.801-.158-1.298zm-7.461.274h1.708l-.856-2.451-.852 2.451zm16.713-.458c0 6.052-6.732 11.705-15.968 9.458-1.678 1.027-5.377 2.065-7.978 2.535.971-1.912 2.048-4.538 1.993-6.368-1.308-1.562-2.047-3.575-2.047-5.625 0-5.781 5.662-10.007 12-10.007 6.299 0 12 4.195 12 10.007zm-12.749 2.993l-2.47-6.5h-1.302l-2.479 6.5h1.392l.535-1.5h2.438l.537 1.5h1.349zm6.837-3.937c.062-.243.1-.426.135-.605l-1.1-.214-.109.5c-.371-.054-.767-.061-1.166-.021.009-.268.025-.531.049-.784h1.229v-1.042h-1.081c.054-.265.099-.424.144-.575l-1.075-.322c-.079.263-.145.521-.211.897h-1.226v1.042h1.092c-.028.337-.046.686-.051 1.038-1.206.443-1.718 1.288-1.718 2.053 0 .904.714 1.7 1.842 1.598 1.401-.128 2.337-1.186 2.885-2.487.567.327.805.876.591 1.385-.197.471-.78.919-1.892.896v1.121c1.234.019 2.448-.45 2.925-1.583.464-1.107-.067-2.317-1.263-2.897zm-2.144 1.841c.293-.303.522-.688.697-1.075-.253-.021-.522-.014-.79.021.017.378.048.731.093 1.054z"
          />
        </svg>
      </button>
    </div> -->
    <!-- video infos -->
    <div
      class="w-[50%] mx-auto hidden flex-col space-y-4 bg-white border border-slate-700 rounded-lg p-1 py-4"
    >
      <button
        @click="showNewProcessPop = true"
        class="w-full flex justify-center items-center space-x-1 2xl:space-x-4 bg-white h-8 py-1 rounded-full"
      >
        <svg
          clip-rule="evenodd"
          fill-rule="evenodd"
          stroke-linejoin="round"
          class="h-6 w-6 fill-[#061B44]"
        >
          <path
            d="m3.508 6.726c1.765-2.836 4.911-4.726 8.495-4.726 5.518 0 9.997 4.48 9.997 9.997 0 5.519-4.479 9.999-9.997 9.999-5.245 0-9.553-4.048-9.966-9.188-.024-.302.189-.811.749-.811.391 0 .715.3.747.69.351 4.369 4.012 7.809 8.47 7.809 4.69 0 8.497-3.808 8.497-8.499 0-4.689-3.807-8.497-8.497-8.497-3.037 0-5.704 1.597-7.206 3.995l1.991.005c.414 0 .75.336.75.75s-.336.75-.75.75h-4.033c-.414 0-.75-.336-.75-.75v-4.049c0-.414.336-.75.75-.75s.75.335.75.75z"
            fill-rule="nonzero"
          />
        </svg>
        <p class="text-[#061B44] font-semibold text-xs 2xl:text-sm">
          {{ $t("Start_a_New_Transcription") }}
        </p>
      </button>
      <div
        :class="{ 'lg:space-x-reverse': locale === 'ar' }"
        class="w-full flex justify-start items-center space-x-1 2xl:space-x-4 h-8 bg-white px-2 rounded-full"
      >
        <p class="text-[#061B44] font-bold text-xs 2xl:text-sm">
          {{ $t("font-size") }}
        </p>
        <button
          @click="decreaseFontSize"
          class="text-lg 2xl:text-xl text-[#061B44] font-bold"
        >
          <
        </button>
        <p class="2xl:text-lg font-semibold text-[#061B44]">
          {{ fontSizePercent }}%
        </p>
        <button
          @click="increaseFontSize"
          class="text-lg 2xl:text-xl text-[#061B44] font-bold"
        >
          >
        </button>
      </div>
      <button
        @click="showFontFamilyList"
        class="flex flex-row justify-center items-center border border-slate-500 px-4 h-10 rounded-lg"
      >
        <p
          :class="{ 'pl-2': locale === 'ar', 'pr-2': locale !== 'ar' }"
          class="text-[#061B44] font-bold text-xs 2xl:text-sm"
        >
          {{ $t("font") }}
        </p>
        <p class="text-[#061B44] font-semibold text-xs 2xl:text-sm">
          {{ fontFamily }}
        </p>
      </button>
      <div
        class="flex flex-row items-center space-x-2 h-8 bg-white px-2 rounded-full"
      >
        <p class="text-[#061B44] font-bold text-xs 2xl:text-sm">
          {{ $t("font-color") }}
        </p>
        <color-picker
          v-model:pureColor="pickedColorCaptions"
          format="hex"
          shape="circle"
        />
      </div>
      <div class="flex flex-row">
        <button
          @click="toggleCaption(false)"
          class="flex flex-col items-center justify-center space-x-2 h-6 px-4 text-sm 2xl:text-base font-semibold rounded-md text-white"
          :class="{
            'bg-green-600': isCaptionOn,
            'bg-slate-600': !isCaptionOn,
          }"
        >
          <p>CC</p>
        </button>
        <div class="flex flex-col items-start justify-start">
          <div
            v-for="cc in availableCaptions"
            :key="cc.language"
            class="px-2 mt-0"
          >
            <label class="flex items-center h-6">
              <input
                type="checkbox"
                :checked="activeCaptionLang === cc.language && isCaptionOn"
                @change="toggleCaption(cc.language)"
                class="mr-2"
              />
              <span class="font-semibold text-sm 2xl:text-base uppercase">
                {{ removeParentheses(cc.language) }}
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="isCachedDubbingShowed"
    class="overlay z-50 bg-black bg-opacity-50 flex items-center justify-center"
    @click.self="() => toggleCachedDubbingPop(false)"
  >
    <div
      class="bg-white rounded-lg w-full max-w-[700px] h-[80vh] flex flex-col"
    >
      <div class="px-5 py-3 border-b flex flex-row justify-between">
        <h2 class="text-lg font-semibold">
          {{ $t("stored-captions-and-dubbings") }}
        </h2>
        <button
          class="text-slate-800"
          @click="() => toggleCachedDubbingPop(false)"
        >
          <svg
            class="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M18 6L6 18" />
            <path d="M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="h-full overflow-y-auto mt-4">
        <div
          v-if="storedCaptions.length === 0"
          class="flex flex-col items-center justify-center h-[60vh] text-gray-500"
        >
          <svg
            class="w-16 h-16 mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
            />
          </svg>
          <p class="text-lg font-medium">{{ $t("no-captions-available") }}</p>
          <p class="text-sm">{{ $t("start-by-generating-captions") }}</p>
        </div>
        <div v-else class="px-4">
          <div class="mb-4 flex justify-end">
            <button
              class="inline-flex items-center px-4 h-7 bg-blue-600 text-white text-sm rounded"
              :disabled="isDownloadingAudio"
              @click="downloadFinalDubbing"
            >
              <svg
                class="h-4 w-4 mr-2"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              {{
                isDownloadingAudio
                  ? $t("processing")
                  : finalDubbingDownloadSucceeded
                    ? $t("final-dubbing-download-done")
                    : $t("download-final-dubbing")
              }}
            </button>
          </div>
          <div
            v-for="caption in storedCaptions"
            :key="caption.id"
            class="mb-4 border rounded-lg"
          >
            <div class="p-4 pb-2">
              <div class="flex justify-between items-center">
                <h3 class="text-sm font-medium">
                  {{ $t("caption") }} {{ parseFloat(caption.id) + 1 }}
                </h3>
                <p
                  class="text-xs rounded px-2 h-7 text-center text-slate-600 flex flex-row items-center"
                >
                  {{ caption.start }} →
                  {{ caption.endTime }}
                </p>
              </div>
            </div>
            <div class="p-4 pt-0">
              <div class="space-y-4">
                <div v-if="caption.isEditing" class="space-y-2">
                  <textarea
                    v-model="caption.editedText"
                    class="w-full min-h-[60px] border rounded-md p-2 text-sm"
                  ></textarea>
                  <button
                    class="inline-flex items-center px-3 h-7 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
                    :disabled="savingCaptionId === caption.id"
                    @click="saveEditing(caption.id)"
                  >
                    <svg
                      class="h-4 w-4 mr-2"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                      />
                      <polyline points="17 21 17 13 7 13 7 21" />
                      <polyline points="7 3 7 8 15 8" />
                    </svg>
                    {{ $t("save") }}
                  </button>
                </div>
                <div v-else class="flex justify-between items-start">
                  <p class="text-sm">{{ caption.text }}</p>
                  <!-- <button
                    class="p-2 hover:bg-gray-100 rounded"
                    @click="startEditing(caption.id)"
                  >
                    <svg
                      class="h-4 w-4"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                      />
                      <path
                        d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                      />
                    </svg>
                  </button> -->
                </div>
                <div class="border-t my-2"></div>
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-2">
                    <template v-if="caption.base64">
                      <button
                        class="inline-flex items-center px-3 h-7 bg-blue-300 text-white rounded text-sm"
                        @click="togglePlayDubbingAudio(caption.id)"
                      >
                        <svg
                          v-if="caption.isPlaying"
                          class="h-4 w-4"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <rect x="6" y="4" width="4" height="16" />
                          <rect x="14" y="4" width="4" height="16" />
                        </svg>
                        <svg
                          v-else
                          class="h-4 w-4"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                        >
                          <polygon points="5 3 19 12 5 21 5 3" />
                        </svg>
                      </button>
                    </template>
                    <span
                      v-else
                      class="text-xs border border-gray-300 rounded px-2 h-7 flex flex-col items-center justify-center"
                    >
                      {{ $t("no-audio") }}
                    </span>
                  </div>
                  <button
                    v-if="caption.base64"
                    class="inline-flex items-center px-3 h-7 bg-orange-400 text-white text-sm rounded"
                    @click="deleteAudio(caption.id, caption.audioStartTime)"
                  >
                    <svg
                      class="h-4 w-4 mr-2"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path d="M3 6h18" />
                      <path
                        d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                      />
                    </svg>
                    {{ $t("delete-audio") }}
                  </button>
                  <button
                    v-else
                    class="inline-flex items-center px-3 h-7 border border-gray-300 rounded text-sm"
                    @click="requestNewAudio(caption.id)"
                  >
                    <svg
                      class="h-4 w-4 mr-2"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"
                      />
                      <path d="M21 3v5h-5" />
                      <path
                        d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"
                      />
                      <path d="M8 16H3v5" />
                    </svg>
                    {{ $t("generate-audio") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- video player -->
  <div class="w-full py-8 hidden">
    <video
      id="videoPlayer"
      controls
      class="video-js vjs-16-9"
      crossorigin="anonymous"
    ></video>
  </div>
  <div v-if="showNewProcessPop" class="overlay z-50">
    <div
      class="overlay-content flex flex-col w-[85%] md:w-[75%] lg:w-[55%] xl:w-[45%] 2xl:w-[30%] space-y-4"
      @click.stop
    >
      <i
        class="pi pi-exclamation-circle text-[#061B44] text-4xl text-center"
      ></i>
      <p class="text-[#061B44] font-semibold text-lg pb-2 text-center">
        {{ $t("Starting_a_new_transcription_will") }}
      </p>
      <div class="flex flex-row space-x-2 justify-between">
        <button
          @click="showNewProcessPop = false"
          class="bg-white border border-slate-900 rounded-md text-slate-900 text-lg font-bold py-1 px-8 h-10"
        >
          {{ $t("No_Stay_on_Page") }}
        </button>
        <button
          @click="
            () => {
              showNewProcessPop = false;
              processNewVideoOrder();
            }
          "
          class="bg-subDark border border-slate-900 rounded-md text-white text-lg font-bold py-1 px-8 h-10"
        >
          {{ $t("Yes_Start_New") }}
        </button>
      </div>
    </div>
  </div>
  <!-- user consume solde -->
  <div
    v-if="showPaymentModal"
    class="overlay bg-gray-600 bg-opacity-50 flex items-center justify-center z-50"
  >
    <div class="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
      <div class="flex flex-row text-xl items-center mb-4 space-x-1">
        <i class="pi pi-credit-card text-blue-500 text-center"></i>
        <h3 class="font-semibold">{{ $t("complete-your-translation") }}</h3>
      </div>
      <p class="text-gray-700 mb-6">{{ modalMessage }}</p>
      <div class="flex justify-end space-x-4">
        <button
          @click="handleModalResponse(false)"
          class="mt-4 bg-white text-slate-900 border-slate-400 border-[1px] h-9 py-1 px-10 rounded-md font-normal text-base"
        >
          {{ t("cancel") }}
        </button>
        <button
          @click="handleModalResponse(true)"
          class="mt-4 text-white bg-slate-900 h-9 py-1 px-10 rounded-md font-normal text-base flex items-center space-x-2"
        >
          <p>{{ $t("continue") }}</p>
        </button>
      </div>
    </div>
  </div>

  <!-- Hint Popup Modal -->
  <div v-if="showHintPopup" class="overlay z-50" @click="showHintPopup = false">
    <div
      class="overlay-content flex flex-col items-center min-w-[90%] sm:min-w-[80%] md:min-w-[60%] lg:min-w-[50%] max-w-[600px] max-h-[80vh]"
      @click.stop
    >
      <div
        :class="{ 'space-x-reverse': locale === 'ar' }"
        class="flex flex-row space-x-4 w-full items-center justify-between h-10 py-6 border-b-2 border-slate-300 bg-white"
      >
        <div class="flex items-center space-x-2" :class="{ 'space-x-reverse': locale === 'ar' }">
          <div class="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center">
            <i class="pi pi-lightbulb text-slate-900" style="font-size: 1.25rem"></i>
          </div>
          <h3 class="text-slate-900 font-semibold text-lg md:text-xl px-3 py-1.5 rounded-lg bg-white">
            {{ $t("add-context-hint") || "Add Context Hint" }}
          </h3>
        </div>
        <button
          @click="showHintPopup = false"
          class="bg-white border-2 border-slate-300 rounded-lg text-slate-900 text-sm md:text-base font-semibold py-1.5 px-4 h-10 hover:bg-slate-50 transition-colors"
        >
          <i class="pi pi-times" style="font-size: 1rem"></i>
        </button>
      </div>
      
      <div class="w-full p-4 overflow-y-auto flex-1 bg-white">
        <!-- Info Section -->
        <div class="bg-slate-50 border border-slate-300 rounded-lg p-4 mb-4">
          <div class="flex items-start space-x-2" :class="{ 'space-x-reverse': locale === 'ar' }">
            <i class="pi pi-info-circle text-slate-900 mt-0.5" style="font-size: 1.25rem"></i>
            <div>
              <p class="text-sm font-semibold text-slate-900 mb-1 px-2 py-1 rounded bg-slate-50">
                {{ $t("what-is-context-hint") || "What is a Context Hint?" }}
              </p>
              <p class="text-xs text-slate-700 px-2 py-1 rounded bg-slate-50">
                {{ $t("context-hint-description") || "Provide brief context about your text's topic (e.g., Medical document, Legal contract) to get more accurate, domain-specific translations." }}
              </p>
            </div>
          </div>
        </div>

        <!-- Hint Input -->
        <div class="mb-4">
          <label class="block text-sm font-semibold text-slate-900 mb-2">
            {{ $t("context-hint-label") || "What is this text about?" }}
          </label>
          <textarea
            v-model="translationHint"
            @input="handleHintInput"
            :placeholder="$t('context-hint-placeholder') || 'e.g., Medical document, Legal contract, Technical manual, Business presentation, Marketing content, etc.'"
            class="w-full px-4 py-3 text-sm border-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 resize-none transition-all bg-white"
            :class="{
              'border-slate-900 bg-slate-50': translationHint && translationHint.trim().length > 0,
              'border-slate-300': !translationHint || translationHint.trim().length === 0
            }"
            rows="3"
            maxlength="200"
          ></textarea>
          
          <!-- Character Counter with Visual Feedback -->
          <div
            :class="{ 'text-right': locale === 'ar' }"
            class="flex items-center justify-between mt-2"
          >
            <div class="flex items-center space-x-2">
              <div
                class="flex-1 h-1.5 bg-slate-200 rounded-full overflow-hidden"
                :class="{ 'max-w-24': locale !== 'ar' }"
              >
                <div
                  class="h-full rounded-full transition-all duration-300"
                  :class="{
                    'bg-slate-900': translationHint.length < 150,
                    'bg-subOrange': translationHint.length >= 150 && translationHint.length < 190,
                    'bg-subOrange opacity-90': translationHint.length >= 190
                  }"
                  :style="{ width: `${(translationHint.length / 200) * 100}%` }"
                ></div>
              </div>
              <span
                class="text-xs font-medium"
                  :class="{
                    'text-slate-900': translationHint.length < 150,
                    'text-subOrange': translationHint.length >= 150
                  }"
              >
                {{ translationHint.length }}/200
              </span>
            </div>
            <button
              v-if="translationHint && translationHint.trim().length > 0"
              @click="translationHint = ''"
              class="flex items-center space-x-1 text-xs text-subOrange hover:text-subOrange hover:opacity-80 font-medium transition-colors"
              :class="{ 'space-x-reverse': locale === 'ar' }"
            >
              <i class="pi pi-times" style="font-size: 0.75rem"></i>
              <span>{{ $t("clear-hint") || "Clear" }}</span>
            </button>
          </div>
        </div>
        
        <!-- Quick Example Buttons -->
        <div class="mb-4">
          <p class="text-xs text-slate-700 mb-2 font-medium">
            {{ $t("quick-examples") || "Quick examples:" }}
          </p>
          <div
            class="flex flex-wrap gap-2"
            :class="{ 'flex-row-reverse': locale === 'ar' }"
          >
            <button
              v-for="example in contextExamples"
              :key="example"
              @click="translationHint = example"
              class="px-3 py-1.5 text-xs bg-white hover:bg-slate-900 hover:text-white text-slate-900 rounded-full transition-all duration-200 border border-slate-300 hover:border-slate-900 font-medium"
            >
              {{ example }}
            </button>
          </div>
        </div>

        <!-- Active Hint Status -->
        <div
          v-if="translationHint && translationHint.trim().length > 0"
          class="bg-slate-50 border-2 border-slate-900 rounded-lg p-3 flex items-center space-x-2 mb-4"
          :class="{ 'space-x-reverse': locale === 'ar' }"
        >
          <i class="pi pi-check-circle text-slate-900" style="font-size: 1.25rem"></i>
          <div>
            <p class="text-sm font-semibold text-slate-900">
              {{ $t("hint-active") || "Context Hint Active" }}
            </p>
            <p class="text-xs text-slate-700">
              {{ $t("hint-will-be-used") || "This hint will be used for more accurate translations" }}
            </p>
          </div>
        </div>
      </div>
      
      <!-- Action Buttons -->
      <div
        :class="{ 'space-x-reverse': locale === 'ar' }"
        class="flex flex-row space-x-3 w-full items-center justify-end pt-4 border-t-2 border-slate-300 bg-white"
      >
        <button
          @click="showHintPopup = false"
          class="bg-white border-2 border-slate-300 rounded-lg text-slate-900 text-sm md:text-base font-semibold py-2 px-6 hover:bg-slate-50 transition-colors"
        >
          {{ $t("cancel") || "Cancel" }}
        </button>
        <button
          @click="saveHintAndClose"
          :disabled="!translationHint || translationHint.trim().length === 0"
          :class="{
            'opacity-50 cursor-not-allowed': !translationHint || translationHint.trim().length === 0,
            'bg-subDark text-white hover:bg-opacity-90': translationHint && translationHint.trim().length > 0
          }"
          class="bg-subDark text-white rounded-lg text-sm md:text-base font-semibold py-2 px-6 transition-all duration-200 hover:shadow-md"
        >
          {{ $t("save") || "Save" }}
        </button>
      </div>
    </div>
  </div>

  <!-- Find/Replace Dialog -->
  <FindReplaceDialog
    ref="findReplaceDialogRef"
    :is-open="showFindReplace"
    :show-target-selector="true"
    :initial-target="findReplaceTarget"
    @close="closeFindReplace"
    @find="(term, target) => { findReplaceTarget = target; performFind(term, target); }"
    @find-next="findNextMatch"
    @find-previous="findPreviousMatch"
    @replace="replaceCurrentMatch"
    @replace-all="replaceAllMatches"
    @target-change="(target) => { findReplaceTarget = target; if (findReplaceSearchTerm) performFind(findReplaceSearchTerm, target); }"
  />

  <!-- PDF Preview Modal -->
  <PdfPreviewModal
    :is-open="showPdfPreview"
    :text="previewText"
    :font-family="previewConfig.fontFamily"
    :font-size="previewConfig.fontSize"
    :color="previewConfig.color"
    :is-rtl="previewConfig.isRtl"
    @close="closePdfPreview"
    @export="exportPdfFromPreview"
  />

  <!-- PDF Generation Loading Indicator -->
  <div
    v-if="isPdfGenerating"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10001]"
  >
    <div class="bg-white rounded-lg p-8 flex flex-col items-center space-y-4 min-w-[300px]">
      <svg
        aria-hidden="true"
        class="w-12 h-12 text-gray-200 animate-spin fill-blue-600"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
      <p class="text-slate-700 font-medium text-lg">{{ $t("generating-pdf") || "Generating PDF..." }}</p>
      <p class="text-slate-500 font-normal text-sm">{{ $t("please-wait") || "Please wait..." }}</p>
      <button
        @click="cancelPdfGeneration"
        class="mt-4 px-4 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-md transition-colors"
      >
        {{ $t("pdf-cancel-button") || "Cancel" }}
      </button>
    </div>
  </div>

  <!-- PDF Generation Error Overlay -->
  <div
    v-if="pdfError && !isPdfGenerating"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10001]"
  >
    <div class="bg-white rounded-lg p-8 flex flex-col items-center space-y-4 min-w-[300px]">
      <svg
        class="w-12 h-12 text-red-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <p class="text-slate-700 font-medium text-lg">{{ $t("pdf-generation-failed") || "PDF Generation Failed" }}</p>
      <p class="text-slate-600 font-normal text-sm text-center">
        {{ pdfError.message }}
        <span v-if="pdfError.pageNumber" class="block mt-1">
          {{ $t("pdf-page-failed", [pdfError.pageNumber]) || `Page ${pdfError.pageNumber} failed` }}
        </span>
      </p>
      <div class="flex space-x-3 mt-2">
        <button
          @click="pdfError = null"
          class="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-md transition-colors"
        >
          {{ $t("close") || "Close" }}
        </button>
        <button
          @click="() => { const error = pdfError; pdfError = null; if (error && previewConfig.isOriginal !== undefined) { downloadAsPdfWithFormatting(previewConfig.isOriginal, previewText, previewFormatting || []); } else if (lastPdfIsOriginal !== null && lastPdfIsOriginal !== undefined) { downloadAsPdf(lastPdfIsOriginal); } }"
          class="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md transition-colors"
        >
          {{ $t("pdf-retry-button") || "Retry" }}
        </button>
      </div>
    </div>
  </div>
</template>

<style>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-height: 80vh;
  overflow-y: auto;
  z-index: 51;
}

.overlay-content.is-language-picker-overlay {
  overflow: hidden !important;
}

#ytPlayer {
  width: 100%;
  height: 100%;
  position: absolute;
}

#videoContainer {
  position: relative;
  text-align: center;
  padding-bottom: 60%;
}
.captionContainer {
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translate(-50%, 0%);
  color: white;
  text-align: center;
}
</style>

<script setup lang="ts">
import {
  computed,
  nextTick,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  ref,
  toRaw,
  watch,
} from "vue";
import {
  languages,
  Language,
  unsupportedCloudTts,
  languageCodeMappings,
} from "../../../utils/languageList";
import { CaptionModel } from "../../../utils/captionModel";
import { hasWebVttCaptions } from "../../../utils/webvtt";
import { parseTranslatedWebVttWithSpeakers } from "../../../utils/translatedCaptionSpeakers";
import {
  API_BASE_URL,
  TRANSLATE_CAPTIONS,
  TRANSCRIPT_YOUTUBE,
  TRANSLATE_TEXT,
  GETPRICES,
  GETTRANSLATEDTEXT,
  SPEAKTEXT,
  SUMMARIZETEXT,
  DUBBINGTEXT,
  TRANSLATE_TEXT_GPT,
  TRANSLATE_TEXT_BULK,
  TRANSLATE_TEXT_BULK_GPT,
  ONETIME_AUDIO_RESULT,
} from "../../../utils/appConst";
import { useAuthStore } from "../../../store/auth";
import { useRoute, useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import { useUserProfile } from "../../../store/userProfile";
import { useYoutubeStore } from "../../../store/youtubeStore";
import { useUserActivities } from "../../../store/userActivities";
import { useI18n } from "vue-i18n";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import { Document, Packer, Paragraph, TextRun } from "docx";
import { ColorPicker } from "vue3-colorpicker";
import PdfPreviewModal from "../../common/PdfPreviewModal.vue";
import { loadFontBase } from "../../../utils/loadFontBase64";
import { useCommunicationStore } from "../../../store/connectionStore";
import servicesPricing from "../../../utils/servicesPricing";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import { toBlobURL } from "@ffmpeg/util";
import { openDB, IDBPDatabase } from "idb";
import { useFontStore } from "../../../store/fontsStore";
import { loadGoogleFont } from "../../../utils/loadFont";
import { getDocxExportFontSizeHalfPoints } from "../../../utils/docxExport";
import { useUserPreference } from "../../../store/userPreferences";
import FindReplaceDialog from "../../common/FindReplaceDialog.vue";

const ys = useYoutubeStore();
const authStore = useAuthStore();
const profileStore = useUserProfile();
const activitesStore = useUserActivities();
const communicationStore = useCommunicationStore();
const prefStore = useUserPreference();
const fontStore = useFontStore();
const translateCpationUrl = `${API_BASE_URL}${TRANSLATE_CAPTIONS}`;
const transcriptYoutubeUrl = `${API_BASE_URL}${TRANSCRIPT_YOUTUBE}`;
const translateTextUrl = `${API_BASE_URL}${TRANSLATE_TEXT}`;
const translateTextGPTUrl = `${API_BASE_URL}${TRANSLATE_TEXT_GPT}`;
const translateTextBulkUrl = `${API_BASE_URL}${TRANSLATE_TEXT_BULK}`;
const translateTextBulkGPTUrl = `${API_BASE_URL}${TRANSLATE_TEXT_BULK_GPT}`;
const getPrices = `${API_BASE_URL}${GETPRICES}`;
const getTranslatedFileUrl = `${API_BASE_URL}${GETTRANSLATEDTEXT}`;
const speakTextUrl = `${API_BASE_URL}${SPEAKTEXT}`;
const summarizeTextUrl = `${API_BASE_URL}${SUMMARIZETEXT}`;
const dubbingTextUrl = `${API_BASE_URL}${DUBBINGTEXT}`;
const isFromNotification = computed(() => ys.isFromNotification);
const ffmpeg = new FFmpeg();
const filteredFonts = computed<any[]>(() => {
  return fontStore.fonts.filter((font:any) =>
    font.name.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
})
const mountPlayer = computed({
  get: () => ys.mountPlayer,
  set: (value) => (ys.mountPlayer = value),
});
const currentCaptions = computed({
  get: () => ys.currentCaptions,
  set: (value) => (ys.currentCaptions = value),
});
const originalJsonContent = computed({
  get: () => ys.originalJsonContent,
  set: (value) => (ys.originalJsonContent = value),
});
const translationLanguage = computed(() => ys.translationLanguage);
const myLanguagesList = computed(() => ys.myLanguagesList);
const originalLanguage = computed(() => ys.originalLanguage);
const isTranslationListOpened = computed({
  get: () => ys.isTranslationListOpened,
  set: (value) => (ys.isTranslationListOpened = value),
});

// Multi-language selection computed properties
const isMultiLanguageMode = computed({
  get: () => ys.isMultiLanguageMode,
  set: (value) => (ys.isMultiLanguageMode = value),
});
const selectedTargetLanguages = computed({
  get: () => ys.selectedTargetLanguages,
  set: (value) => (ys.selectedTargetLanguages = value),
});
const bulkTextTranslations = computed({
  get: () => ys.bulkTextTranslations,
  set: (value) => (ys.bulkTextTranslations = value),
});
const currentDisplayLanguage = computed({
  get: () => ys.currentDisplayLanguage,
  set: (value) => (ys.currentDisplayLanguage = value),
});
const isTargetListOpen = computed({
  get: () => ys.isTargetListOpen,
  set: (value) => (ys.isTargetListOpen = value),
});

// Computed property for languages with translations (for quick access)
const availableTranslatedLanguages = computed(() => {
  const langCodes = Object.keys(bulkTextTranslations.value);
  // Also include current translation language if it has a translation
  if (translatedText.value && translationLanguage.value?.langCode && !langCodes.includes(translationLanguage.value.langCode)) {
    langCodes.push(translationLanguage.value.langCode);
  }
  return languages.filter((lang) => langCodes.includes(lang.langCode));
});

// Find/Replace state
const showFindReplace = ref(false);
const findReplaceTarget = ref<"original" | "translated">("original");
const findReplaceMode = ref<"text" | "caption">("text");
const findReplaceDialogRef = ref<InstanceType<typeof FindReplaceDialog> | null>(null);
const findReplaceMatches = ref<number[]>([]);
const currentFindMatchIndex = ref(-1);
const findReplaceSearchTerm = ref("");
const originalTextAreaRef = ref<HTMLTextAreaElement | null>(null);
const originalSummarizedTextAreaRef = ref<HTMLTextAreaElement | null>(null);
const translatedTextAreaRef = ref<HTMLTextAreaElement | null>(null);
const translatedSummarizedTextAreaRef = ref<HTMLTextAreaElement | null>(null);

// Helper function to check if language has translation
const hasTranslation = (langCode: string): boolean => {
  // Check bulk translations first
  if (bulkTextTranslations.value[langCode]) {
    return true;
  }
  // Also check if current translation matches this language
  if (translationLanguage.value?.langCode === langCode && translatedText.value && translatedText.value.length > 0) {
    return true;
  }
  return false;
};
const pickedColor = computed({
  get: () => ys.pickedColor,
  set: (value) => (ys.pickedColor = value),
});
const showTextTab = computed({
  get: () => ys.showTextTab,
  set: (value) => (ys.showTextTab = value),
});
const pickedColorCaptions = computed({
  get: () => ys.pickedColorCaptions,
  set: (value) => (ys.pickedColorCaptions = value),
});
const pickedBackgroundColor = computed({
  get: () => ys.pickedBackgroundColor,
  set: (value) => (ys.pickedBackgroundColor = value),
});
const useCaptionBackground = computed({
  get: () => ys.useCaptionBackground,
  set: (value) => (ys.useCaptionBackground = value),
});
const latestTranslationTarget = computed({
  get: () => ys.latestTranslationTarget,
  set: (value) => (ys.latestTranslationTarget = value),
});
const searchQuery = computed({
  get: () => ys.searchQuery,
  set: (value) => (ys.searchQuery = value),
});
const originalText = computed({
  get: () => ys.originalText,
  set: (value) => (ys.originalText = value),
});
const originalSummarizedText = computed({
  get: () => ys.originalSummarizedText,
  set: (value) => (ys.originalSummarizedText = value),
});
const translatedSummarizedText = computed({
  get: () => ys.translatedSummarizedText,
  set: (value) => (ys.translatedSummarizedText = value),
});
const showOriginalSummarized = computed({
  get: () => ys.showOriginalSummarized,
  set: (value) => (ys.showOriginalSummarized = value),
});
const showTranslatedSummarized = computed({
  get: () => ys.showTranslatedSummarized,
  set: (value) => (ys.showTranslatedSummarized = value),
});
const originalVideoSubtitle = computed({
  get: () => ys.originalVideoSubtitle,
  set: (value) => (ys.originalVideoSubtitle = value),
});
const translatedText = computed({
  get: () => ys.translatedText,
  set: (value) => (ys.translatedText = value),
});
const hasVideo = computed({
  get: () => ys.hasVideo,
  set: (value) => (ys.hasVideo = value),
});
const isLoading = computed({
  get: () => ys.isLoading,
  set: (value) => (ys.isLoading = value),
});
const isNotValidLink = computed({
  get: () => ys.isNotValidLink,
  set: (value) => (ys.isNotValidLink = value),
});
const isTargetLanguageSelected = computed({
  get: () => ys.isTargetLanguageSelected,
  set: (value) => (ys.isTargetLanguageSelected = value),
});
const activeCaptionLang = computed({
  get: () => ys.activeCaptionLang,
  set: (value) => (ys.activeCaptionLang = value),
});
const availableCaptions = computed({
  get: () => ys.availableCaptions,
  set: (value) => (ys.availableCaptions = value),
});
const userInput = computed({
  get: () => ys.userInput,
  set: (value) => (ys.userInput = value),
});
const captions = computed({
  get: () => ys.captions,
  set: (value) => (ys.captions = value),
});
const hasCaption = computed({
  get: () => ys.hasCaption,
  set: (value) => (ys.hasCaption = value),
});
const translatedVideoSubtitle = computed({
  get: () => ys.translatedVideoSubtitle,
  set: (value) => (ys.translatedVideoSubtitle = value),
});
const prebuildVideoSubtitle = computed({
  get: () => ys.prebuildVideoSubtitle,
  set: (value) => (ys.prebuildVideoSubtitle = value),
});
const parsedCaptionsWithSpeakers = computed(() => ys.parsedCaptionsWithSpeakers);

// Parse translated WebVTT; speaker tags come from original, text from translated cues.
const translatedCaptionsWithSpeakers = computed((): CaptionModel[] => {
  if (!translatedVideoSubtitle.value || parsedCaptionsWithSpeakers.value.length === 0) {
    return [];
  }

  try {
    return parseTranslatedWebVttWithSpeakers(
      translatedVideoSubtitle.value,
      parsedCaptionsWithSpeakers.value
    );
  } catch (error) {
    console.error("Error parsing translated captions with speakers:", error);
    return [];
  }
});

const notReadyYet = computed({
  get: () => ys.notReadyYet,
  set: (value) => (ys.notReadyYet = value),
});
const webvttTextArea1 = computed({
  get: () => ys.webvttTextArea1,
  set: (value) => (ys.webvttTextArea1 = value),
});
const webvttTextArea2 = computed({
  get: () => ys.webvttTextArea2,
  set: (value) => (ys.webvttTextArea2 = value),
});
const defaultOriginalVideoSubtitle = computed({
  get: () => ys.defaultOriginalVideoSubtitle,
  set: (value) => (ys.defaultOriginalVideoSubtitle = value),
});
const defaultTranslatedVideoSubtitle = computed({
  get: () => ys.defaultTranslatedVideoSubtitle,
  set: (value) => (ys.defaultTranslatedVideoSubtitle = value),
});
const defaultOriginalText = computed({
  get: () => ys.defaultOriginalText,
  set: (value) => (ys.defaultOriginalText = value),
});
const defaultTranslatedText = computed({
  get: () => ys.defaultTranslatedText,
  set: (value) => (ys.defaultTranslatedText = value),
});
const player = computed({
  get: () => ys.player,
  set: (value) => (ys.player = value),
});
const selectedVoice = computed({
  get: () => ys.selectedVoice,
  set: (value) => (ys.selectedVoice = value),
});
const selectedVoiceTranslated = computed({
  get: () => ys.selectedVoiceTranslated,
  set: (value) => (ys.selectedVoiceTranslated = value),
});
const origineTokenValue = computed({
  get: () => ys.origineTokenValue,
  set: (value) => (ys.origineTokenValue = value),
});
const translatedTokenValue = computed({
  get: () => ys.translatedTokenValue,
  set: (value) => (ys.translatedTokenValue = value),
});
const currentRequestId = computed({
  get: () => ys.currentRequestId,
  set: (value) => (ys.currentRequestId = value),
});
const summarizesData = computed({
  get: () => ys.summarizesData,
  set: (value) => (ys.summarizesData = value),
});
const latestTranslationId = computed({
  get: () => ys.latestTranslationId,
  set: (value) => (ys.latestTranslationId = value),
});
const currentTime = computed({
  get: () => ys.currentTime,
  set: (value) => (ys.currentTime = value),
});
const dubbingEnabled = computed({
  get: () => ys.dubbingEnabled,
  set: (value) => (ys.dubbingEnabled = value),
});
const storedCaptions = computed({
  get: () => ys.storedCaptions,
  set: (value) => (ys.storedCaptions = value),
});
const computePricing = computed({
  get: () => ys.computePricing,
  set: (value) => (ys.computePricing = value),
});
const balanceNotEnough = computed({
  get: () => ys.balanceNotEnough,
  set: (value) => (ys.balanceNotEnough = value),
});
const audioSource = computed({
  get: () => ys.audioSource,
  set: (value) => (ys.audioSource = value),
});
const audioSourceTranslated = computed({
  get: () => ys.audioSourceTranslated,
  set: (value) => (ys.audioSourceTranslated = value),
});
const audioContent = computed({
  get: () => ys.audioContent,
  set: (value) => (ys.audioContent = value),
});
const audioContentTranslated = computed({
  get: () => ys.audioContentTranslated,
  set: (value) => (ys.audioContentTranslated = value),
});
const translatedSummarizesLangs = ref<any[]>([]);
let currentAudioElement: HTMLAudioElement | null = null;
const storedAudioElement = ref<HTMLAudioElement | null>(null);
/** Caption id whose clip is loaded in `storedAudioElement` (for pause/resume). */
const storedDubbingAudioCaptionId = ref<string | null>(null);
const dubbingRenderingProgress = ref(0);
const alreadyAcceptPaymentSwitch = ref(false);
const isDownloadingAudio = ref(false);
/** After a successful "Download final dubbing" in the stored-dubbing modal. */
const finalDubbingDownloadSucceeded = ref(false);
const isCachedDubbingShowed = ref(false);
const isAudioLoading = ref(false);
const savingCaptionId = ref<string | null>(null);
const playOriginalAudio = ref(true);
const playTranslationAudio = ref(true);
const isAudioDownloading = ref(false);
const isTranslatingCaptions = ref(false);
const isPdfGenerating = ref(false);
const pdfProgress = ref({
  currentPage: 0,
  totalPages: 0,
  percentage: 0,
  status: 'initializing' as 'initializing' | 'rendering' | 'converting' | 'complete' | 'error'
});
const pdfCancelled = ref(false);
const pdfError = ref<{
  message: string,
  pageNumber?: number,
  technical?: string
} | null>(null);
const lastPdfIsOriginal = ref<boolean | null>(null);
const fontLoadingCache = new Map<string, boolean>();
let html2canvasLoadPromise: Promise<void> | null = null;
const showPdfPreview = ref(false);
const previewText = ref("");
const previewConfig = ref<{
  isOriginal: boolean;
  fontFamily: string;
  fontSize: number;
  color: string;
  isRtl: boolean;
}>({
  isOriginal: true,
  fontFamily: "",
  fontSize: 12,
  color: "#000000",
  isRtl: false,
});

interface ParagraphFormat {
  text: string;
  alignment: 'left' | 'center' | 'right' | 'justify';
  bold: boolean;
  italic: boolean;
  underline: boolean;
}

const previewFormatting = ref<ParagraphFormat[]>([]);
const showNewProcessPop = ref(false);
const translatedChecked = ref(true);
const downloadOnlySentencesSrt = ref(false);
const fontFamilyListShow = ref(false);
const fontFamilyListShowCaptions = ref(false);
const showDownloadTypes = ref(false);
const showDownloadTranslatedTypes = ref(false);
const showDownloadSRTTypes = ref(false);
const showDownloadTranslatedSRTTypes = ref(false);
const isCaptionsLangsDropOpen = ref(false);
const fontSizePercent = ref(50);
const fontSizePercentCaptions = ref(50);
const fontSizeClass = ref("text-lg");
const fontSizeClassCaptions = ref("text-lg");
const editingTexts = ref(false);
const editingSubtitles = ref(false);
const showSavedText = ref(false);
const showSubtitlesText = ref(false);
const fontFamily = ref("Arial");
const selectedPreviewFont = ref<string>("");
const selectedPreviewFontCaption = ref<string>("");
// Toggle for speaker diarization panel visibility (default: visible)
const showSpeakerDiarization = ref(true);
// Toggle for translated speaker diarization panel visibility (default: visible)
const showTranslatedSpeakerDiarization = ref(true);
// Toggle for speaker color controls
const showSpeakerColorControls = ref(false);
// Toggle for translated speaker color controls
const showTranslatedSpeakerColorControls = ref(false);
// Editable speaker colors (reactive)
const speakerColors = ref<Record<number, string>>({
  1: '#4867D3',  // Primary blue
  2: '#10B981',  // Green
  3: '#F59E0B',  // Orange
  4: '#EF4444',  // Red
  5: '#8B5CF6',  // Purple
  6: '#EC4899',  // Pink
  7: '#06B6D4',  // Cyan
  8: '#84CC16',  // Lime
  9: '#F97316',  // Orange-red
  10: '#6366F1'  // Indigo
});
// Speaker color configuration for diarization
const SPEAKER_COLORS: Record<number, string> = {
  1: '#4867D3',  // Primary blue
  2: '#10B981',  // Green
  3: '#F59E0B',  // Orange
  4: '#EF4444',  // Red
  5: '#8B5CF6',  // Purple
  6: '#EC4899',  // Pink
  7: '#06B6D4',  // Cyan
  8: '#84CC16',  // Lime
  9: '#F97316',  // Orange-red
  10: '#6366F1'  // Indigo
};

// Fallback color if speaker tag is missing
const DEFAULT_SPEAKER_COLOR = '#1E293B'; // Dark gray

// Hint functionality variables
const translationHint = ref<string>("");
const showHintInput = ref(false);
const showHintPopup = ref(false);

const contextExamples = [
  "Medical document",
  "Legal contract",
  "Technical manual",
  "Business presentation",
  "Marketing content",
  "Educational material",
  "News article",
  "Scientific paper",
  "User manual",
  "Financial report"
];

const fontFamilyCaptions = ref("Arial");
const fontSizeNumber = ref(12);
const fontSizeNumberCaptions = ref(12);
const audioElement = ref<HTMLAudioElement | null>(null);
const audioElementTranslated = ref<HTMLAudioElement | null>(null);
const isPlaying = ref(false);
const isCaptionOn = ref(true);
const summarizingOriginalText = ref(false);
const summarizingTranslatedText = ref(false);
const selectedSummarizedLanguage = ref("ar");
const isSummarizedLangsDropOpen = ref(false);
const isDubbingOperationRunning = ref(false);
const isDubbingStopsVideo = ref(false);
const isFetchingDubbing = ref(false);
const showPaymentModal = ref(false);
const modalMessage = ref("");
const modalResolve = ref<any>(null);
const playbackSpeed = ref(1);
const playbackSpeedTranslated = ref(1);
let dubbingAudioElement: any;
const processedCueIndices = ref({
  original: 0,
  translated: 0,
});
const handleModalResponse = (confirmed: any) => {
  if (modalResolve.value) {
    modalResolve.value(confirmed);
    modalResolve.value = null;
  }
};
let timeoutTextId: ReturnType<typeof setTimeout> | null = null;
let timeoutSubtitleId: ReturnType<typeof setTimeout> | null = null;
const minTokens = 50;
const maxTokens = 500;
const originSliderStyle = computed(() => {
  const percentage =
    ((origineTokenValue.value - minTokens) / (maxTokens - minTokens)) * 100;
  return locale.value === "ar"
    ? {
        background: `linear-gradient(to left, #000000 ${percentage}%, #d1d5db ${percentage}%)`,
      }
    : {
        background: `linear-gradient(to right, #000000 ${percentage}%, #d1d5db ${percentage}%)`,
      };
});
const translatedSliderStyle = computed(() => {
  const percentage =
    ((translatedTokenValue.value - minTokens) / (maxTokens - minTokens)) * 100;
  return locale.value === "ar"
    ? {
        background: `linear-gradient(to left, #000000 ${percentage}%, #d1d5db ${percentage}%)`,
      }
    : {
        background: `linear-gradient(to right, #000000 ${percentage}%, #d1d5db ${percentage}%)`,
      };
});
const originalSummPercentage = computed(() => {
  const range = maxTokens - minTokens;
  const value = origineTokenValue.value - minTokens;
  return Math.round(25 + (value / range) * 60);
});
const translatedSummPercentage = computed(() => {
  const range = maxTokens - minTokens;
  const value = translatedTokenValue.value - minTokens;
  return Math.round(25 + (value / range) * 60);
});
const computedOriginalClass = computed(() => {
  return [fontSizeClass.value];
});
const computedTranslatedClass = computed(() => {
  return [fontSizeClass.value];
});
const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();

var videoJsOptions = {
  loadingSpinner: false,
  errorDisplay: true,
  preload: "auto",
  playbackRates: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 3],
  controls: true,
  textTrackSettings: true,
  textTrackDisplay: true,
  controlBar: {
    pictureInPictureToggle: true,
    remainingTimeDisplay: false,
    fullscreenToggle: true,
    volumePanel: {
      inline: true,
    },
  },
  html5: {
    nativeTextTracks: true,
    preloadTextTracks: false,
  },
  techOrder: ["html5", "youtube"],
};

router.beforeEach((to, from, next) => {
  if (audioElement.value) {
    audioElement.value!.pause();
  }
  if (audioElementTranslated.value) {
    audioElementTranslated.value!.pause();
  }
  next();
});

const deleteAudio = (id: string, key: any) => {
  if (storedDubbingAudioCaptionId.value === id && storedAudioElement.value) {
    storedAudioElement.value.pause();
    try {
      storedAudioElement.value.removeAttribute("src");
      storedAudioElement.value.load();
    } catch {
      /* ignore */
    }
    storedAudioElement.value = null;
    storedDubbingAudioCaptionId.value = null;
  }
  delete ys.activeAudioDubbing[key];
  storedCaptions.value = storedCaptions.value.map((caption) =>
    caption.id === id
      ? { ...caption, base64: null, isPlaying: false }
      : caption
  );
  cacheCaptionsAndDubbings();
};

const requestNewAudio = async (id: string): Promise<void> => {
  const targetCaption = storedCaptions.value.find(
    (caption) => caption.id === id
  );
  await generateAudio(id, targetCaption?.text!);
};

const saveEditing = async (id: string) => {
  try {
    savingCaptionId.value = id;
    const startTime = storedCaptions.value.find(
      (caption) => caption.id === id
    )?.audioStartTime;
    const newText =
      storedCaptions.value.find((caption) => caption.id === id)?.editedText ?? "";
    storedCaptions.value = storedCaptions.value.map((caption) =>
      caption.id === id
        ? { ...caption, text: caption.editedText, isEditing: false }
        : caption
    );
    captions.value = captions.value.map((caption) =>
      caption.start === (startTime! / 1000).toString()
        ? { ...caption, text: newText }
        : caption
    );
    await cacheCaptionsAndDubbings();
    loadCachedCaptionsAndDubbings();
  } finally {
    savingCaptionId.value = null;
  }
};

const generateAudio = async (id: string, text: string): Promise<boolean> => {
  try {
    if (isAudioLoading.value) {
      return false;
    }

    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return false;
    }
    if (userSubscription !== "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date();
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return false;
      }
    }

    const lengthText = text.length;
    const canProceed = await computeTtsCost(userSubscription, lengthText);
    if (!canProceed) {
      return false;
    }

    const trLang = languages.find(
      (l: Language) => l.langName === activeCaptionLang.value
    );
    let langCode = trLang?.langCode || "en";
    langCode = languageCodeMappings.tts[langCode] || langCode;

    if (unsupportedCloudTts.includes(langCode)) {
      toast(t("the-selected-language-is-currently"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return false;
    }

    isAudioLoading.value = true;
    const response = await fetch(speakTextUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        text,
        language: langCode,
        gender: selectedVoiceTranslated.value,
      }),
    });
    const result = await response.json();

    if (response.ok && result.audioContent) {
      const base64 = `data:audio/mp3;base64,${result.audioContent}`;
      const cpData = storedCaptions.value.find(
        (caption: any) => caption.id === id
      );
      const base64AudioMap: any = {};
      base64AudioMap[cpData?.audioStartTime!] = {
        base64,
        endTime: cpData?.audioEndTime,
      };
      storedCaptions.value = storedCaptions.value.map((caption) =>
        caption.id === id
          ? { ...caption, base64: base64AudioMap[cpData?.audioStartTime!] }
          : caption
      );
      ys.activeAudioDubbing = {
        ...ys.activeAudioDubbing,
        ...base64AudioMap,
      };
      cacheCaptionsAndDubbings();
      return true;
    } else {
      let errorMessage = "Something went wrong";
      if (result.error) {
        switch (result.error) {
          case "Subscription required. Please upgrade your plan.":
            errorMessage = t("subscription-required-please-upgrade-your-plan");
            break;
          case "Your subscription has expired. Please renew your subscription.":
            errorMessage = t(
              "your-subscription-has-expired-please-renew-your-subscription"
            );
            break;
          case "This combination of language and gender is not supported":
            errorMessage = t("this-combination-of-language-and");
            break;
          case "The balance is insufficient":
            errorMessage = t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            );
            break;
          case "Invalid token":
          case "Authorization header missing":
            toast(
              t("your-session-has-expired-please-log-in-again-to-continue"),
              {
                autoClose: 2500,
                type: "error",
                theme: "light",
              }
            );
            await new Promise((resolve) => setTimeout(resolve, 2500));
            authStore.logout();
            router.push("/signing");
            return false;
          default:
            errorMessage = t("were-fixing-a-technical-issue-so-please-try");
            break;
        }
      }
      toast(errorMessage, {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return false;
    }
  } catch (error) {
    console.error("Audio generation error:", error);
    toast(t("were-fixing-a-technical-issue-so-please-try"), {
      autoClose: 3000,
      type: "error",
      theme: "light",
    });
    return false;
  } finally {
    isAudioLoading.value = false;
    return true;
  }
};

const togglePlayDubbingAudio = (id: string) => {
  try {
    const newCaptions = [...storedCaptions.value];
    const captionIndex = newCaptions.findIndex((c) => c.id === id);
    if (captionIndex === -1 || !newCaptions[captionIndex].base64) {
      return;
    }

    const audioEl = storedAudioElement.value;
    const sameClipLoaded =
      audioEl && storedDubbingAudioCaptionId.value === id;

    if (sameClipLoaded) {
      if (!audioEl.paused) {
        newCaptions[captionIndex].isPlaying = false;
        audioEl.pause();
        storedCaptions.value = newCaptions;
        cacheCaptionsAndDubbings();
        return;
      }
      if (audioEl.ended) {
        audioEl.currentTime = 0;
      }
      newCaptions[captionIndex].isPlaying = true;
      void audioEl.play();
      storedCaptions.value = newCaptions;
      cacheCaptionsAndDubbings();
      return;
    }

    const playingIndex = newCaptions.findIndex((c) => c.isPlaying);
    if (playingIndex !== -1) {
      newCaptions[playingIndex].isPlaying = false;
    }
    if (audioEl) {
      audioEl.pause();
      try {
        audioEl.removeAttribute("src");
        audioEl.load();
      } catch {
        /* ignore */
      }
      storedAudioElement.value = null;
      storedDubbingAudioCaptionId.value = null;
    }

    const caption = newCaptions[captionIndex];
    const src = caption.base64?.base64;
    if (!src) {
      return;
    }
    newCaptions[captionIndex].isPlaying = true;
    const audio = new Audio(src);
    storedAudioElement.value = audio;
    storedDubbingAudioCaptionId.value = id;
    audio.onended = () => {
      storedCaptions.value = storedCaptions.value.map((c) =>
        c.id === id ? { ...c, isPlaying: false } : c
      );
    };
    void audio.play();
    storedCaptions.value = newCaptions;
    cacheCaptionsAndDubbings();
  } catch (error) {
    console.log("togglePlayDubbingAudio error:", error);
  }
};

const calculateEndTime = (start: string, dur: string): string => {
  const startMs = parseFloat(start) * 1000;
  const durationMs = parseFloat(dur) * 1000;
  const endMs = startMs + durationMs;
  return formatTimestamp(endMs);
};

const calculateStartedTime = (start: string): string => {
  const startMs = parseFloat(start) * 1000;
  return formatTimestamp(startMs);
};

const formatTimestamp = (ms: number): string => {
  const hours = Math.floor(ms / 3600000)
    .toString()
    .padStart(2, "0");
  ms %= 3600000;
  const minutes = Math.floor(ms / 60000)
    .toString()
    .padStart(2, "0");
  ms %= 60000;
  const seconds = Math.floor(ms / 1000)
    .toString()
    .padStart(2, "0");
  const milliseconds = (ms % 1000).toString().padStart(3, "0");
  return `${hours}:${minutes}:${seconds}.${milliseconds}`;
};

async function getAudioDuration(arrayBuffer: ArrayBuffer): Promise<number> {
  const audioContext = new AudioContext();
  try {
    const clonedBuffer = cloneArrayBuffer(arrayBuffer);
    const audioBuffer = await audioContext.decodeAudioData(clonedBuffer);
    return audioBuffer.duration;
  } catch (e) {
    console.error("Failed to get audio duration:", e);
    throw e;
  } finally {
    await audioContext.close();
  }
}

function cloneArrayBuffer(buffer: ArrayBuffer): ArrayBuffer {
  const newBuffer = new ArrayBuffer(buffer.byteLength);
  new Uint8Array(newBuffer).set(new Uint8Array(buffer));
  return newBuffer;
}

async function downloadFinalDubbing() {
  try {
    finalDubbingDownloadSucceeded.value = false;
    dubbingRenderingProgress.value = 0;
    isDownloadingAudio.value = true;
    const missingCaptions = storedCaptions.value.filter(
      (caption) => !caption.base64
    );
    if (missingCaptions.length > 0) {
      for (const cp of missingCaptions) {
        const targetCaption = storedCaptions.value.find(
          (caption) => caption.id === cp.id
        );
        const result = await generateAudio(cp.id, targetCaption?.text!);
        if (!result) {
          return;
        }
      }
      const stillMissing = storedCaptions.value.filter(
        (caption) => !caption.base64
      );
      if (stillMissing.length > 0) {
        toast(t("failed-to-generate-some-dubbings"), {
          autoClose: 3000,
          type: "error",
          theme: "light",
        });
        return;
      }
    }

    if (!ffmpeg.loaded) {
      const baseURL = "https://unpkg.com/@ffmpeg/core@0.12.10/dist/esm";
      await ffmpeg.load({
        coreURL: await toBlobURL(
          `${baseURL}/ffmpeg-core.js`,
          "text/javascript"
        ),
        wasmURL: await toBlobURL(
          `${baseURL}/ffmpeg-core.wasm`,
          "application/wasm"
        ),
      });
      ffmpeg.on("log", ({ message }) => console.log("FFmpeg log:", message));
    }

    /* let processedCaptions = 0;
    ffmpeg.on('progress', ({ progress }) => {
      if (typeof progress !== 'number' || progress < 0 || progress > 1) return;
      const captionProgress = (processedCaptions / captions.value.length) * 50;
      const fileProgress = progress * (50 / captions.value.length);
      dubbingRenderingProgress.value = Math.min(80, Math.round(30 + captionProgress + fileProgress));
      console.log(`Caption ${processedCaptions}/${captions.value.length}: ${dubbingRenderingProgress.value}%`);
    }); */

    const audioFiles: {
      name: string;
      data: ArrayBuffer;
      startTime: number;
      duration: number;
    }[] = [];
    const filesToKeep: string[] = []; // Track files for concatenation
    for (const [index, caption] of storedCaptions.value.entries()) {
      if (!caption.base64?.base64) {
        console.warn(`Skipping caption ${caption.id}: no base64 audio`);
        continue;
      }

      const startTime = caption.audioStartTime / 1000;
      const endTime = caption.audioEndTime / 1000;
      const captionDuration = endTime - startTime;
      const nextStartTime =
        storedCaptions.value[index + 1]?.audioStartTime / 1000 || null;
      const breakDuration = nextStartTime ? nextStartTime - endTime : 0;
      const targetDuration = captionDuration + (breakDuration || 0);

      const response = await fetch(caption.base64.base64);
      if (!response.ok) {
        console.error(
          `Failed to fetch audio for caption ${caption.id}: ${response.status}`
        );
        continue;
      }
      const blob = await response.blob();
      const arrayBuffer = await blob.arrayBuffer();

      const inputFile = `input_${caption.id}.mp3`;
      const inputData = new Uint8Array(cloneArrayBuffer(arrayBuffer));
      await ffmpeg.writeFile(inputFile, inputData);

      const outputFile = `adjusted_${caption.id}.mp3`;
      let audioDuration: number;
      try {
        audioDuration = await getAudioDuration(arrayBuffer);
      } catch (e) {
        console.error(`Skipping caption ${caption.id}: failed to get duration`);
        await ffmpeg.deleteFile(inputFile);
        continue;
      }

      let speed = 1.0;
      if (audioDuration > targetDuration) {
        speed = Math.min(audioDuration / targetDuration, 2.0);
        const result = await ffmpeg.exec([
          "-i",
          inputFile,
          "-filter:a",
          `atempo=${speed.toFixed(2)}`,
          "-c:a",
          "mp3",
          "-y",
          outputFile,
        ]);
        if (result !== 0) {
          console.error(`FFmpeg failed for ${inputFile}: exit code ${result}`);
          await ffmpeg.deleteFile(inputFile);
          continue;
        }
      } else {
        const result = await ffmpeg.exec([
          "-i",
          inputFile,
          "-c:a",
          "copy",
          "-y",
          outputFile,
        ]);
        if (result !== 0) {
          console.error(`FFmpeg failed for ${inputFile}: exit code ${result}`);
          await ffmpeg.deleteFile(inputFile);
          continue;
        }
      }

      let adjustedData: ArrayBuffer;
      try {
        adjustedData = (await ffmpeg.readFile(outputFile)) as any;
      } catch (e) {
        console.error(`Failed to read ${outputFile}:`, e);
        await ffmpeg.deleteFile(inputFile);
        continue;
      }

      audioFiles.push({
        name: outputFile,
        data: cloneArrayBuffer(adjustedData),
        startTime,
        duration: audioDuration / speed,
      });
      filesToKeep.push(outputFile);

      await ffmpeg.deleteFile(inputFile);
    }

    if (audioFiles.length === 0) {
      toast(t("no-audio-files-to-process"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }

    const concatList: string[] = [];
    let currentTime = 0;
    for (const [index, file] of audioFiles.entries()) {
      await ffmpeg.writeFile(file.name, new Uint8Array(file.data));

      const silenceDuration =
        index === 0 ? file.startTime : file.startTime - currentTime;
      if (silenceDuration > 0) {
        const silenceFile = `silence_${index}.mp3`;
        const result = await ffmpeg.exec([
          "-f",
          "lavfi",
          "-t",
          silenceDuration.toFixed(3),
          "-i",
          "anullsrc=channel_layout=stereo:sample_rate=44100",
          "-c:a",
          "mp3",
          "-y",
          silenceFile,
        ]);
        if (result !== 0) {
          console.error(
            `Failed to generate ${silenceFile}: exit code ${result}`
          );
        } else {
          concatList.push(`file '${silenceFile}'`);
          filesToKeep.push(silenceFile);
        }
      }
      concatList.push(`file '${file.name}'`);
      currentTime = file.startTime + file.duration;
    }

    const concatFile = "concat_list.txt";
    const concatContent = concatList.join("\n");
    await ffmpeg.writeFile(concatFile, new TextEncoder().encode(concatContent));

    const finalOutput = "final_dubbing.mp3";
    const concatResult = await ffmpeg.exec([
      "-f",
      "concat",
      "-safe",
      "0",
      "-i",
      concatFile,
      "-c:a",
      "mp3",
      "-y",
      finalOutput,
    ]);
    if (concatResult !== 0) {
      console.error(`FFmpeg concat failed: exit code ${concatResult}`);
      throw new Error("Concatenation failed");
    }

    let finalData: ArrayBuffer;
    try {
      finalData = (await ffmpeg.readFile(finalOutput)) as any;
      console.log(`Read ${finalOutput}, size: ${finalData.byteLength} bytes`);
    } catch (e) {
      console.error(`Failed to read ${finalOutput}:`, e);
      throw e;
    }

    const blob = new Blob([finalData], { type: "audio/mp3" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `dubbing_${currentRequestId.value || "video"}.mp3`;
    link.click();
    URL.revokeObjectURL(url);

    for (const file of filesToKeep) {
      await ffmpeg.deleteFile(file);
    }
    await ffmpeg.deleteFile(concatFile);
    await ffmpeg.deleteFile(finalOutput);
    finalDubbingDownloadSucceeded.value = true;
  } catch (error) {
    console.error("Download final dubbing error:", error);
    finalDubbingDownloadSucceeded.value = false;
    toast(t("were-fixing-a-technical-issue-so-please-try"), {
      autoClose: 3000,
      type: "error",
      theme: "light",
    });
  } finally {
    isDownloadingAudio.value = false;
  }
}

const toggleCachedDubbingPop = (initialize: boolean) => {
  if (initialize) {
    storedCaptions.value = captions.value.map((caption, index) => ({
      ...caption,
      id: `${index}`,
      endTime: calculateEndTime(caption.start, caption.dur),
      start: calculateStartedTime(caption.start),
      base64: ys.activeAudioDubbing[parseFloat(caption.start) * 1000] || null,
      audioStartTime: parseFloat(caption.start) * 1000,
      audioEndTime:
        parseFloat(caption.start) * 1000 + parseFloat(caption.dur) * 1000,
      isPlaying: false,
      isEditing: false,
      editedText: caption.text,
    }));
  }
  if (!isCachedDubbingShowed.value) {
    finalDubbingDownloadSucceeded.value = false;
  }
  isCachedDubbingShowed.value = !isCachedDubbingShowed.value;
};

const toggleShowOrinialSummarized = (value: boolean) => {
  if (showOriginalSummarized.value === value) return;
  if (value) {
    if (!originalSummarizedText.value) {
      return;
    }
    showOriginalSummarized.value = true;
  } else {
    showOriginalSummarized.value = false;
  }
};

const toggleShowTranslatedSummarized = (value: boolean) => {
  if (showTranslatedSummarized.value === value) return;
  if (value) {
    if (!translatedSummarizedText.value) {
      return;
    }
    showTranslatedSummarized.value = true;
  } else {
    showTranslatedSummarized.value = false;
  }
};

function consumePendingHelpScroll() {
  const id = ys.pendingHelpScrollSectionId;
  if (!id || !hasCaption.value) return;
  const attempt = (): boolean => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      ys.pendingHelpScrollSectionId = null;
      return true;
    }
    return false;
  };
  if (attempt()) return;
  requestAnimationFrame(() => {
    if (attempt()) return;
    setTimeout(() => {
      if (!attempt()) {
        ys.pendingHelpScrollSectionId = null;
      }
    }, 450);
  });
}

watch(
  hasCaption,
  (ready) => {
    if (!ready) return;
    nextTick(() => consumePendingHelpScroll());
  },
  { immediate: true }
);

watch(summarizesData, () => {
  translatedSummarizesLangs.value = summarizesData.value
    .filter((e: any) => e.lang !== originalLanguage.value.langCode)
    .map((item) => item.lang);
});

watch(
  () => showTextTab.value,
  () => {
    nextTick(() => {
      const checkboxes = document.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach((checkbox: any) => {
        const checkboxId = `${selectedVoice.value}-checkbox`;
        if (checkbox.id === checkboxId) {
          checkbox.checked = true;
        }
        const checkboxIdtranslated = `${selectedVoiceTranslated.value}-checkbox-translated`;
        if (checkbox.id === checkboxIdtranslated) {
          checkbox.checked = true;
        }
      });
    });
  }
);

watch(originalText, () => {
  if (!editingTexts.value) {
    editingTexts.value = true;
  }
  if (timeoutTextId) {
    clearTimeout(timeoutTextId);
  }
  timeoutTextId = setTimeout(async () => {
    editingTexts.value = false;
    showSavedText.value = true;
    timeoutTextId = null;
    await new Promise((f) => setTimeout(f, 3000));
    showSavedText.value = false;
  }, 1000);
});

watch(translatedText, () => {
  if (!editingTexts.value) {
    editingTexts.value = true;
  }
  if (timeoutTextId) {
    clearTimeout(timeoutTextId);
  }
  timeoutTextId = setTimeout(async () => {
    editingTexts.value = false;
    showSavedText.value = true;
    timeoutTextId = null;
    await new Promise((f) => setTimeout(f, 3000));
    showSavedText.value = false;
  }, 1000);
});

watch(audioContentTranslated, (raw) => {
  if (!raw || !audioSourceTranslated.value || !audioElementTranslated.value) return;
  const src = typeof raw === "string" && (raw.startsWith("http://") || raw.startsWith("https://")) ? raw : `data:audio/mpeg;base64,${raw}`;
  audioSourceTranslated.value.src = src;
  audioElementTranslated.value.load();
});

watch(originalVideoSubtitle, () => {
  if (!editingSubtitles.value) {
    editingSubtitles.value = true;
  }
  if (timeoutSubtitleId) {
    clearTimeout(timeoutSubtitleId);
  }
  timeoutSubtitleId = setTimeout(async () => {
    editingSubtitles.value = false;
    timeoutSubtitleId = null;
    showSubtitlesText.value = true;
    if (translatedVideoSubtitle.value.length != 0) {
      const { original: paddedOriginal, translated: paddedTranslated } =
        padCaptionsToEqualLines(
          originalVideoSubtitle.value,
          translatedVideoSubtitle.value
        );
      translatedVideoSubtitle.value = paddedTranslated;
    }
    await new Promise((f) => setTimeout(f, 3000));
    showSubtitlesText.value = false;
  }, 1000);
});

const handleDubbingToggle = (event: any) => {
  const isChecked = event.target.checked;
  if (isChecked) {
    let textToDubbing = translatedVideoSubtitle.value;
    if (textToDubbing.trim().length === 0) {
      toast(t("please-select-a-language-and-translate"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      dubbingEnabled.value = false;
      event.target.checked = false;
    } else if (
      unsupportedCloudTts.includes(translationLanguage.value.langCode)
    ) {
      toast(t("the-selected-language-is-currently"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      dubbingEnabled.value = false;
      event.target.checked = false;
    } else {
      dubbingEnabled.value = true;
      player.value.setVolume(40);
    }
  }
};

function padCaptionsToEqualLines(originalText: any, translatedText: any) {
  const originalLines = originalText.split("\n");
  const translatedLines = translatedText.split("\n");
  const originalHeader = originalLines[0].startsWith("WEBVTT")
    ? originalLines.shift()
    : "";
  const translatedHeader = translatedLines[0].startsWith("WEBVTT")
    ? translatedLines.shift()
    : "";
  const originalCaptions = splitCaptions(originalLines);
  const translatedCaptions = splitCaptions(translatedLines);
  const paddedOriginal = [];
  const paddedTranslated = [];

  for (let i = 0; i < originalCaptions.length; i++) {
    const originalCaption = originalCaptions[i];
    const translatedCaption = translatedCaptions[i] || {
      index: originalCaption.index,
      timestamp: originalCaption.timestamp,
      text: "",
    };
    const originalTextLines = originalCaption.text.split("\n");
    const translatedTextLines = translatedCaption.text.split("\n");
    const maxLines = Math.max(
      originalTextLines.length,
      translatedTextLines.length
    );
    const paddedOriginalText = [
      ...originalTextLines,
      ...Array(maxLines - originalTextLines.length).fill(""),
    ];
    const paddedTranslatedText = [
      ...translatedTextLines,
      ...Array(maxLines - translatedTextLines.length).fill(""),
    ];
    paddedOriginal.push(
      `${originalCaption.index}\n${
        originalCaption.timestamp
      }\n${paddedOriginalText.join("\n")}`
    );
    paddedTranslated.push(
      `${translatedCaption.index}\n${
        translatedCaption.timestamp
      }\n${paddedTranslatedText.join("\n")}`
    );
  }

  return {
    original: `${originalHeader}\n\n${paddedOriginal.join("\n\n")}`,
    translated: `${translatedHeader}\n\n${paddedTranslated.join("\n\n")}`,
  };
}

function splitCaptions(lines: any) {
  const captions = [];
  let index = "";
  let timestamp = "";
  let text = "";

  lines.forEach((line: any) => {
    if (/^\d+$/.test(line)) {
      if (index && timestamp && text) {
        captions.push({ index, timestamp, text: text.trim() });
        text = "";
      }
      index = line;
    } else if (line.includes("-->")) {
      timestamp = line;
    } else {
      text += line + "\n";
    }
  });

  if (index && timestamp && text) {
    captions.push({ index, timestamp, text: text.trim() });
  }

  return captions;
}

watch(translatedVideoSubtitle, () => {
  if (!editingSubtitles.value) {
    editingSubtitles.value = true;
  }
  if (timeoutSubtitleId) {
    clearTimeout(timeoutSubtitleId);
  }
  timeoutSubtitleId = setTimeout(async () => {
    editingSubtitles.value = false;
    showSubtitlesText.value = true;
    timeoutSubtitleId = null;
    const { original: paddedOriginal, translated: paddedTranslated } =
      padCaptionsToEqualLines(
        originalVideoSubtitle.value,
        translatedVideoSubtitle.value
      );
    originalVideoSubtitle.value = paddedOriginal;
    if (translatedVideoSubtitle.value.length != 0) {
      cacheCaptionsAndDubbings();
    }
    await new Promise((f) => setTimeout(f, 3000));
    showSubtitlesText.value = false;
  }, 1000);
  try {
    const avCaption = availableCaptions.value.find(
      (cc) => cc.language === translationLanguage.value.langName
    );
    if (avCaption) {
      avCaption.captions = parseWebVTTToCaption(translatedVideoSubtitle.value);
      if (translationLanguage.value.langName === activeCaptionLang.value) {
        captions.value = avCaption.captions;
        ys.currentTime =
          player?.value != null ? player?.value.getCurrentTime() || 0 : 0;
        updateCurrentCaptions(currentTime.value);
      }
    }
  } catch (error) {
    console.log("update captions ----------", error);
  }
});

watch(originalVideoSubtitle, () => {
  if (!hasVideo.value) return;
  const entry = availableCaptions.value.find(
    (cc) => cc.language === originalLanguage.value.langName
  );
  if (!entry) return;
  entry.captions = JSON.parse(
    JSON.stringify(parseWebVTT(originalVideoSubtitle.value))
  );
  if (originalLanguage.value.langName === activeCaptionLang.value) {
    captions.value = entry.captions;
    ys.currentTime =
      player?.value != null ? player?.value.getCurrentTime() || 0 : 0;
    updateCurrentCaptions(ys.currentTime);
  }
});

watch(translatedVideoSubtitle, () => {
  if (!hasVideo.value) return;
  const entry = availableCaptions.value.find(
    (cc) => cc.language === translationLanguage.value.langName
  );
  if (!entry) return;
  entry.captions = JSON.parse(
    JSON.stringify(parseWebVTT(translatedVideoSubtitle.value))
  );
  if (translationLanguage.value.langName === activeCaptionLang.value) {
    captions.value = entry.captions;
    ys.currentTime =
      player?.value != null ? player?.value.getCurrentTime() || 0 : 0;
    updateCurrentCaptions(ys.currentTime);
  }
});

const handleReceivedValue = (value: any) => {
  initYouTubePlayer(value);
};

onMounted(async () => {
  /* ys.videoPlayer = videojs(
    "videoPlayer",
    videoJsOptions,
    function onPlayerReady() {
      videojs.log("Your player is ready!");
    }
  ); */
  const checkboxes = document.querySelectorAll('input[type="checkbox"]');
  checkboxes.forEach((checkbox: any) => {
    const checkboxId = `${selectedVoice.value}-checkbox`;
    if (checkbox.id === checkboxId) {
      checkbox.checked = true;
    }
    const checkboxIdtranslated = `${selectedVoiceTranslated.value}-checkbox-translated`;
    if (checkbox.id === checkboxIdtranslated) {
      checkbox.checked = true;
    }
  });
  if (ys.mountPlayer) {
    const videoId = extractVideoId(ys.userInput);
    await initYouTubePlayer(videoId || "");
  }
  communicationStore.registerCallback(handleReceivedValue);
  if (audioContent.value) {
    audioSource.value!.src = `data:audio/mpeg;base64,${audioContent.value}`;
    audioElement.value!.load();
  }
  if (audioContentTranslated.value) {
    const raw = audioContentTranslated.value;
    audioSourceTranslated.value!.src = typeof raw === "string" && (raw.startsWith("http://") || raw.startsWith("https://")) ? raw : `data:audio/mpeg;base64,${raw}`;
    audioElementTranslated.value!.load();
  }
  // Cooldown is disabled in fontStore.fetchGoogleFonts() - see src/store/fontsStore.ts
  await fontStore.fetchGoogleFonts(authStore.token!);
  nextTick().then(() => {
    const dbRequest = indexedDB.open("FontCacheDB", 1);
    dbRequest.onsuccess = (event: any) => {
      const db = event.target.result;
      const tx = db.transaction("fonts", "readonly");
      const store = tx.objectStore("fonts");
      const getAllKeysRequest = store.getAllKeys();

      getAllKeysRequest.onsuccess = () => {
        const cachedKeys = getAllKeysRequest.result;
        fontStore.fonts.forEach((font: any) => {
          if (cachedKeys.includes(font.name)) {
            console.log("Font found in cache: ", font.name);
            loadGoogleFont(font.name, font.files.regular, () => {});
          }
        });
      };

      getAllKeysRequest.onerror = () => {
        console.warn("Failed to get font keys from IndexedDB", getAllKeysRequest.error);
      };
    };

    dbRequest.onerror = (e: any) => {
      console.warn("IndexedDB open error", e);
    };
    fontFamily.value = prefStore.selectedFont != null ? prefStore.selectedFont.name : "";
  });
});

onUnmounted(() => {
  try {
    ys.videoPlayer?.dispose();
    ys.videoPlayer = null;
  } catch (error) {
    console.log(`onUnmounted: ${error}`);
  }
  communicationStore.unregisterCallback(handleReceivedValue);
});

onBeforeUnmount(() => {
  currentCaptions.value = [];
  console.log(ys.intervalId);
  if (ys.intervalId != null) {
    clearInterval(ys.intervalId);
    ys.intervalId = null;
    player.value.pauseVideo();
  }
});

onBeforeMount(async () => {
  const queryType = route.query.type?.toString();
  const onetimeOrderId = route.query.onetime_order?.toString();
  if (queryType === "onetime_result" && onetimeOrderId) {
    notReadyYet.value = true;
    destroyVideoPlayer();
    processNewVideo();
    await fetchOneTimeResultForYoutube(onetimeOrderId);
    return;
  }
  if (route.query.req) {
    notReadyYet.value = true;
    destroyVideoPlayer();
    processNewVideo();
    const reqId = route.query.req.toString();
    await fetchTranscription(reqId);
    await fetchSummarizedText();
    loadCachedCaptionsAndDubbings();
    if (route.query.tr) {
      const relatedRequestId = route.query.tr.toString();
      await getTranslatedFile(relatedRequestId || "");
    }
    ys.isFromNotification = true;
  }
});

watch(
  () => [route.query.type, route.query.onetime_order],
  async () => {
    const queryType = route.query.type?.toString();
    const onetimeOrderId = route.query.onetime_order?.toString();
    if (queryType === "onetime_result" && onetimeOrderId) {
      notReadyYet.value = true;
      destroyVideoPlayer();
      processNewVideo();
      await fetchOneTimeResultForYoutube(onetimeOrderId);
      return;
    }
  }
);

watch(
  () => route.query.req,
  async () => {
    if (route.query.type === "onetime_result" && route.query.onetime_order) return;
    if (route.query.req) {
      notReadyYet.value = true;
      destroyVideoPlayer();
      processNewVideo();
      const reqId = route.query.req.toString();
      await fetchTranscription(reqId);
      await fetchSummarizedText();
      loadCachedCaptionsAndDubbings();
      if (route.query.tr) {
        const relatedRequestId = route.query.tr.toString();
        await getTranslatedFile(relatedRequestId || "");
      }
      ys.isFromNotification = true;
    }
  }
);

const processNewVideo = () => {
  try {
    if (notReadyYet.value) {
      hasVideo.value = false;
      isLoading.value = false;
      isNotValidLink.value = false;
      isTargetLanguageSelected.value = false;
      captions.value = [];
      activeCaptionLang.value = "";
      availableCaptions.value = [];
      userInput.value = "";
      hasCaption.value = false;
      originalVideoSubtitle.value = "";
      prebuildVideoSubtitle.value = "";
      translatedVideoSubtitle.value = "";
      originalText.value = "";
      notReadyYet.value = false;
      defaultOriginalVideoSubtitle.value = "";
      defaultTranslatedVideoSubtitle.value = "";
      defaultOriginalText.value = "";
      defaultTranslatedText.value = "";
      translatedText.value = "";
    }
    if (dubbingEnabled.value) {
      dubbingEnabled.value = false;
    }
    currentCaptions.value = [];
    console.log(currentCaptions.value);
  } catch (error) {
    console.log(error);
  }
};

const processNewVideoOrder = () => {
  try {
    hasVideo.value = false;
    isLoading.value = false;
    isNotValidLink.value = false;
    isTargetLanguageSelected.value = false;
    captions.value = [];
    activeCaptionLang.value = "";
    availableCaptions.value = [];
    userInput.value = "";
    hasCaption.value = false;
    originalVideoSubtitle.value = "";
    prebuildVideoSubtitle.value = "";
    translatedVideoSubtitle.value = "";
    originalText.value = "";
    translatedText.value = "";
    audioContent.value = "";
    notReadyYet.value = false;
    defaultOriginalVideoSubtitle.value = "";
    defaultTranslatedVideoSubtitle.value = "";
    defaultOriginalText.value = "";
    defaultTranslatedText.value = "";
    latestTranslationId.value = "";
    currentCaptions.value = [];
    console.log(currentCaptions.value);
    if (dubbingEnabled.value) {
      dubbingEnabled.value = false;
    }
  } catch (error) {
    console.log(error);
  }
};

const increaseFontSize = () => {
  try {
    if (fontSizePercent.value == 75) return;
    fontSizePercent.value += 5;
    updateTextSize();
  } catch (error) {
    console.log("increaseFontSize:", error);
  }
};

const increaseCaptionsFontSize = () => {
  try {
    if (fontSizePercentCaptions.value == 75) return;
    fontSizePercentCaptions.value += 5;
    updateCaptionsTextSize();
  } catch (error) {
    console.log("increaseFontSize:", error);
  }
};

const syncScroll = (target: "webvttTextArea1" | "webvttTextArea2") => {
  const sourceTextarea =
    target === "webvttTextArea1"
      ? webvttTextArea2.value
      : webvttTextArea1.value;
  const targetTextarea =
    target === "webvttTextArea1"
      ? webvttTextArea1.value
      : webvttTextArea2.value;

  if (sourceTextarea && targetTextarea) {
    targetTextarea.scrollTop = sourceTextarea.scrollTop;
  }
};

const base64ToBlob = (base64: any, mime: any) => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime });
};

const downloadAudioFile = async (translated: boolean) => {
  try {
    if (isAudioDownloading.value) return;
    if (translated) {
      if (showTranslatedSummarized.value) return;
    } else {
      if (showOriginalSummarized.value) return;
    }
    if (
      (translated && ys.translatedText.length == 0) ||
      (!translated && originalText.value.length == 0)
    ) {
      toast(t("text-to-speech-cannot-be-used-with"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (
      (translated &&
        unsupportedCloudTts.includes(ys.translationLanguage.langCode)) ||
      (!translated &&
        unsupportedCloudTts.includes(originalLanguage.value.langCode))
    ) {
      toast(t("the-selected-language-is-currently"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }

    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }

    const lengthText = translated
      ? translatedText.value.length
      : originalText.value.length;
    const canProceed = await computeTtsCost(userSubscription, lengthText);
    if (!canProceed) {
      return;
    }

    isAudioDownloading.value = true;
    playOriginalAudio.value = !translated;
    playTranslationAudio.value = translated;
    const response = await fetch(speakTextUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        text: translated ? ys.translatedText : originalText.value,
        language: translated
          ? ys.translationLanguage.langCode
          : originalLanguage.value.langCode,
        gender: translated
          ? selectedVoiceTranslated.value
          : selectedVoice.value,
      }),
    });
    const result = await response.json();
    if (!response.ok) {
      switch (result.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        case "Subscription required. Please upgrade your plan.":
          toast(t("subscription-required-please-upgrade-your-plan"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Your subscription has expired. Please renew your subscription.":
          toast(
            t("your-subscription-has-expired-please-renew-your-subscription"),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "This combination of language and gender is not supported":
          toast(t("this-combination-of-language-and"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "The balance is insufficient":
          toast(
            t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            ),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "Internal Server Error":
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
      }
      return;
    }
    console.log(result);
    if (result.audioContent) {
      audioContent.value = result.audioContent;
      isAudioDownloading.value = false;
    } else {
      isAudioDownloading.value = false;
    }
    const audioBlob = base64ToBlob(audioContent.value, "audio/mp3");
    const url = URL.createObjectURL(audioBlob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${generateFileName(!translated)}.mp3`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.log("downloadAudioFile:", error);
  }
};

// Helper function to detect if response is Soniox format
function isSonioxFormat(data: any): boolean {
  // Soniox format has: id, text, tokens array
  // Google Cloud format has: results array with alternatives
  if (!data || typeof data !== 'object') {
    return false;
  }
  
  // Check if it's Soniox format (has id, text, and tokens array)
  if (data.id !== undefined && data.text !== undefined && Array.isArray(data.tokens)) {
    return true;
  }
  
  // Check if it's Google Cloud format (has results array with alternatives)
  if (data.results && Array.isArray(data.results) && data.results.length > 0) {
    if (data.results[0].alternatives && Array.isArray(data.results[0].alternatives)) {
      return false;
    }
  }
  
  // Check if it's Google Cloud format (array with results)
  if (Array.isArray(data) && data.length > 0 && data[0].results) {
    return false;
  }
  
  return false;
}

// New method to extract text from Soniox format
const extractTextFromSoniox = (sonioxData: any): string => {
  try {
    // Soniox format has text field directly
    if (sonioxData && typeof sonioxData === 'object' && sonioxData.text) {
      return sonioxData.text || "";
    }
    
    // If text field is not available, try to reconstruct from tokens
    if (sonioxData && sonioxData.tokens && Array.isArray(sonioxData.tokens)) {
      let text = "";
      sonioxData.tokens.forEach((token: any) => {
        if (token.text) {
          text += token.text;
        }
      });
      return text.trim();
    }
    
    return "";
  } catch (error) {
    console.error("Error extracting text from Soniox:", error);
    return "";
  }
};

// Generate WebVTT from Soniox format
function subtitleGenerationSoniox(sonioxResponse: any): string {
  try {
    const captions = parseSonioxTranscription(sonioxResponse);
    
    // Format captions into WebVTT
    let webvttContent = "WEBVTT\n\n";
    captions.forEach((caption, index) => {
      webvttContent += `${index + 1}\n${caption.start} --> ${caption.dur}\n${
        caption.text
      }\n\n`;
    });

    return webvttContent;
  } catch (error) {
    console.error("Error generating WebVTT from Soniox:", error);
    return "";
  }
}

// Generate WebVTT from Google Cloud format
function subtitleGeneration(speechToTextResponse: any): string {
  try {
    const captions: CaptionModel[] = [];
    const minBinSize = 2.5;
    const maxBinSize = 3.5;

    speechToTextResponse[0].results.forEach((result: any) => {
      let currentStartTime = 0;
      let transcript = "";

      for (let i = 0; i < result.alternatives[0].words.length; i++) {
        const word = result.alternatives[0].words[i].word;
        const wordStartSeconds =
          result.alternatives[0].words[i].startTime.seconds || 0;
        const nextWordStartSeconds =
          result.alternatives[0].words[i + 1]?.startTime.seconds || 0;
        const ndnextWordStartSeconds =
          result.alternatives[0].words[i + 2]?.startTime.seconds || 0;

        if (transcript.trim() === "") {
          currentStartTime = wordStartSeconds;
        }

        transcript = transcript + " " + word;

        const duration = nextWordStartSeconds - currentStartTime;
        const ndDuration =
          ndnextWordStartSeconds - nextWordStartSeconds + duration;

        if (
          (minBinSize <= duration && duration <= maxBinSize) ||
          ndDuration > maxBinSize
        ) {
          const newCaption: CaptionModel = {
            start: formatTime(currentStartTime),
            dur: formatTime(nextWordStartSeconds),
            text: transcript.trim(),
          };

          captions.push(newCaption);

          currentStartTime = nextWordStartSeconds;
          transcript = "";
        }
      }

      if (transcript.trim() !== "") {
        const lastWordEndSeconds =
          result.alternatives[0].words[result.alternatives[0].words.length - 1]
            .endTime.seconds;
        const duration = lastWordEndSeconds - currentStartTime;

        if (duration > 0) {
          const newCaption: CaptionModel = {
            start: formatTime(currentStartTime),
            dur: formatTime(lastWordEndSeconds),
            text: transcript.trim(),
          };
          captions.push(newCaption);
        }
      }
    });

    // Format captions into WebVTT
    let webvttContent = "WEBVTT\n\n";
    captions.forEach((caption, index) => {
      webvttContent += `${index + 1}\n${caption.start} --> ${caption.dur}\n${
        caption.text
      }\n\n`;
    });

    return webvttContent;
  } catch (error) {
    console.error("Error processing captions:", error);
    return "";
  }
}

// Parse Soniox transcription format
function parseSonioxTranscription(sonioxResponse: any): CaptionModel[] {
  try {
    const captions: CaptionModel[] = [];
    const minBinSize = 3.5;
    const maxBinSize = 4.5;
    
    if (!sonioxResponse.tokens || !Array.isArray(sonioxResponse.tokens)) {
      console.warn("Soniox response missing tokens array");
      return captions;
    }

    let currentSpeaker: number | null = null;
    let currentStartTime = 0;
    let transcript = "";
    let speakerSegments: Array<{
      word: string;
      speakerTag: number | null;
      startTime: number;
      start: number;
      end: number;
    }> = [];

    // Group tokens into words (tokens can be partial words like "S", "o,", " wh", "at")
    const words: Array<{
      text: string;
      startMs: number;
      endMs: number;
      speaker: number | null;
    }> = [];
    
    let currentWord = "";
    let wordStartMs = 0;
    let wordEndMs = 0;
    let wordSpeaker: number | null = null;

    sonioxResponse.tokens.forEach((token: any) => {
      const tokenText = token.text || "";
      const tokenStartMs = token.start_ms || 0;
      const tokenEndMs = token.end_ms || 0;
      const tokenSpeaker = token.speaker !== null && token.speaker !== undefined ? (typeof token.speaker === 'string' ? parseInt(token.speaker) : token.speaker) : null;

      const hasLeadingSpace = tokenText.trimStart() !== tokenText;
      const trimmedTokenText = tokenText.trimStart();
      
      if (hasLeadingSpace) {
        if (currentWord.trim()) {
          words.push({
            text: currentWord.trim(),
            startMs: wordStartMs,
            endMs: wordEndMs,
            speaker: wordSpeaker
          });
        }
        currentWord = trimmedTokenText;
        wordStartMs = tokenStartMs;
        wordEndMs = tokenEndMs;
        wordSpeaker = tokenSpeaker;
      } else {
        if (!currentWord) {
          wordStartMs = tokenStartMs;
          wordSpeaker = tokenSpeaker;
        }
        currentWord += tokenText;
        wordEndMs = tokenEndMs;
        if (tokenSpeaker !== null) {
          wordSpeaker = tokenSpeaker;
        }
      }
    });

    if (currentWord.trim()) {
      words.push({
        text: currentWord.trim(),
        startMs: wordStartMs,
        endMs: wordEndMs,
        speaker: wordSpeaker
      });
    }

    const getMostCommonSpeaker = (segments: Array<{speakerTag: number | null}>): number | null => {
      const speakerCounts: Record<number, number> = {};
      let maxCount = 0;
      let mostCommonSpeaker: number | null = null;

      segments.forEach(segment => {
        if (segment.speakerTag !== null && segment.speakerTag !== undefined) {
          speakerCounts[segment.speakerTag] = (speakerCounts[segment.speakerTag] || 0) + 1;
          if (speakerCounts[segment.speakerTag] > maxCount) {
            maxCount = speakerCounts[segment.speakerTag];
            mostCommonSpeaker = segment.speakerTag;
          }
        }
      });

      if (mostCommonSpeaker === null) {
        const firstSpeaker = segments.find(s => s.speakerTag !== null && s.speakerTag !== undefined);
        if (firstSpeaker) {
          mostCommonSpeaker = firstSpeaker.speakerTag;
        }
      }

      return mostCommonSpeaker;
    };

    if (words.length === 0) {
      return captions;
    }
    
    words.forEach((word, i) => {
      const wordStartSeconds = word.startMs / 1000;
      const nextWord = words[i + 1];
      const nextWordStartSeconds = nextWord ? (nextWord.startMs / 1000) : null;
      
      const wordText = word.text;
      const speakerTag = word.speaker;

      if (transcript.trim() === "") {
        currentStartTime = wordStartSeconds;
        currentSpeaker = speakerTag;
      }

      const speakerChanged = currentSpeaker !== null && speakerTag !== null && currentSpeaker !== speakerTag;
      
      if (speakerChanged && transcript.trim() !== "" && speakerSegments.length > 0) {
        const duration = wordStartSeconds - currentStartTime;
        if (duration >= 0.3) {
          const captionSpeaker = getMostCommonSpeaker(speakerSegments);
          
          const newCaption: CaptionModel = {
            start: formatTime(currentStartTime),
            dur: formatTime(wordStartSeconds),
            text: transcript.trim(),
            speakerTag: captionSpeaker,
            words: speakerSegments.map(s => ({
              word: s.word,
              speakerTag: s.speakerTag,
              startTime: s.startTime
            }))
          };

          captions.push(newCaption);

          currentStartTime = wordStartSeconds;
          transcript = "";
          speakerSegments = [];
          currentSpeaker = speakerTag;
        }
      }

      transcript = transcript + " " + wordText;
      
      speakerSegments.push({
        word: wordText,
        speakerTag: speakerTag,
        startTime: wordStartSeconds,
        start: wordStartSeconds,
        end: word.endMs / 1000
      });

      if (speakerTag !== null) {
        currentSpeaker = speakerTag;
      }
      
      if (nextWordStartSeconds !== null) {
        const duration = nextWordStartSeconds - currentStartTime;
        const ndnextWord = words[i + 2];
        const ndnextWordStartSeconds = ndnextWord ? (ndnextWord.startMs / 1000) : null;
        const ndDuration = ndnextWordStartSeconds 
          ? (ndnextWordStartSeconds - nextWordStartSeconds + duration) 
          : null;

        const shouldSplit = 
          (minBinSize <= duration && duration <= maxBinSize) ||
          (ndDuration && ndDuration > maxBinSize);

        if (shouldSplit) {
          const captionSpeaker = getMostCommonSpeaker(speakerSegments);
          
          const newCaption: CaptionModel = {
            start: formatTime(currentStartTime),
            dur: formatTime(nextWordStartSeconds),
            text: transcript.trim(),
            speakerTag: captionSpeaker,
            words: speakerSegments.map(s => ({
              word: s.word,
              speakerTag: s.speakerTag,
              startTime: s.startTime
            }))
          };

          captions.push(newCaption);

          currentStartTime = nextWordStartSeconds;
          transcript = "";
          speakerSegments = [];
          currentSpeaker = speakerTag;
        }
      }
    });

    if (transcript.trim() !== "" && words.length > 0) {
      const lastWord = words[words.length - 1];
      const lastWordEndSeconds = lastWord.endMs / 1000;
      const duration = lastWordEndSeconds - currentStartTime;

      if (duration > 0) {
        const captionSpeaker = getMostCommonSpeaker(speakerSegments);
        
        const newCaption: CaptionModel = {
          start: formatTime(currentStartTime),
          dur: formatTime(lastWordEndSeconds),
          text: transcript.trim(),
          speakerTag: captionSpeaker,
          words: speakerSegments.map(s => ({
            word: s.word,
            speakerTag: s.speakerTag,
            startTime: s.startTime
          }))
        };
        captions.push(newCaption);
      }
    }

    return captions;
  } catch (error) {
    console.error("Error parsing Soniox transcription:", error);
    return [];
  }
}

// Parse Google Cloud transcription with speakers
function parseTranscriptionWithSpeakers(speechToTextResponse: any): CaptionModel[] {
  try {
    const captions: CaptionModel[] = [];
    const minBinSize = 3.5;
    const maxBinSize = 4.5;
    
    if (speechToTextResponse[0]?.results) {
      speechToTextResponse[0].results.forEach((result: any) => {
        let currentSpeaker: number | null = null;
        let currentStartTime = 0;
        let transcript = "";
        let speakerSegments: Array<{
          word: string;
          speakerTag: number | null;
          startTime: number;
          start: number;
          end: number;
        }> = [];

        result.alternatives[0].words.forEach((wordData: any, i: number) => {
          const wordStartSeconds = parseFloat(wordData.startTime?.seconds || 0);
          const nextWord = result.alternatives[0].words[i + 1];
          const nextWordStartSeconds = nextWord 
            ? (parseFloat(nextWord.startTime?.seconds || 0)) 
            : null;
          
          const wordText = wordData.word;
          const speakerTag = wordData.speakerTag || null;

          if (transcript.trim() === "") {
            currentStartTime = wordStartSeconds;
            currentSpeaker = speakerTag;
          }

          transcript = transcript + " " + wordText;
          
          speakerSegments.push({
            word: wordText,
            speakerTag: speakerTag,
            startTime: wordStartSeconds,
            start: wordStartSeconds,
            end: parseFloat(wordData.endTime?.seconds || wordStartSeconds)
          });

          if (nextWordStartSeconds !== null) {
            const duration = nextWordStartSeconds - currentStartTime;
            const ndnextWord = result.alternatives[0].words[i + 2];
            const ndnextWordStartSeconds = ndnextWord 
              ? (parseFloat(ndnextWord.startTime?.seconds || 0)) 
              : null;
            const ndDuration = ndnextWordStartSeconds 
              ? (ndnextWordStartSeconds - nextWordStartSeconds + duration) 
              : null;

            if (
              (minBinSize <= duration && duration <= maxBinSize) ||
              (ndDuration && ndDuration > maxBinSize)
            ) {
              const newCaption: CaptionModel = {
                start: formatTime(currentStartTime),
                dur: formatTime(nextWordStartSeconds),
                text: transcript.trim(),
                speakerTag: currentSpeaker,
                words: speakerSegments.map(s => ({
                  word: s.word,
                  speakerTag: s.speakerTag,
                  startTime: s.startTime
                }))
              };

              captions.push(newCaption);

              currentStartTime = nextWordStartSeconds;
              transcript = "";
              speakerSegments = [];
            }
          }
        });

        if (transcript.trim() !== "") {
          const lastWord = result.alternatives[0].words[result.alternatives[0].words.length - 1];
          const lastWordEndSeconds = parseFloat(lastWord.endTime?.seconds || 0);
          const duration = lastWordEndSeconds - currentStartTime;

          if (duration > 0) {
            const newCaption: CaptionModel = {
              start: formatTime(currentStartTime),
              dur: formatTime(lastWordEndSeconds),
              text: transcript.trim(),
              speakerTag: currentSpeaker,
              words: speakerSegments.map(s => ({
                word: s.word,
                speakerTag: s.speakerTag,
                startTime: s.startTime
              }))
            };
            captions.push(newCaption);
          }
        }
      });
    }

    return captions;
  } catch (error) {
    console.error("Error parsing transcription with speakers:", error);
    return [];
  }
}

// Function to get speaker color
const getSpeakerColor = (speakerTag: number | null | undefined): string => {
  if (!speakerTag) return DEFAULT_SPEAKER_COLOR;
  // Use editable colors if available, fallback to default
  return speakerColors.value[speakerTag] || SPEAKER_COLORS[speakerTag] || DEFAULT_SPEAKER_COLOR;
};

// Function to update speaker color
const updateSpeakerColor = (speakerTag: number, color: string) => {
  speakerColors.value[speakerTag] = color;
};

function generateFileName(source: boolean): string {
  let fileName: string = `Subtitles.tech-youtube_${extractVideoId(
    userInput.value
  )}_`;
  if (source) {
    fileName += `${originalLanguage.value.langName}`;
  } else {
    fileName += `${translationLanguage.value.langName}`;
  }
  return fileName;
}

const handleEditedCaptionsTranslation = async () => {
  if (!hasWebVttCaptions(originalVideoSubtitle.value)) {
    toast(t("no-captions-available"), {
      autoClose: 3000,
      type: "error",
      theme: "light",
    });
    return;
  }
  const parseSRT = (srt: string) => {
    return srt.split("\n\n").reduce((acc, block) => {
      const [index, timestamp, ...textLines] = block.split("\n");
      if (index && timestamp) {
        acc[timestamp] = { index, text: textLines.join("\n") };
      }
      return acc;
    }, {} as Record<string, { index: string; text: string }>);
  };

  const originalCaptions = parseSRT(ys.prebuildVideoSubtitle);
  const editedCaptions = parseSRT(originalVideoSubtitle.value);

  const updates: { timestamp: string; text?: string; newText?: string }[] = [];
  for (const timestamp in editedCaptions) {
    const updatedCaption = editedCaptions[timestamp];
    const originalCaption = originalCaptions[timestamp];

    if (!originalCaption) {
      updates.push({ timestamp, newText: updatedCaption.text });
    } else if (updatedCaption.text !== originalCaption.text) {
      updates.push({
        timestamp,
        text: originalCaption.text,
        newText: updatedCaption.text,
      });
    }
  }

  const translateCaptionss = async (
    captions: { timestamp: string; newText: string }[]
  ) => {
    return await Promise.all(
      captions.map(async (caption) => {
        const translatedText = await translateSentence(caption.newText);
        return { timestamp: caption.timestamp, translatedText };
      })
    );
  };

  const captionsToTranslate = updates
    .filter((update) => update.newText !== undefined)
    .map((update) => ({
      timestamp: update.timestamp,
      newText: update.newText!,
    }));

  const translations = await translateCaptionss(captionsToTranslate);

  const translatedUpdates = updates.map((update) => {
    const translation = translations.find(
      (t) => t.timestamp === update.timestamp
    );
    return {
      timestamp: update.timestamp,
      translatedText: translation ? translation.translatedText : undefined,
    };
  });

  let translatedContent = ys.translatedVideoSubtitle;
  translatedUpdates.forEach(({ timestamp, translatedText }) => {
    const regex = new RegExp(`(${timestamp}\\n)[^\n]+`, "g");
    const existingCaptionMatch = translatedContent.match(regex);
    console.log(translatedText);

    if (translatedText && existingCaptionMatch) {
      translatedContent = translatedContent.replace(
        regex,
        `$1${translatedText}`
      );
    } else if (translatedText && !existingCaptionMatch) {
      translatedContent += `\n${editedCaptions[timestamp].index}\n${timestamp}\n${translatedText}\n`;
    }
    console.log(translatedContent);
  });
  ys.translatedVideoSubtitle = translatedContent;
  ys.prebuildVideoSubtitle = originalVideoSubtitle.value;
  ys.defaultTranslatedVideoSubtitle = translatedContent;
  const { original: paddedOriginal, translated: paddedTranslated } =
    padCaptionsToEqualLines(
      originalVideoSubtitle.value,
      translatedVideoSubtitle.value
    );
  translatedVideoSubtitle.value = paddedTranslated;
};

const setPlaybackSpeed = (speed: number) => {
  playbackSpeed.value = speed;
  if (audioElement.value) {
    audioElement.value.playbackRate = speed;
  }
};
const setPlaybackSpeedTranslated = (speed: number) => {
  playbackSpeedTranslated.value = speed;
  if (audioElementTranslated.value) {
    audioElementTranslated.value.playbackRate = speed;
  }
};

const speakText = async (translated: boolean) => {
  try {
    if (isAudioLoading.value) return;
    if (isPlaying.value) {
      audioElement.value?.pause();
      audioElementTranslated.value?.pause();
      isPlaying.value = false;
      playOriginalAudio.value = false;
      playTranslationAudio.value = false;
      return;
    }
    if (translated) {
      if (showTranslatedSummarized.value) return;
    } else {
      if (showOriginalSummarized.value) return;
    }
    if (
      (translated && ys.translatedText.length == 0) ||
      (!translated && originalText.value.length == 0)
    ) {
      toast(t("text-to-speech-cannot-be-used-with"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }

    if (
      (translated &&
        unsupportedCloudTts.includes(ys.translationLanguage.langCode)) ||
      (!translated &&
        unsupportedCloudTts.includes(originalLanguage.value.langCode))
    ) {
      toast(t("the-selected-language-is-currently"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }

    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }
    playOriginalAudio.value = !translated;
    playTranslationAudio.value = translated;
    const lengthText = translated
      ? translatedText.value.length
      : originalText.value.length;

    /* if (lengthText > 5000) {
      toast(t("your-text-exceeds-the-5-000-character"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    } */

    const canProceed = await computeTtsCost(userSubscription, lengthText);
    if (!canProceed) {
      return;
    }

    let langCode;
    if (translated) {
      langCode = translationLanguage.value.langCode;
      langCode = languageCodeMappings.tts[langCode] || langCode;
    } else {
      langCode = originalLanguage.value.langCode;
      langCode = languageCodeMappings.tts[langCode] || langCode;
    }

    isAudioLoading.value = true;
    const response = await fetch(speakTextUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        text: translated ? ys.translatedText : originalText.value,
        language: langCode,
        gender: translated
          ? selectedVoiceTranslated.value
          : selectedVoice.value,
      }),
    });
    const result = await response.json();

    if (response.ok && result.audioContent) {
      if (translated) {
        audioContentTranslated.value = result.audioContent;
        audioSourceTranslated.value!.src = `data:audio/mpeg;base64,${result.audioContent}`;
        audioElementTranslated.value!.load();
        audioElementTranslated.value!.playbackRate =
          playbackSpeedTranslated.value;

        audioElementTranslated.value!.onplay = () => {
          isPlaying.value = true;
          isAudioLoading.value = false;
        };

        audioElementTranslated.value!.onpause = () => {
          isPlaying.value = false;
          playOriginalAudio.value = false;
          playTranslationAudio.value = false;
        };

        audioElementTranslated.value!.onended = () => {
          isPlaying.value = false;
          playOriginalAudio.value = false;
          playTranslationAudio.value = false;
          isAudioLoading.value = false;
        };

        audioElementTranslated.value!.onerror = () => {
          console.error(
            `[${new Date().toISOString()}] Audio element error, code=${
              audioElementTranslated.value!.error?.code
            }, message=${audioElementTranslated.value!.error?.message}`
          );
          isPlaying.value = false;
          isAudioLoading.value = false;
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 1500,
            type: "error",
            theme: "light",
          });
        };

        audioElementTranslated.value!.play().catch((err) => {
          console.error(
            `[${new Date().toISOString()}] Play error:`,
            err.message
          );
          isAudioLoading.value = false;
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 1500,
            type: "error",
            theme: "light",
          });
        });
      } else {
        audioContent.value = result.audioContent;
        audioSource.value!.src = `data:audio/mpeg;base64,${result.audioContent}`;
        audioElement.value!.load();
        audioElement.value!.playbackRate = playbackSpeed.value;

        audioElement.value!.onplay = () => {
          isPlaying.value = true;
          isAudioLoading.value = false;
        };

        audioElement.value!.onpause = () => {
          isPlaying.value = false;
          playOriginalAudio.value = false;
          playTranslationAudio.value = false;
        };

        audioElement.value!.onended = () => {
          isPlaying.value = false;
          playOriginalAudio.value = false;
          playTranslationAudio.value = false;
          isAudioLoading.value = false;
        };

        audioElement.value!.onerror = () => {
          console.error(
            `[${new Date().toISOString()}] Audio element error, code=${
              audioElement.value!.error?.code
            }, message=${audioElement.value!.error?.message}`
          );
          isPlaying.value = false;
          isAudioLoading.value = false;
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 1500,
            type: "error",
            theme: "light",
          });
        };

        audioElement.value!.play().catch((err) => {
          console.error(
            `[${new Date().toISOString()}] Play error:`,
            err.message
          );
          isAudioLoading.value = false;
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 1500,
            type: "error",
            theme: "light",
          });
        });
      }
    } else {
      let errorMessage = t("something-went-wrong");
      if (result.error) {
        switch (result.error) {
          case "Subscription required. Please upgrade your plan.":
            errorMessage = t("subscription-required-please-upgrade-your-plan");
            break;
          case "Your subscription has expired. Please renew your subscription.":
            errorMessage = t(
              "your-subscription-has-expired-please-renew-your-subscription"
            );
            break;
          case "This combination of language and gender is not supported":
            errorMessage = t("this-combination-of-language-and");
            break;
          case "The balance is insufficient":
            errorMessage = t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            );
            break;
          case "Invalid token":
          case "Authorization header missing":
            toast(
              t("your-session-has-expired-please-log-in-again-to-continue"),
              {
                autoClose: 2500,
                type: "error",
                theme: "light",
              }
            );
            await new Promise((resolve) => setTimeout(resolve, 2500));
            authStore.logout();
            router.push("/signing");
            return;
          case "Internal Server Error":
            toast(t("were-fixing-a-technical-issue-so-please-try"), {
              autoClose: 3000,
              type: "error",
              theme: "light",
            });
            break;
          default:
            toast(t("were-fixing-a-technical-issue-so-please-try"), {
              autoClose: 3000,
              type: "error",
              theme: "light",
            });
            break;
        }
      }
      toast(errorMessage, {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      isAudioLoading.value = false;
    }
  } catch (error) {
    console.log(error);
    isAudioLoading.value = false;
    toast(t("something-went-wrong"), {
      autoClose: 1500,
      type: "error",
      theme: "light",
    });
  }
};

const filteredLanguages = () => {
  if (searchQuery.value.length == 0) {
    ys.myLanguagesList = languages;
  } else {
    const lowerCaseQuery = searchQuery.value.toLowerCase();
    ys.myLanguagesList = languages.filter((langs) =>
      langs.langName.toLowerCase().includes(lowerCaseQuery)
    );
  }
};

const resetFilter = () => {
  ys.searchQuery = "";
  ys.myLanguagesList = languages;
};

const toggleCaption = (index: any) => {
  if (index == false) {
    isCaptionOn.value = !isCaptionOn.value;
  } else {
    ys.captions = availableCaptions.value.find(
      (cc) => cc.language === index
    )?.captions!;
    ys.activeCaptionLang = index;
    loadCachedDubbingsOnly();
  }
  if (isCaptionsLangsDropOpen.value) {
    isCaptionsLangsDropOpen.value = false;
  }
};

async function loadCachedDubbingsOnly() {
  if (!currentRequestId?.value && !userInput.value) {
    console.log("No requestId or inputLink provided, skipping cache load");
    return;
  }
  ys.activeAudioDubbing = [];

  let db: IDBPDatabase;
  try {
    db = await initDB();
  } catch (e) {
    console.error("Failed to initialize IndexedDB:", e);
    return;
  }
  let cache: CacheEntry[] = [];
  try {
    cache = (await db.transaction("cache").objectStore("cache").getAll()) || [];
  } catch (e) {
    console.error("Failed to load cache from IndexedDB:", e);
    return;
  }
  const entry = cache.find(
    (item) =>
      (currentRequestId.value && item.requestId === currentRequestId.value) ||
      (userInput.value && item.inputLink === userInput.value)
  );

  const trLang = languages.find(
    (l: Language) => l.langName === activeCaptionLang.value
  );
  let langCode = trLang?.langCode || "en";

  if (!entry || !entry.languages[langCode]) {
    console.log("No cached data found for the specified language");
    return;
  }
  const { captions: cachedCaptions, dubbings: cachedDubbings } =
    entry.languages[langCode];
  if (cachedDubbings && Object.keys(cachedDubbings).length) {
    ys.activeAudioDubbing = cachedDubbings;
  }
}

const toggleDownloadTypes = () => {
  if (originalText.value.length === 0) return;
  showDownloadTypes.value = !showDownloadTypes.value;
};

const toggleDownloadTranslatedTypes = () => {
  if (translatedText.value.length === 0) return;
  showDownloadTranslatedTypes.value = !showDownloadTranslatedTypes.value;
};

const toggleDownloadSRTTypes = () => {
  if (originalVideoSubtitle.value.length === 0) return;
  showDownloadSRTTypes.value = !showDownloadSRTTypes.value;
};

const toggleDownloadTranslatedSRTTypes = () => {
  if (translatedVideoSubtitle.value.length === 0) return;
  showDownloadTranslatedSRTTypes.value = !showDownloadTranslatedSRTTypes.value;
};

const selectOnlyThis = (event: Event) => {
  try {
    const target = event.target as HTMLInputElement;
    if (!target) return;
    const checkboxes = Array.from(
      document.querySelectorAll('input[type="checkbox"]')
    ).filter(
      (checkbox) => !(checkbox as HTMLInputElement).id.includes("-translated")
    );

    const checkedCount = checkboxes.filter(
      (checkbox) => (checkbox as HTMLInputElement).checked
    ).length;

    if (checkedCount === 0 && target.checked === false) {
      target.checked = true;
      return;
    }

    checkboxes.forEach((checkbox: any) => {
      if (checkbox !== event.target) {
        checkbox.checked = false;
      }
    });
    selectedVoice.value = target.value;
  } catch (error) {
    console.log("selectOnlyThis:", error);
  }
};

const selectOnlyThisTranslation = (event: Event) => {
  try {
    const target = event.target as HTMLInputElement;
    if (!target) return;
    const checkboxes = Array.from(
      document.querySelectorAll('input[type="checkbox"]')
    ).filter((checkbox) =>
      (checkbox as HTMLInputElement).id.includes("-translated")
    );

    const checkedCount = checkboxes.filter(
      (checkbox) => (checkbox as HTMLInputElement).checked
    ).length;

    if (checkedCount === 0 && target.checked === false) {
      target.checked = true;
      return;
    }

    checkboxes.forEach((checkbox: any) => {
      if (checkbox !== event.target) {
        checkbox.checked = false;
      }
    });
    selectedVoiceTranslated.value = target.value;
  } catch (error) {
    console.log("selectOnlyThis:", error);
  }
};

const handleTranslatedCheckbox = (event: any) => {
  try {
    translatedChecked.value = event.target.checked;
  } catch (error) {
    console.log("handleTranslatedCheckbox:", error);
  }
};

const handleIgnoreSrtCheckbox = (event: any) => {
  try {
    event.stopPropagation();
    downloadOnlySentencesSrt.value = event.target.checked;
  } catch (error) {
    console.log("handleIgnoreSrtCheckbox:", error);
  }
};

const cutLongText = (text: string, long: number): string => {
  return text.length > long ? text.slice(0, long) + "..." : text;
};

const updateTextSize = () => {
  if (fontSizePercent.value == 35) {
    fontSizeClass.value = "text-xs";
    fontSizeNumber.value = 8;
  } else if (fontSizePercent.value == 40) {
    fontSizeClass.value = "text-sm";
    fontSizeNumber.value = 10;
  } else if (fontSizePercent.value == 45) {
    fontSizeClass.value = "text-base";
    fontSizeNumber.value = 12;
  } else if (fontSizePercent.value == 50) {
    fontSizeClass.value = "text-lg";
    fontSizeNumber.value = 14;
  } else if (fontSizePercent.value == 55) {
    fontSizeClass.value = "text-xl";
    fontSizeNumber.value = 16;
  } else if (fontSizePercent.value == 60) {
    fontSizeClass.value = "text-2xl";
    fontSizeNumber.value = 18;
  } else if (fontSizePercent.value == 65) {
    fontSizeClass.value = "text-3xl";
    fontSizeNumber.value = 20;
  } else if (fontSizePercent.value == 70) {
    fontSizeClass.value = "text-4xl";
    fontSizeNumber.value = 22;
  } else if (fontSizePercent.value == 75) {
    fontSizeClass.value = "text-5xl";
    fontSizeNumber.value = 24;
  } else if (fontSizePercent.value == 80) {
    fontSizeClass.value = "text-6xl";
    fontSizeNumber.value = 26;
  } else if (fontSizePercent.value == 85) {
    fontSizeClass.value = "text-7xl";
    fontSizeNumber.value = 28;
  } else if (fontSizePercent.value == 90) {
    fontSizeClass.value = "text-8xl";
    fontSizeNumber.value = 30;
  } else if (fontSizePercent.value == 95) {
    fontSizeClass.value = "text-9xl";
    fontSizeNumber.value = 32;
  }
};

const updateCaptionsTextSize = () => {
  if (fontSizePercentCaptions.value == 35) {
    fontSizeClassCaptions.value = "text-xs";
    fontSizeNumberCaptions.value = 8;
  } else if (fontSizePercentCaptions.value == 40) {
    fontSizeClassCaptions.value = "text-sm";
    fontSizeNumberCaptions.value = 10;
  } else if (fontSizePercentCaptions.value == 45) {
    fontSizeClassCaptions.value = "text-base";
    fontSizeNumberCaptions.value = 12;
  } else if (fontSizePercentCaptions.value == 50) {
    fontSizeClassCaptions.value = "text-lg";
    fontSizeNumberCaptions.value = 14;
  } else if (fontSizePercentCaptions.value == 55) {
    fontSizeClassCaptions.value = "text-xl";
    fontSizeNumberCaptions.value = 16;
  } else if (fontSizePercentCaptions.value == 60) {
    fontSizeClassCaptions.value = "text-2xl";
    fontSizeNumberCaptions.value = 18;
  } else if (fontSizePercentCaptions.value == 65) {
    fontSizeClassCaptions.value = "text-3xl";
    fontSizeNumberCaptions.value = 20;
  } else if (fontSizePercentCaptions.value == 70) {
    fontSizeClassCaptions.value = "text-4xl";
    fontSizeNumberCaptions.value = 22;
  } else if (fontSizePercentCaptions.value == 75) {
    fontSizeClassCaptions.value = "text-5xl";
    fontSizeNumberCaptions.value = 24;
  }
};

const decreaseFontSize = () => {
  try {
    if (fontSizePercent.value == 35) return;
    fontSizePercent.value -= 5;
    updateTextSize();
    //updateTextTrackStyles();
  } catch (error) {
    console.log("decreaseFontSize:", error);
  }
};

const decreaseFontCaptionsSize = () => {
  try {
    if (fontSizePercentCaptions.value == 35) return;
    fontSizePercentCaptions.value -= 5;
    updateCaptionsTextSize();
    //updateTextTrackStyles();
  } catch (error) {
    console.log("decreaseFontSize:", error);
  }
};

const showFontFamilyList = () => {
  fontFamilyListShow.value = !fontFamilyListShow.value;
};

const showFontFamilyListCaptions = () => {
  fontFamilyListShowCaptions.value = !fontFamilyListShowCaptions.value;
};

const updateFontFamily = (selectedFont: string) => {
  fontFamily.value = selectedFont;
};

async function applyFont(fontName:string) {
  const font:any = fontStore.fonts.find((f:any) => f.name === fontName);
  if (font) {
    await loadGoogleFont(fontName, font.files.regular);
    fontFamily.value = fontName;
    prefStore.setFontPreference({
      name: fontName,
      url: font.files.regular,
      variant: "regular",
    });
  }
  showFontFamilyList();
}

async function updatePreviewFont(fontName:string, fontUrl:string) {
  selectedPreviewFont.value = fontName;
  await loadGoogleFont(fontName, fontUrl);
}

async function updatePreviewFontCaptions(fontName: string, fontUrl: string) {
  selectedPreviewFontCaption.value = fontName;
  await loadGoogleFont(fontName, fontUrl);
}

async function applyFontCaptions(fontName: string) {
  const font: any = fontStore.fonts.find((f: any) => f.name === fontName);
  if (font) {
    await loadGoogleFont(fontName, font.files.regular);
    fontFamilyCaptions.value = fontName;
  }
  showFontFamilyListCaptions();
}

const updateFontFamilyCaptions = (selectedFont: string) => {
  fontFamilyCaptions.value = selectedFont;
};

const getLanguageName = (code: string) => {
  return (
    languages.find((language: Language) => language.langCode === code)
      ?.langName || code
  );
};

const getTranslatedFile = async (fileId: string) => {
  try {
    if (!fileId) {
      return;
    }
    const response = await fetch(getTranslatedFileUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        reqId: fileId,
      }),
    });
    const r = await response.json();
    if (!response.ok) {
      switch (r.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        default:
          break;
      }
      return;
    }
    const trLang = languages.find(
      (language) => language.langCode === r.targetLamguage
    ) || {
      langName: "Arabic",
      langCode: "ar",
      countryCode: "sa",
    };
    ys.translationLanguage = { ...trLang };
    ys.translatedText = r.translatedText.translatedText;
    ys.defaultTranslatedText = r.translatedText.translatedText;
  } catch (error) {
    console.error("Error making request to the server:", error);
  }
};

const closeList = () => {
  ys.isOpen = false;
  isTargetListOpen.value = false;
  isTranslationListOpened.value = false;
  resetFilter();
};

const selectTargetLanguage = async (lang: Language) => {
  if (isMultiLanguageMode.value) {
    // Multi-select mode: toggle language selection
    if (lang.langCode === originalLanguage.value.langCode) {
      toast(t("original-and-translation-languages-must-be-different"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }
    
    const existingIndex = selectedTargetLanguages.value.findIndex(
      (l) => l.langCode === lang.langCode
    );
    
    if (existingIndex >= 0) {
      // Remove from selection
      selectedTargetLanguages.value.splice(existingIndex, 1);
    } else {
      // Add to selection
      selectedTargetLanguages.value.push({ ...lang });
    }
    
    // Update translationLanguage to the first selected or current display language
    if (selectedTargetLanguages.value.length > 0) {
      const displayLang = currentDisplayLanguage.value?.langCode
        ? currentDisplayLanguage.value
        : selectedTargetLanguages.value[0];
      ys.translationLanguage = displayLang;
      // If translation exists in cache or bulk translations, show it
      if (bulkTextTranslations.value[displayLang.langCode]) {
        translatedText.value = bulkTextTranslations.value[displayLang.langCode];
        defaultTranslatedText.value = bulkTextTranslations.value[displayLang.langCode];
      } else {
        // Clear translation if switching to a language without translation
        translatedText.value = "";
        defaultTranslatedText.value = "";
      }
    } else {
      ys.translationLanguage = {
        langName: "Arabic",
        langCode: "ar",
        countryCode: "sa",
      };
      translatedText.value = "";
      defaultTranslatedText.value = "";
    }
    ys.isTargetLanguageSelected = selectedTargetLanguages.value.length > 0;
  } else {
    // Single-select mode: original behavior
    if (lang.langCode == originalLanguage.value.langCode) {
      toast(t("original-and-translation-languages-must-be-different"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }
    ys.translationLanguage = { ...lang };
    ys.isTargetLanguageSelected = true;
    
    // Check if translation exists for this language
    if (bulkTextTranslations.value[lang.langCode]) {
      translatedText.value = bulkTextTranslations.value[lang.langCode];
      defaultTranslatedText.value = bulkTextTranslations.value[lang.langCode];
    } else if (translationLanguage.value?.langCode === lang.langCode && translatedText.value && translatedText.value.length > 0) {
      // Keep current translation if it's for the selected language
      // Do nothing, translation already displayed
    } else {
      // Clear translation if switching to a different language without translation
      translatedText.value = "";
      defaultTranslatedText.value = "";
    }
    
    isTargetListOpen.value = false;
    closeList();
    defaultTranslatedVideoSubtitle.value = "";
    translatedVideoSubtitle.value = "";
    loadCachedCaptionsAndDubbings();
  }
};

const navToPayment = () => {
  try {
    activitesStore.setComingFrom("youtubetranscription");
    router.push("/pricing");
  } catch (error) {
    console.log("navToPayment", error);
  }
};

const copyText = (isOriginal: boolean) => {
  let isValueEmpty = false;
  let textToCopy = "";
  if (isOriginal) {
    if (showOriginalSummarized.value) {
      isValueEmpty = originalSummarizedText.value.length == 0;
      textToCopy = originalSummarizedText.value;
    } else {
      isValueEmpty = originalText.value.length == 0;
      textToCopy = originalText.value;
    }
  } else {
    if (showTranslatedSummarized.value) {
      isValueEmpty = translatedSummarizedText.value.length == 0;
      textToCopy = translatedSummarizedText.value;
    } else {
      isValueEmpty = translatedText.value.length == 0;
      textToCopy = translatedText.value;
    }
  }
  if (isValueEmpty) {
    return;
  }
  navigator.clipboard
    .writeText(textToCopy)
    .then(() => {
      toast(t("text-copied-to-clipboard"), {
        autoClose: 1500,
        type: "success",
        theme: "light",
      });
    })
    .catch((error) => {
      toast(t("failed-to-copy-text-please-try-again"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      console.error("Error copying text:", error);
    });
};

const copySubtitle = (isOriginal: boolean) => {
  if (
    isOriginal
      ? originalVideoSubtitle.value.length == 0
      : ys.translatedVideoSubtitle.length == 0
  ) {
    return;
  }
  navigator.clipboard
    .writeText(
      isOriginal ? originalVideoSubtitle.value : ys.translatedVideoSubtitle
    )
    .then(() => {
      toast(t("text-copied-to-clipboard"), {
        autoClose: 1500,
        type: "success",
        theme: "light",
      });
    })
    .catch((error) => {
      toast(t("failed-to-copy-text-please-try-again"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      console.error("Error copying text:", error);
    });
};

function extractSentencesFromWebVTT(webvtt: string): string {
  if (downloadOnlySentencesSrt.value) {
    return webvtt
      .split("\n")
      .filter((line) => !line.match(/^WEBVTT|^\d+$|^\d{2}:\d{2}:\d{2}\.\d{3}/))
      .join("\n")
      .trim();
  } else {
    return webvtt;
  }
}

const downloadWebVttFile = (originalContent: boolean) => {
  if (originalContent) {
    if (originalVideoSubtitle.value.length == 0) {
      return;
    }
    const blob = new Blob(
      [extractSentencesFromWebVTT(originalVideoSubtitle.value)],
      { type: "text/vtt" }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${generateFileName(originalContent)}.vtt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    if (ys.translatedVideoSubtitle.length == 0) {
      return;
    }
    const blob = new Blob(
      [extractSentencesFromWebVTT(ys.translatedVideoSubtitle)],
      {
        type: "text/vtt",
      }
    );
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${generateFileName(originalContent)}.vtt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

const fetchTranslationPrice = async () => {
  try {
    const response = await fetch(getPrices, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
    });
    const result = await response.json();
    if (result.error) {
      ys.computePricing = false;
      return;
    }
    if (result.message == "Success" && result.Prices) {
      ys.textTranslationPrice = result.Prices.text_per_1000_char;
    }
  } catch (error) {
    console.log(error);
  }
};

function translationCostFromDeposit(textLength: number) {
  return textLength * servicesPricing.textTranslation;
}

function ttsCostFromDeposit(textLength: number) {
  return textLength * servicesPricing.textToSpeech;
}

const computeTranslationCost = async (
  translateText: boolean
): Promise<boolean> => {
  return new Promise<boolean>((resolve, reject) => {
    try {
      ys.computePricing = true;
      ys.balanceNotEnough = false;
      let totalLength = 0;
      if (translateText) {
        totalLength = originalText.value.length;
      } else {
        if (
          !hasWebVttCaptions(originalVideoSubtitle.value) ||
          captions.value.length === 0
        ) {
          toast(t("no-captions-available"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          ys.computePricing = false;
          resolve(false);
          return;
        }
        captions.value.forEach((caption: CaptionModel) => {
          totalLength += caption.text.length;
        });
      }
      const userSubscription = profileStore.subscriptionType;
      const currentTimestamp = new Date();
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);

      if (userSubscription === "CONSUMEASYOUPAY") {
        const cost = translationCostFromDeposit(totalLength);
        if (cost <= profileStore.userDeposit) {
          ys.computePricing = false;
          resolve(true);
        } else {
          // Check alternative: textTranslationVolume
          if (currentTimestamp > subscriptionEndDate) {
            ys.balanceNotEnough = true;
            toast(
              t("your-balance-is-insufficient-please-recharge-to-continue"),
              {
                autoClose: 2500,
                type: "error",
                theme: "light",
              }
            );
            ys.computePricing = false;
            resolve(false);
          }
          const shortfallCost = cost - profileStore.userDeposit;
          const shortfallChars = Math.ceil(
            shortfallCost / servicesPricing.textTranslation
          );
          if (shortfallChars > profileStore.textTranslationVolume) {
            ys.balanceNotEnough = true;
            toast(
              t("your-balance-is-insufficient-please-recharge-to-continue"),
              {
                autoClose: 2500,
                type: "error",
                theme: "light",
              }
            );
            ys.computePricing = false;
            resolve(false);
          } else {
            // Show native confirmation dialog
            modalMessage.value = t("your-deposit-balance-is-not-enough");
            showPaymentModal.value = true;
            modalResolve.value = (confirmed: any) => {
              ys.computePricing = false;
              showPaymentModal.value = false;
              if (confirmed) {
                resolve(true);
              } else {
                ys.balanceNotEnough = true;
                resolve(false);
              }
            };
          }
        }
      } else {
        if (totalLength <= profileStore.textTranslationVolume) {
          ys.computePricing = false;
          resolve(true); // Primary balance sufficient
        } else {
          // Check alternative: userDeposit
          const shortfallChars =
            totalLength - profileStore.textTranslationVolume;
          const shortfallCost = translationCostFromDeposit(shortfallChars);
          if (shortfallCost > profileStore.userDeposit) {
            ys.balanceNotEnough = true;
            toast(
              t("your-balance-is-insufficient-please-recharge-to-continue"),
              {
                autoClose: 2500,
                type: "error",
                theme: "light",
              }
            );
            ys.computePricing = false;
            resolve(false);
          } else {
            // Show native confirmation dialog
            modalMessage.value = t("your-subscription-balance-is-not");
            showPaymentModal.value = true;
            modalResolve.value = (confirmed: any) => {
              ys.computePricing = false;
              showPaymentModal.value = false;
              if (confirmed) {
                resolve(true);
              } else {
                ys.balanceNotEnough = true;
                resolve(false);
              }
            };
          }
        }
      }
    } catch (error) {
      console.log(error);
      ys.computePricing = false;
      ys.balanceNotEnough = false;
      reject(error);
    }
  });
};

const computeTtsCost = async (
  userSubscription: any,
  lengthText: number
): Promise<boolean> => {
  return new Promise<boolean>((resolve, reject) => {
    computePricing.value = true;
    balanceNotEnough.value = false;
    if (userSubscription === "CONSUMEASYOUPAY") {
      const cost = ttsCostFromDeposit(lengthText);
      if (profileStore.userDeposit < cost) {
        const currentTimestamp = new Date(new Date().toISOString());
        const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
        if (currentTimestamp > subscriptionEndDate) {
          balanceNotEnough.value = true;
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          resolve(false);
        }

        const shortfallCost = cost - profileStore.userDeposit;
        const shortfallChars = Math.ceil(
          shortfallCost / servicesPricing.textToSpeech
        );
        if (shortfallChars > profileStore.textToSpeechVolume) {
          balanceNotEnough.value = true;
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          resolve(false);
        }

        modalMessage.value = t("your-deposit-balance-is-not-enough");
        showPaymentModal.value = true;
        modalResolve.value = (confirmed: any) => {
          computePricing.value = false;
          showPaymentModal.value = false;
          if (confirmed) {
            resolve(true);
          } else {
            balanceNotEnough.value = true;
            resolve(false);
          }
        };
      } else {
        resolve(true);
      }
    } else {
      if (profileStore.textToSpeechVolume < lengthText) {
        const shortfallCost = lengthText - profileStore.textToSpeechVolume;
        const shortfallChars = ttsCostFromDeposit(shortfallCost);
        if (shortfallChars > profileStore.userDeposit) {
          balanceNotEnough.value = true;
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          resolve(false);
        }

        modalMessage.value = t("your-subscription-balance-is-not");
        showPaymentModal.value = true;
        modalResolve.value = (confirmed: any) => {
          computePricing.value = false;
          showPaymentModal.value = false;
          if (confirmed) {
            resolve(true);
          } else {
            balanceNotEnough.value = true;
            resolve(false);
          }
        };
      } else {
        resolve(true);
      }
    }
  });
};

const dubbingComputeTtsCost = async (
  userSubscription: any,
  lengthText: number
): Promise<boolean> => {
  return new Promise<boolean>((resolve, reject) => {
    computePricing.value = true;
    balanceNotEnough.value = false;
    if (userSubscription === "CONSUMEASYOUPAY") {
      const cost = ttsCostFromDeposit(lengthText);
      if (profileStore.userDeposit < cost) {
        const currentTimestamp = new Date(new Date().toISOString());
        const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
        if (currentTimestamp > subscriptionEndDate) {
          balanceNotEnough.value = true;
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          resolve(false);
        }

        const shortfallCost = cost - profileStore.userDeposit;
        const shortfallChars = Math.ceil(
          shortfallCost / servicesPricing.textToSpeech
        );
        if (shortfallChars > profileStore.textToSpeechVolume) {
          balanceNotEnough.value = true;
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          resolve(false);
        }

        modalMessage.value = t("your-deposit-balance-is-not-enough");
        if (alreadyAcceptPaymentSwitch.value) {
          resolve(true);
        } else {
          showPaymentModal.value = true;
          modalResolve.value = (confirmed: any) => {
            computePricing.value = false;
            showPaymentModal.value = false;
            if (confirmed) {
              resolve(true);
              alreadyAcceptPaymentSwitch.value = true;
            } else {
              balanceNotEnough.value = true;
              alreadyAcceptPaymentSwitch.value = false;
              resolve(false);
            }
          };
        }
      } else {
        resolve(true);
      }
    } else {
      if (profileStore.textToSpeechVolume < lengthText) {
        const shortfallCost = lengthText - profileStore.textToSpeechVolume;
        const shortfallChars = ttsCostFromDeposit(shortfallCost);
        if (shortfallChars > profileStore.userDeposit) {
          balanceNotEnough.value = true;
          toast(t("your-balance-is-insufficient-please-recharge-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          resolve(false);
        }

        modalMessage.value = t("your-subscription-balance-is-not");
        if (alreadyAcceptPaymentSwitch.value) {
          resolve(true);
        } else {
          showPaymentModal.value = true;
          modalResolve.value = (confirmed: any) => {
            computePricing.value = false;
            showPaymentModal.value = false;
            if (confirmed) {
              alreadyAcceptPaymentSwitch.value = true;
              resolve(true);
            } else {
              balanceNotEnough.value = true;
              alreadyAcceptPaymentSwitch.value = false;
              resolve(false);
            }
          };
        }
      } else {
        resolve(true);
      }
    }
  });
};

const extractText = (data: any) => {
  try {
    let concatenatedTranscript = "";
    data.forEach((caption: any) => {
      let text = caption["text"]!.trim();
      concatenatedTranscript += text + " ";
    });
    return concatenatedTranscript.trim();
  } catch (error) {
    console.log(error);

    return "";
  }
};

const destroyVideoPlayer = () => {
  if (player.value && typeof player.value.destroy === "function") {
    player.value.destroy();
    player.value = null;
  }
};

const initYouTubePlayer = (videoId: string): Promise<void> => {
  if (player.value && typeof player.value.destroy === "function") {
    player.value.destroy();
    player.value = null;
  }
  return new Promise((resolve) => {
    player.value = new window.YT.Player("ytPlayer", {
      width: "100%",
      height: "100%",
      videoId: videoId,
      playerVars: {
        //controls: 0,
        fs: 0,
      },
      events: {
        onReady: () => {
          ys.hasVideo = true;
          ys.isLoading = false;
          resolve();
        },
        onStateChange: (event: any) => {
          if (event.data === 1) {
            if (ys.intervalId !== null) {
              clearInterval(ys.intervalId);
            }
            ys.intervalId = setInterval(async () => {
              ys.currentTime = player?.value.getCurrentTime() || 0;
              updateCurrentCaptions(ys.currentTime);

              // Check if we need to fetch more chunks
              if (dubbingEnabled.value) {
                console.log("dubbing emanbled ---------------");

                const isOriginalText = false; // Adjust based on user selection
                await checkAndFetchNextChunk(currentTime.value, isOriginalText);

                // Play audio for current time
                const audioInfo = getAudioForTime(
                  currentTime.value,
                  isOriginalText
                );
                if (
                  audioInfo &&
                  (!currentAudioElement ||
                    currentAudioElement.src !== audioInfo.base64)
                ) {
                  if (currentAudioElement) {
                    currentAudioElement.pause();
                    currentAudioElement = null;
                  }

                  currentAudioElement = new Audio(audioInfo.base64);
                  currentAudioElement.volume = 1.0;

                  // Adjust playback speed
                  const audioMap = ys.activeAudioDubbing;
                  const nextTime =
                    Object.keys(audioMap)
                      .map(Number)
                      .sort((a, b) => a - b)
                      .find((t) => t > audioInfo.startTime) || null;

                  await adjustPlaybackSpeed(
                    currentAudioElement,
                    audioInfo.startTime,
                    audioInfo.endTime,
                    nextTime
                  );

                  //currentAudioElement.currentTime = Math.max(0, (currentTime.value * 1000 - audioInfo.startTime) / 1000);
                  currentAudioElement.play().catch((error) => {
                    console.error("Audio play failed:", error);
                  });
                }
              }
            }, 1000);
            if (dubbingEnabled.value) {
              if (dubbingAudioElement) {
                // Sync audio to video time (in case of seek before play)
                dubbingAudioElement.currentTime =
                  player?.value.getCurrentTime();
                dubbingAudioElement.play().catch((error: any) => {
                  console.error("Audio play failed:", error);
                });
              }
            }
          } else if (event.data === 0 || event.data === 2) {
            if (ys.intervalId !== null) {
              clearInterval(ys.intervalId);
              ys.intervalId = null;
            }
          }
        },
      },
    });
  });
};

function subtitleGenerationFromCaption(captionsResponse: any): string {
  try {
    const captions: CaptionModel[] = [];
    captionsResponse.forEach((result: any) => {
      if (!result.text) {
        return;
      }
      const text = result.text.trim();
      if (text.length === 0) {
        return;
      }
      const newCaption: CaptionModel = {
        start: formatTime(parseFloat(result.start)),
        dur: formatTime(parseFloat(result.start) + parseFloat(result.dur)),
        text: text,
      };
      captions.push(newCaption);
    });

    // Format captions into WebVTT
    let webvttContent = "WEBVTT\n\n";
    captions.forEach((caption, index) => {
      webvttContent += `${index + 1}\n${caption.start} --> ${caption.dur}\n${
        caption.text
      }\n\n`;
    });
    return webvttContent;
  } catch (error) {
    console.error("Error processing captions:", error);
    return "";
  }
}

// Handle hint input - auto-expand if user starts typing
const handleHintInput = () => {
  if (translationHint.value && translationHint.value.trim().length > 0 && !showHintInput.value) {
    showHintInput.value = true;
  }
};

// Save hint and close popup
const saveHintAndClose = () => {
  if (translationHint.value && translationHint.value.trim().length > 0) {
    showHintPopup.value = false;
    toast(
      t("context-hint-saved") || `Context hint saved: "${translationHint.value.trim()}"`,
      {
        autoClose: 2000,
        type: "success",
        theme: "light",
      }
    );
  }
};

function formatTime(seconds: number): string {
  const date = new Date(seconds * 1000);
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");
  const secondsFormatted = date.getSeconds().toString().padStart(2, "0");
  const milliseconds = (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5);
  return `${hours}:${minutes}:${secondsFormatted}.${milliseconds}`;
}

const translateCaptions = async () => {
  try {
    if (
      originalVideoSubtitle.value.trim().length === 0 ||
      !hasWebVttCaptions(originalVideoSubtitle.value)
    ) {
      toast(t("no-captions-available"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (
      originalLanguage.value.langCode === translationLanguage.value.langCode
    ) {
      toast(
        t(
          "translation-language-matches-the-original-please-choose-a-different-language"
        ),
        {
          autoClose: 1500,
          type: "error",
          theme: "light",
        }
      );
      return;
    }
    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }
    isTranslatingCaptions.value = true;
    if (latestTranslationTarget.value === translationLanguage.value.langCode) {
      if (defaultOriginalVideoSubtitle.value != originalVideoSubtitle.value) {
        if (ys.translatedVideoSubtitle.length != 0) {
          await handleEditedCaptionsTranslation();
          return;
        }
      }
    }
    // translate captions
    const canProceed = await computeTranslationCost(false);
    if (!canProceed) {
      return;
    }

    // NOTE: the context hint applies to TEXT translation only (translateTextGPT
    // endpoint). Captions always use the standard endpoint.
    const endpointUrl = translateCpationUrl;

    let body;
    if (ys.activeCaptionLang != originalLanguage.value.langName) {
      ys.captions = availableCaptions.value.find(
        (cc) => cc.language === originalLanguage.value.langName
      )?.captions!;
      ys.activeCaptionLang = originalLanguage.value.langName;
    }
    const capList = captions.value.map((caption) => caption.text);
    if (!capList.some((text) => text.trim().length > 0)) {
      toast(t("no-captions-available"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (defaultOriginalVideoSubtitle.value === originalVideoSubtitle.value) {
      body = JSON.stringify({
        captionsList: capList,
        from: originalLanguage.value.langCode,
        to: ys.translationLanguage.langCode,
        isOriginalText: true,
        externelLink: ys.userInput,
      });
    } else {
      body = JSON.stringify({
        captionsList: capList,
        from: originalLanguage.value.langCode,
        to: ys.translationLanguage.langCode,
      });
    }
    const responsed = await fetch(endpointUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: body,
    });
    const translatedCaptions = await responsed.json();
    if (!responsed.ok) {
      if (
        translatedCaptions.error &&
        String(translatedCaptions.error).toLowerCase().includes("captions list")
      ) {
        toast(t("no-captions-available"), {
          autoClose: 3000,
          type: "error",
          theme: "light",
        });
        return;
      }
      switch (translatedCaptions.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        case "Subscription required. Please upgrade your plan.":
          toast(t("subscription-required-please-upgrade-your-plan"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Your subscription has expired. Please renew your subscription.":
          toast(
            t("your-subscription-has-expired-please-renew-your-subscription"),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "The balance is insufficient":
          toast(
            t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            ),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "Internal Server Error":
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
      }
      return;
    }
    const translatedLines = translatedCaptions?.translatedText;
    if (!Array.isArray(translatedLines) || translatedLines.length === 0) {
      toast(t("no-captions-available"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }
    ys.captions.forEach((caption, index) => {
      caption.text = translatedLines[index];
    });
    const newCaptions = JSON.parse(JSON.stringify(ys.captions));
    const index = availableCaptions.value.findIndex(
      (caption) => caption.language === ys.translationLanguage.langName
    );
    if (index !== -1) {
      availableCaptions.value[index].captions = newCaptions;
    } else {
      availableCaptions.value.push({
        language: ys.translationLanguage.langName,
        captions: newCaptions,
      });
    }
    ys.activeCaptionLang = ys.translationLanguage.langName;
    ys.translatedVideoSubtitle = subtitleGenerationFromCaption(ys.captions);
    ys.defaultTranslatedVideoSubtitle = subtitleGenerationFromCaption(
      ys.captions
    );
    await profileStore.getUserSubscription(authStore.token!);
    const { original: paddedOriginal, translated: paddedTranslated } =
      padCaptionsToEqualLines(
        originalVideoSubtitle.value,
        translatedVideoSubtitle.value
      );
    latestTranslationTarget.value = translationLanguage.value.langCode;
    translatedVideoSubtitle.value = paddedTranslated;
    cacheCaptionsAndDubbings();
  } catch (error) {
    console.error("Error making request to the server:", error);
  } finally {
    isTranslatingCaptions.value = false;
  }
};

const translateSentence = async (text: string): Promise<string | undefined> => {
  try {
    const canProceed = await computeTranslationCost(true);
    if (!canProceed) {
      return undefined;
    }
    // Use GPT endpoint if context hint is provided
    const useGPT = translationHint.value && translationHint.value.trim().length > 0;
    const endpointUrl = useGPT ? translateTextGPTUrl : translateTextUrl;
    
    // translate text
    const response = await fetch(endpointUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: JSON.stringify({
        originalText: text,
        from: originalLanguage.value.langCode,
        to: ys.translationLanguage.langCode,
        ...(useGPT && { context: translationHint.value.trim() }),
      }),
    });

    const results = await response.json();
    if (!response.ok) {
      switch (results.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        case "Subscription required. Please upgrade your plan.":
          toast(t("subscription-required-please-upgrade-your-plan"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Your subscription has expired. Please renew your subscription.":
          toast(
            t("your-subscription-has-expired-please-renew-your-subscription"),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "The balance is insufficient":
          toast(
            t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            ),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "Internal Server Error":
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
      }
      return "";
    }
    await profileStore.getUserSubscription(authStore.token!);
    return results.translatedText;
  } catch (error) {
    console.error("Error making request to the server:", error);
  }
};

// IndexedDB caching for text translations
interface TextCacheEntry {
  id?: number; // Auto-increment ID from IndexedDB
  requestId?: string;
  inputLink?: string;
  languages: Record<string, { textTranslations: string }>;
  created?: number;
}

async function initTextCacheDB(): Promise<IDBPDatabase> {
  return openDB("subtitle_youtubeTextCache", 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("textCache")) {
        db.createObjectStore("textCache", { keyPath: "id", autoIncrement: true });
      }
    },
  });
}

async function saveTextTranslationsToCache(
  translations: Record<string, string>,
  langCodes: string[],
  requestId?: string,
  inputLink?: string
) {
  try {
    const db = await initTextCacheDB();
    const tx = db.transaction("textCache", "readwrite");
    const store = tx.objectStore("textCache");

    let cache: TextCacheEntry[] = [];
    try {
      cache = (await store.getAll()) || [];
    } catch (e) {
      console.error("Failed to load cache from IndexedDB:", e);
    }

    const entryIndex = cache.findIndex(
      (item) =>
        (requestId && item.requestId === requestId) ||
        (inputLink && item.inputLink === inputLink)
    );
    const entry: TextCacheEntry =
      entryIndex >= 0
        ? cache[entryIndex]
        : { requestId, inputLink, languages: {}, created: Date.now() };

    // Update language data with text translations
    langCodes.forEach((langCode) => {
      if (translations[langCode]) {
        if (!entry.languages[langCode]) {
          entry.languages[langCode] = { textTranslations: "" };
        }
        entry.languages[langCode].textTranslations = translations[langCode];
      }
    });

    // Use put() to update existing entry or add new one
    // This is more efficient than clear() + add() and avoids potential race conditions
    if (entryIndex >= 0 && cache[entryIndex].id) {
      // Update existing entry
      entry.id = cache[entryIndex].id; // Preserve the ID for update
      await store.put(entry);
    } else {
      // Add new entry (ID will be auto-generated)
      await store.add(entry);
    }
    await tx.done;
  } catch (e) {
    console.error("Failed to save text translations to IndexedDB:", e);
  }
}

async function loadCachedTextTranslations() {
  // Wait a bit to ensure currentRequestId is set (handles race conditions)
  await new Promise(resolve => setTimeout(resolve, 100));
  
  if (!ys.currentRequestId && !ys.userInput) {
    console.log("No requestId or inputLink provided, skipping text cache load");
    return;
  }

  let db: IDBPDatabase;
  try {
    db = await initTextCacheDB();
  } catch (e) {
    console.error("Failed to initialize IndexedDB:", e);
    return;
  }
  let cache: TextCacheEntry[] = [];
  try {
    cache = (await db.transaction("textCache").objectStore("textCache").getAll()) || [];
  } catch (e) {
    console.error("Failed to load cache from IndexedDB:", e);
    return;
  }
  const entry = cache.find(
    (item) =>
      (ys.currentRequestId && item.requestId === ys.currentRequestId) ||
      (ys.userInput && item.inputLink === ys.userInput)
  );

  if (!entry) {
    console.log("No cached text translations found");
    // Clear translations if no cache found for this request
    bulkTextTranslations.value = {};
    return;
  }

  // Load all cached translations into bulkTextTranslations
  const cachedTranslations: Record<string, string> = {};
  Object.keys(entry.languages).forEach((langCode) => {
    if (entry.languages[langCode]?.textTranslations) {
      cachedTranslations[langCode] = entry.languages[langCode].textTranslations;
    }
  });

  if (Object.keys(cachedTranslations).length > 0) {
    // Replace with cached translations (don't merge - this is a fresh load for a specific request)
    bulkTextTranslations.value = cachedTranslations;
    
    // Preserve current display language if it has a cached translation, otherwise use first available
    const currentLangCode = currentDisplayLanguage.value?.langCode;
    const langToDisplay = (currentLangCode && cachedTranslations[currentLangCode])
      ? languages.find((l) => l.langCode === currentLangCode)
      : languages.find((l) => l.langCode === Object.keys(cachedTranslations)[0]);
    
    if (langToDisplay) {
      currentDisplayLanguage.value = langToDisplay;
      ys.translationLanguage = langToDisplay;
      translatedText.value = cachedTranslations[langToDisplay.langCode];
      defaultTranslatedText.value = cachedTranslations[langToDisplay.langCode];
    }
  } else {
    // Clear translations if no cache found for this request
    bulkTextTranslations.value = {};
  }
}

// Watch for mode toggle to handle state properly
watch(
  () => isMultiLanguageMode.value,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      // When switching to single-select mode, clear multi-select selections
      if (!newValue) {
        // Keep the current translation language if it exists
        if (translationLanguage.value?.langCode) {
          // Check if translation exists for current language
          if (bulkTextTranslations.value[translationLanguage.value.langCode]) {
            translatedText.value = bulkTextTranslations.value[translationLanguage.value.langCode];
            defaultTranslatedText.value = bulkTextTranslations.value[translationLanguage.value.langCode];
          }
        }
        // Clear selected languages array but keep current translation language
        selectedTargetLanguages.value = [];
      } else {
        // When switching to multi-select mode, add current translation language to selection if it exists
        if (translationLanguage.value?.langCode && translatedText.value && translatedText.value.length > 0) {
          const currentLang = languages.find((l) => l.langCode === translationLanguage.value.langCode);
          if (currentLang && !selectedTargetLanguages.value.find((l) => l.langCode === currentLang.langCode)) {
            selectedTargetLanguages.value.push({ ...currentLang });
          }
        }
      }
    }
  }
);

const translateTextBulk = async () => {
  try {
    if (originalText.value.trim().length === 0) {
      toast(t("translation_empty"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (selectedTargetLanguages.value.length === 0) {
      toast(t("please-select-at-least-one-target-language"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }
    // Check if any selected language matches original
    const invalidLang = selectedTargetLanguages.value.find(
      (l) => l.langCode === originalLanguage.value.langCode
    );
    if (invalidLang) {
      toast(t("original-and-translation-languages-must-be-different"), {
        autoClose: 1500,
        type: "error",
        theme: "light",
      });
      return;
    }
    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }
    const canProceed = await computeTranslationCost(true);
    if (!canProceed) {
      return;
    }

    // Use GPT endpoint if context hint is provided
    const useGPT = translationHint.value && translationHint.value.trim().length > 0;
    const endpointUrl = useGPT ? translateTextBulkGPTUrl : translateTextBulkUrl;
    
    const targetLangCodes = selectedTargetLanguages.value.map((l) => l.langCode);
    const body = JSON.stringify({
      originalText: originalText.value,
      from: originalLanguage.value.langCode,
      to: targetLangCodes,
      isOriginalText: originalText.value === defaultOriginalText.value,
      externelLink: originalText.value === defaultOriginalText.value ? ys.userInput : undefined,
      ...(useGPT && { context: translationHint.value.trim() }),
    });

    const response = await fetch(endpointUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: body,
    });

    const results = await response.json();
    console.log(results);
    if (!response.ok) {
      switch (results.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        case "Subscription required. Please upgrade your plan.":
          toast(t("subscription-required-please-upgrade-your-plan"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Your subscription has expired. Please renew your subscription.":
          toast(
            t("your-subscription-has-expired-please-renew-your-subscription"),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "The balance is insufficient":
          toast(
            t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            ),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "Internal Server Error":
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
      }
      return;
    }
    if (results.message === "Success" && results.translations) {
      // Merge new translations with existing ones (don't overwrite existing translations)
      bulkTextTranslations.value = {
        ...bulkTextTranslations.value,
        ...results.translations,
      };
      
      // Save to cache
      await saveTextTranslationsToCache(
        results.translations,
        targetLangCodes,
        ys.currentRequestId || undefined,
        ys.userInput || undefined
      );

      // Display first selected language by default
      const firstLang = selectedTargetLanguages.value[0];
      if (results.translations[firstLang.langCode]) {
        currentDisplayLanguage.value = firstLang;
        ys.translationLanguage = firstLang;
        translatedText.value = results.translations[firstLang.langCode];
        defaultTranslatedText.value = results.translations[firstLang.langCode];
      }
      
      // Clear selected languages after successful translation
      selectedTargetLanguages.value = [];
    } else {
      toast(t("translation-failed"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
    }
    await profileStore.getUserSubscription(authStore.token!);
  } catch (error) {
    console.error("Error making bulk translation request to the server:", error);
    toast(t("were-fixing-a-technical-issue-so-please-try"), {
      autoClose: 3000,
      type: "error",
      theme: "light",
    });
  }
};

const translateText = async () => {
  // If in multi-language mode and has selected languages, use bulk translation
  if (isMultiLanguageMode.value && selectedTargetLanguages.value.length > 0) {
    await translateTextBulk();
    return;
  }

  try {
    if (originalText.value.trim().length === 0) {
      toast(t("translation_empty"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (
      originalLanguage.value.langCode === translationLanguage.value.langCode
    ) {
      toast(
        t(
          "translation-language-matches-the-original-please-choose-a-different-language"
        ),
        {
          autoClose: 1500,
          type: "error",
          theme: "light",
        }
      );
      return;
    }
    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }
    const canProceed = await computeTranslationCost(true);
    if (!canProceed) {
      return;
    }
    // Use GPT endpoint if context hint is provided
    const useGPT = translationHint.value && translationHint.value.trim().length > 0;
    const endpointUrl = useGPT ? translateTextGPTUrl : translateTextUrl;
    
    // translate text
    let body;
    if (originalText.value === defaultOriginalText.value) {
      body = JSON.stringify({
        originalText: originalText.value,
        from: originalLanguage.value.langCode,
        to: ys.translationLanguage.langCode,
        isOriginalText: true,
        externelLink: ys.userInput,
        ...(useGPT && { context: translationHint.value.trim() }),
      });
    } else {
      body = JSON.stringify({
        originalText: originalText.value,
        from: originalLanguage.value.langCode,
        to: ys.translationLanguage.langCode,
        ...(useGPT && { context: translationHint.value.trim() }),
      });
    }
    const response = await fetch(endpointUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: body,
    });

    const results = await response.json();
    if (!response.ok) {
      switch (results.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        case "Subscription required. Please upgrade your plan.":
          toast(t("subscription-required-please-upgrade-your-plan"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Your subscription has expired. Please renew your subscription.":
          toast(
            t("your-subscription-has-expired-please-renew-your-subscription"),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "The balance is insufficient":
          toast(
            t(
              "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
            ),
            {
              autoClose: 3000,
              type: "error",
              theme: "light",
            }
          );
          break;
        case "Internal Server Error":
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
      }
      return;
    }
    if (results.translatedText) {
      ys.translatedText = results.translatedText;
      ys.defaultTranslatedText = results.translatedText;
      latestTranslationId.value = results.requestId;
    } else {
      ys.translatedText = t("translation-is-not-available");
    }
    await profileStore.getUserSubscription(authStore.token!);
    // todo update str player
  } catch (error) {
    console.error("Error making request to the server:", error);
  }
};

const selectTranslatedSummaryLang = (langCode: any) => {
  selectedSummarizedLanguage.value = langCode;
  translatedSummarizedText.value =
    summarizesData.value.find((e: any) => e.lang === langCode).summary || "";
  isSummarizedLangsDropOpen.value = false;
};

const fetchSummarizedText = async () => {
  try {
    const getData = await fetch(
      `${summarizeTextUrl}/${currentRequestId.value}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authStore.token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      }
    );

    const data = await getData.json();

    if (!getData.ok) {
      switch (data.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        default:
          break;
      }
      return;
    }

    if (getData.status === 200 && data.results) {
      summarizesData.value = data.results;
      selectedSummarizedLanguage.value =
        translatedSummarizesLangs.value.length === 0
          ? translationLanguage.value.langCode
          : translatedSummarizesLangs.value[0];
      ys.originalSummarizedText = summarizesData.value.find(
        (e: any) => e.lang === originalLanguage.value.langCode
      )?.summary;
      ys.translatedSummarizedText =
        summarizesData.value.find(
          (e: any) => e.lang === translationLanguage.value.langCode
        )?.summary || "";
    }
  } catch (error) {
    ys.originalSummarizedText = "";
    console.log(`fetchSummarizedText: ${error}`);
  }
};

const summarizeText = async (isOriginalText: boolean) => {
  try {
    let textToSummarize = isOriginalText
      ? originalText.value
      : translatedText.value;
    if (currentRequestId.value.trim().length === 0) {
      toast(t("ai-summarization-is-not-available-free"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }

    if (
      textToSummarize.split(/\s+/).filter((word) => word.length > 0).length <
        10 &&
      textToSummarize.length < 40
    ) {
      toast(t("please-enter-at-least-10-words"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }

    if (isOriginalText) {
      if (ys.originalSummarizedText.length > 0) {
        toast(t("a-summary-for-this-request-and"), {
          autoClose: 3000,
          type: "error",
          theme: "light",
        });
        return;
      }
    } else {
      if (ys.translatedSummarizedText.length > 0) {
        toast(t("a-summary-for-this-request-and"), {
          autoClose: 3000,
          type: "error",
          theme: "light",
        });
        return;
      }
    }

    let textTokenLenth = isOriginalText
      ? origineTokenValue.value
      : translatedTokenValue.value;
    let textLang = isOriginalText
      ? originalLanguage.value.langCode
      : translationLanguage.value.langCode;
    let stillOriginalText;
    let relatedId = isOriginalText ? "" : latestTranslationId.value;
    if (isOriginalText) {
      summarizingOriginalText.value = true;
      stillOriginalText = originalText.value === defaultOriginalText.value;
    } else {
      summarizingTranslatedText.value = true;
      stillOriginalText = translatedText.value === defaultTranslatedText.value;
    }
    let body;
    body = JSON.stringify({
      text: textToSummarize,
      length: textTokenLenth,
      serviceType: "YOUTUBE",
      serviceRequestId: currentRequestId.value,
      summaryLang: textLang,
      relatedRequestId: relatedId,
      isOriginal: stillOriginalText,
      externelLink: ys.userInput,
    });
    const response = await fetch(summarizeTextUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: body,
    });

    const results = await response.json();
    if (!response.ok) {
      switch (results.error) {
        case "serviceRequestId is required":
          toast(t("ai-summarization-is-not-available-free"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Request not found or does not belong to user":
          toast(t("invalid-or-unauthorized"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Summary already exists for this request and language":
          toast(t("a-summary-for-this-request-and"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Rate limit exceeded. Try again later.":
          toast(t("rate-limit-reached-please"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
          break;
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          return;
        default:
          toast(t("were-fixing-a-technical-issue-so-please-try"), {
            autoClose: 3000,
            type: "error",
            theme: "light",
          });
      }
      if (isOriginalText) {
        summarizingOriginalText.value = false;
      } else {
        summarizingTranslatedText.value = false;
      }
      return;
    }

    if (results.result) {
      if (isOriginalText) {
        ys.originalSummarizedText = results.result;
      } else {
        ys.translatedSummarizedText = results.result;
        summarizesData.value.push({
          summary: results.result,
          lang: translationLanguage.value.langCode,
        });
        translatedSummarizesLangs.value = summarizesData.value
          .filter((e: any) => e.lang !== originalLanguage.value.langCode)
          .map((item) => item.lang);
        selectTranslatedSummaryLang(translationLanguage.value.langCode);
      }
    }
    if (isOriginalText) {
      summarizingOriginalText.value = false;
    } else {
      summarizingTranslatedText.value = false;
    }
  } catch (error) {
    if (isOriginalText) {
      summarizingOriginalText.value = false;
    } else {
      summarizingTranslatedText.value = false;
    }
    console.error("Error making request to the server:", error);
  }
};

const dubbingText = async (
  isOriginalText: boolean,
  startIndex = 0,
  chunkSize = 5
) => {
  try {
    let textToDubbing = isOriginalText
      ? originalVideoSubtitle.value
      : translatedVideoSubtitle.value;
    if (textToDubbing.trim().length === 0) {
      toast(t("please-select-a-language-and-translate"), {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return;
    }

    const userSubscription = profileStore.subscriptionType;
    if (userSubscription === "FREE") {
      toast(t("subscription-required-please-upgrade-your-plan"), {
        autoClose: 2500,
        type: "error",
        theme: "light",
      });
      return;
    }
    if (userSubscription != "CONSUMEASYOUPAY") {
      const currentTimestamp = new Date(new Date().toISOString());
      const subscriptionEndDate = new Date(profileStore.subscriptionEndDate);
      if (currentTimestamp > subscriptionEndDate) {
        toast(
          t("your-subscription-has-expired-please-renew-your-subscription"),
          {
            autoClose: 2500,
            type: "error",
            theme: "light",
          }
        );
        return;
      }
    }

    let cues;
    try {
      cues = parseWebVTT(textToDubbing);
    } catch (error) {
      console.error("WebVTT parsing error:", error);
      return;
    }

    if (!cues.length) {
      return;
    }

    const cuesToProcess = cues.slice(startIndex, startIndex + chunkSize);
    if (!cuesToProcess.length) {
      return;
    }

    const totalTextLength = cuesToProcess.reduce(
      (sum, cue) => sum + (cue.text?.trim().length || 0),
      0
    );
    if (totalTextLength === 0) {
      return;
    }

    const canProceed = await dubbingComputeTtsCost(
      userSubscription,
      totalTextLength
    );
    if (!canProceed) {
      return;
    }

    isFetchingDubbing.value = true;
    let textLang = isOriginalText
      ? originalLanguage.value.langCode
      : translationLanguage.value.langCode;
    let genderSelected = isOriginalText
      ? selectedVoice.value
      : selectedVoiceTranslated.value;
    let body;
    body = JSON.stringify({
      webvtt: textToDubbing,
      language: textLang,
      gender: genderSelected,
      startIndex,
      chunkSize,
    });
    const response = await fetch(dubbingTextUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      body: body,
    });

    const results = await response.json();
    if (response.status === 200) {
      if (results.audioMap && Object.keys(results.audioMap).length > 0) {
        const base64AudioMap: any = {};
        interface AudioMapEntry {
          url: string;
          endTime: number;
        }
        for (const [startTime, entry] of Object.entries(results.audioMap) as [
          string,
          AudioMapEntry
        ][]) {
          const { url, endTime } = entry;
          const base64 = await urlToBase64(url);
          if (base64) {
            base64AudioMap[startTime] = { base64, endTime };
          }
        }
        if (isOriginalText) {
        } else {
          ys.activeAudioDubbing = {
            ...ys.activeAudioDubbing,
            ...base64AudioMap,
          };
        }
      }
      isFetchingDubbing.value = false;
      return results;
    } else {
      let errorMessage;
      switch (results.error) {
        case "Subscription required. Please upgrade your plan.":
          errorMessage = t("subscription-required-please-upgrade-your-plan");
          break;
        case "Your subscription has expired. Please renew.":
          errorMessage = t(
            "your-subscription-has-expired-please-renew-your-subscription"
          );
          break;
        case "Insufficient text-to-speech balance":
          errorMessage = t(
            "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
          );
          break;
        case "Unsupported language or gender combination":
          errorMessage = t("this-combination-of-language-and");
          break;
        case "Rate limit exceeded. Try again later.":
          errorMessage = t("rate-limit-exceeded-try-again-later");
          break;
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          return;
        default:
          errorMessage = t("Something_wrong_please_try_later");
          break;
      }
      isFetchingDubbing.value = false;
      toast(errorMessage, {
        autoClose: 3000,
        type: "error",
        theme: "light",
      });
      return results;
    }
  } catch (error) {
    console.error("Error making request to the server:", error);
    isFetchingDubbing.value = false;
    return null;
  }
};

function getAudioForTime(currentTime: number, isOriginalText: boolean) {
  const audioMap = ys.activeAudioDubbing;
  const times = Object.keys(audioMap)
    .map(Number)
    .sort((a, b) => a - b);
  console.log("times -----------", times);

  let selectedAudio = null;
  for (const startTime of times) {
    const { base64, endTime } = audioMap[startTime];
    if (currentTime * 1000 >= startTime && currentTime * 1000 <= endTime) {
      selectedAudio = { startTime, base64, endTime };
      break;
    }
  }

  return selectedAudio;
}

async function adjustPlaybackSpeed(
  audioElement: HTMLAudioElement,
  startTime: number,
  endTime: number,
  nextStartTime: number | null
) {
  const captionDuration = (endTime - startTime) / 1000; // in seconds
  const breakDuration = nextStartTime ? (nextStartTime - endTime) / 1000 : 0;
  const targetDuration = captionDuration + (breakDuration || 0);

  // Wait for metadata to load to get audio duration
  await new Promise((resolve) => {
    audioElement.onloadedmetadata = resolve;
  });

  const audioDuration = audioElement.duration; // in seconds
  if (audioDuration > targetDuration) {
    const speed = audioDuration / targetDuration;
    audioElement.playbackRate = Math.min(speed, 2.0); // Cap at 2x speed
    console.log(
      `Adjusted playback speed to ${audioElement.playbackRate}x for audio duration ${audioDuration}s to fit ${targetDuration}s`
    );
  } else {
    audioElement.playbackRate = 1.0;
  }
}

async function checkAndFetchNextChunk(
  currentTime: number,
  isOriginalText: boolean
) {
  const audioMap = ys.activeAudioDubbing;
  const times = Object.keys(audioMap)
    .map(Number)
    .sort((a, b) => a - b);

  const cues = captions.value;
  const total = captions.value.length;
  const chunkSize = 5;
  //case when no cues are available
  if (!times.length) {
    if (!cues.length) return;
    const targetCueIndex =
      cues.findIndex((cue) => {
        const startMs = parseFloat(cue.start) * 1000;
        const durMs = parseFloat(cue.dur) * 1000;
        return (
          currentTime * 1000 >= startMs && currentTime * 1000 <= startMs + durMs
        );
      }) || 0;

    if (
      targetCueIndex >= 0 &&
      targetCueIndex < total &&
      !isDubbingOperationRunning.value
    ) {
      console.log(`Fetching initial chunk starting at index ${targetCueIndex}`);
      player.value.pauseVideo();
      isDubbingStopsVideo.value = true;
      isDubbingOperationRunning.value = true;
      const response = await dubbingText(
        isOriginalText,
        targetCueIndex,
        chunkSize
      );
      isDubbingOperationRunning.value = false;

      if (response && Object.keys(response.audioMap || {}).length > 0) {
        const remainingCues = total - targetCueIndex;
        let newCuesCount = 0;
        for (const startTime of Object.keys(response.audioMap)) {
          if (!audioMap[startTime]) newCuesCount++;
        }
        if (remainingCues > 0 && newCuesCount > 0) {
          const increment = Math.min(chunkSize, remainingCues, newCuesCount);
          if (isOriginalText) {
            processedCueIndices.value.original = targetCueIndex + increment;
          } else {
            processedCueIndices.value.translated = targetCueIndex + increment;
          }
        }
      }
      isDubbingStopsVideo.value = false;
      if (player.value.pauseVideo()) {
        player.value.playVideo();
      }
      cacheCaptionsAndDubbings();
    }
    return;
  }

  //case when currenct cue not available
  if (cues.length) {
    const targetCueIndex = cues.findIndex((cue) => {
      const startMs = parseFloat(cue.start) * 1000;
      const durMs = parseFloat(cue.dur) * 1000;
      return (
        currentTime * 1000 >= startMs && currentTime * 1000 <= startMs + durMs
      );
    });
    if (
      targetCueIndex >= 0 &&
      targetCueIndex < total &&
      !isDubbingOperationRunning.value
    ) {
      const audioInfo = getAudioForTime(currentTime, isOriginalText);
      if (!audioInfo) {
        console.log("missing cue at this moment -----------");
        isDubbingStopsVideo.value = true;
        player.value.pauseVideo();
        // Missing cue at currentTime
        let newCuesCount = 0;
        for (
          let i = targetCueIndex;
          i < Math.min(targetCueIndex + chunkSize, total);
          i++
        ) {
          const cueStartMs = parseFloat(cues[i].start) * 1000;
          if (!audioMap[cueStartMs]) newCuesCount++;
        }
        const maxChunkSize = newCuesCount > 0 ? newCuesCount : 1;
        console.log(
          `Fetching missing chunk starting at index ${targetCueIndex}`
        );
        isDubbingOperationRunning.value = true;
        const response = await dubbingText(
          isOriginalText,
          targetCueIndex,
          maxChunkSize
        );
        isDubbingOperationRunning.value = false;

        if (response && Object.keys(response.audioMap || {}).length > 0) {
          const remainingCues = total - targetCueIndex;
          let newCuesCount = 0;
          for (const startTime of Object.keys(response.audioMap)) {
            if (!audioMap[startTime]) newCuesCount++;
          }
          if (remainingCues > 0 && newCuesCount > 0) {
            const increment = Math.min(chunkSize, remainingCues, newCuesCount);
            if (isOriginalText) {
              processedCueIndices.value.original = Math.max(
                processedCueIndices.value.original,
                targetCueIndex + increment
              );
            } else {
              processedCueIndices.value.translated = Math.max(
                processedCueIndices.value.translated,
                targetCueIndex + increment
              );
            }
          }
        }
        if (player.value.pauseVideo()) {
          player.value.playVideo();
        }
        isDubbingStopsVideo.value = false;
        cacheCaptionsAndDubbings();
        return; // Exit after fetching missing cue
      }
    }
  }

  //normal case when we need to load next chunk
  const lastTime = times[times.length - 1];
  const lastEndTime = audioMap[lastTime].endTime / 1000;
  const bufferTime = 10;

  const currentIndex = isOriginalText
    ? processedCueIndices.value.original
    : processedCueIndices.value.translated;
  if (
    currentTime >= lastEndTime - bufferTime &&
    !isDubbingOperationRunning.value &&
    currentIndex < captions.value.length
  ) {
    let newCuesCount = 0;
    for (
      let i = currentIndex;
      i < Math.min(currentIndex + chunkSize, total);
      i++
    ) {
      const cueStartMs = parseFloat(cues[i].start) * 1000;
      if (!audioMap[cueStartMs]) newCuesCount++;
    }
    if (newCuesCount === 0) return;
    const maxChunkSize = newCuesCount > 0 ? newCuesCount : 1;
    console.log(
      `Fetching next chunk starting at index ${currentIndex} with chunkSize ${maxChunkSize}`
    );
    isDubbingOperationRunning.value = true;
    const response = await dubbingText(
      isOriginalText,
      currentIndex,
      maxChunkSize
    );
    isDubbingOperationRunning.value = false;
    if (response && Object.keys(response.audioMap || {}).length > 0) {
      const remainingCues = captions.value.length - currentIndex;
      let actualNewCues = 0;
      for (const startTime of Object.keys(response.audioMap)) {
        if (!audioMap[startTime]) {
          actualNewCues++;
        }
      }
      if (remainingCues > 0) {
        const increment = Math.min(chunkSize, remainingCues, actualNewCues); // chunkSize or remaining
        if (isOriginalText) {
          processedCueIndices.value.original += increment;
        } else {
          processedCueIndices.value.translated += increment;
        }
      }
    }
    if (isPlaying.value) {
      player.value.playVideo();
    }
    cacheCaptionsAndDubbings();
  }

  if (currentTime >= lastEndTime && isDubbingOperationRunning.value) {
    player.value.pauseVideo();
  }
}

interface CacheEntry {
  requestId?: string;
  inputLink?: string;
  languages: Record<string, { captions: any; dubbings: any }>;
  created?: number;
}

async function initDB(): Promise<IDBPDatabase> {
  return openDB("subtitle_youtubeCache", 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("cache")) {
        db.createObjectStore("cache", { keyPath: "id", autoIncrement: true });
      }
    },
  });
}

function serializeData(data: any): any {
  try {
    const plainData = toRaw(data);

    if (plainData instanceof Blob) {
      console.warn(
        "Blob detected; storing as placeholder. Consider separate blob storage."
      );
      return { __type: "Blob", size: plainData.size, type: plainData.type };
    } else if (plainData instanceof ArrayBuffer) {
      const uint8Array = new Uint8Array(plainData);
      const binary = String.fromCharCode(...uint8Array);
      return { __type: "ArrayBuffer", data: btoa(binary) };
    } else if (Array.isArray(plainData)) {
      return plainData.map(serializeData);
    } else if (plainData && typeof plainData === "object") {
      const result: Record<string, any> = {};
      for (const [key, value] of Object.entries(plainData)) {
        result[key] = serializeData(value);
      }
      return result;
    }
    return plainData;
  } catch (e) {
    console.error("Failed to serialize data:", data, e);
    return null; // Skip non-serializable data
  }
}

async function cacheCaptionsAndDubbings() {
  try {
    if (!translationLanguage.value.langCode) {
      console.error("Missing translation language code");
      return;
    }

    const trLang = languages.find(
      (l: Language) => l.langName === activeCaptionLang.value
    );
    let langCode = trLang?.langCode || "en";

    let currentCaptions = availableCaptions.value.find(
      (cc) => cc.language === trLang?.langName
    );
    if (!currentCaptions) return;
    const captionsData = serializeData(currentCaptions.captions);
    const dubbingsData = serializeData(ys.activeAudioDubbing);
    const requestId = currentRequestId?.value;
    const inputLink = userInput.value;

    let db: IDBPDatabase;
    try {
      db = await initDB();
    } catch (e) {
      console.error("Failed to initialize IndexedDB:", e);
      return;
    }

    const tx = db.transaction("cache", "readwrite");
    const store = tx.objectStore("cache");

    let cache: CacheEntry[] = [];
    try {
      cache = (await store.getAll()) || [];
    } catch (e) {
      console.error("Failed to load cache from IndexedDB:", e);
    }

    const entryIndex = cache.findIndex(
      (item) =>
        (requestId && item.requestId === requestId) ||
        (inputLink && item.inputLink === inputLink)
    );
    const entry: CacheEntry =
      entryIndex >= 0
        ? cache[entryIndex]
        : { requestId, inputLink, languages: {}, created: Date.now() };

    // Update language data
    entry.languages[langCode] = {
      captions: captionsData,
      dubbings: dubbingsData,
    };

    if (entryIndex >= 0) {
      cache[entryIndex] = entry;
    } else {
      cache.push(entry);
    }
    await store.clear();
    for (const item of cache) {
      try {
        await store.add(item);
      } catch (e) {
        console.error("Failed to add cache entry:", item, e);
      }
    }
    await tx.done;
  } catch (e) {
    console.error("Failed to save to IndexedDB:", e);
  }
}

function convertSecondsToTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secsNumber = seconds % 60;
  const secs =
    secsNumber < 10 ? `0${secsNumber.toFixed(3)}` : secsNumber.toFixed(3);
  return `${pad(hours)}:${pad(minutes)}:${secs}`;
}

function pad(num: number): string {
  return num < 10 ? `0${num}` : `${num}`;
}

function convertCaptionToWebVTT(captions: any[]): string {
  try {
    let webvttContent = "WEBVTT\n\n";
    captions.forEach((caption, index) => {
      const startTime = convertSecondsToTime(caption.start);
      const endTime = convertSecondsToTime(
        caption.start + parseFloat(caption.dur)
      );
      webvttContent += `${index + 1}\n`;
      webvttContent += `${startTime} --> ${endTime}\n`;
      webvttContent += `${caption.text}\n\n`;
    });
    return webvttContent;
  } catch (error) {
    console.error("Error converting captions to WebVTT:", error);
    return "";
  }
}

async function loadCachedCaptionsAndDubbings() {
  if (!currentRequestId?.value && !userInput.value) {
    console.log("No requestId or inputLink provided, skipping cache load");
    return;
  }
  ys.activeAudioDubbing = [];

  let db: IDBPDatabase;
  try {
    db = await initDB();
  } catch (e) {
    console.error("Failed to initialize IndexedDB:", e);
    return;
  }
  let cache: CacheEntry[] = [];
  try {
    cache = (await db.transaction("cache").objectStore("cache").getAll()) || [];
  } catch (e) {
    console.error("Failed to load cache from IndexedDB:", e);
    return;
  }
  const entry = cache.find(
    (item) =>
      (currentRequestId.value && item.requestId === currentRequestId.value) ||
      (userInput.value && item.inputLink === userInput.value)
  );

  if (!entry || !entry.languages[translationLanguage.value.langCode]) {
    console.log("No cached data found for the specified language");
    return;
  }
  const { captions: cachedCaptions, dubbings: cachedDubbings } =
    entry.languages[translationLanguage.value.langCode];
  if (cachedCaptions?.length) {
    captions.value = cachedCaptions;
    defaultTranslatedVideoSubtitle.value =
      convertCaptionToWebVTT(cachedCaptions);
    translatedVideoSubtitle.value = convertCaptionToWebVTT(cachedCaptions);
    console.log("availableCaptions ---", availableCaptions.value);
    const index = availableCaptions.value.findIndex(
      (caption) => caption.language === translationLanguage.value.langName
    );

    if (index !== -1) {
      availableCaptions.value[index].captions = cachedCaptions;
    } else {
      availableCaptions.value.push({
        language: translationLanguage.value.langName,
        captions: cachedCaptions,
      });
    }
    activeCaptionLang.value = translationLanguage.value.langName;
  }
  if (cachedDubbings && Object.keys(cachedDubbings).length) {
    ys.activeAudioDubbing = cachedDubbings;
  }
}

async function urlToBase64(url: string) {
  try {
    const response = await fetch(url);
    if (!response.ok)
      throw new Error(`Failed to fetch audio: ${response.status}`);
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("audio/mpeg")) {
      throw new Error(`Invalid content type: ${contentType}`);
    }
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        if (typeof result === "string" && result.startsWith("data:audio")) {
          resolve(result); // Extract Base64 part
        } else {
          reject(new Error("Invalid Base64 data"));
        }
      };
      reader.onerror = () => reject(new Error("FileReader error"));
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error(`Error converting URL to Base64 for ${url}:`, error);
    return null;
  }
}

const resetText = (isOriginal: boolean) => {
  if (isOriginal) {
    if (showOriginalSummarized.value) return;
  } else {
    if (showTranslatedSummarized.value) return;
  }
  if (isOriginal) {
    originalText.value = defaultOriginalText.value;
  } else {
    translatedText.value = defaultTranslatedText.value;
  }
};

const resetSubtitle = (isOriginal: boolean) => {
  if (isOriginal) {
    originalVideoSubtitle.value = defaultOriginalVideoSubtitle.value;
  } else {
    translatedVideoSubtitle.value = defaultTranslatedVideoSubtitle.value;
  }
};

// Find/Replace functions
const openFindReplace = (mode: "text" | "caption", target: "original" | "translated") => {
  findReplaceMode.value = mode;
  findReplaceTarget.value = target;
  showFindReplace.value = true;
  findReplaceSearchTerm.value = "";
  findReplaceMatches.value = [];
  currentFindMatchIndex.value = -1;
};

const closeFindReplace = () => {
  showFindReplace.value = false;
  findReplaceSearchTerm.value = "";
  findReplaceMatches.value = [];
  currentFindMatchIndex.value = -1;
};

const performFind = (searchTerm: string, target: "original" | "translated") => {
  if (!searchTerm) {
    findReplaceMatches.value = [];
    currentFindMatchIndex.value = -1;
    if (findReplaceDialogRef.value) {
      findReplaceDialogRef.value.setMatchInfo(-1, 0);
    }
    return;
  }

  findReplaceSearchTerm.value = searchTerm;

  let content = "";
  let textOnlyContent = "";

  if (findReplaceMode.value === "text") {
    if (target === "original") {
      content = showOriginalSummarized.value
        ? originalSummarizedText.value
        : originalText.value;
    } else {
      content = showTranslatedSummarized.value
        ? translatedSummarizedText.value
        : translatedText.value;
    }
    textOnlyContent = content;
  } else {
    // caption mode - extract text only from WebVTT
    const webvttContent = target === "original" 
      ? originalVideoSubtitle.value 
      : translatedVideoSubtitle.value;
    
    const blocks = parseWebVTTForFindReplace(webvttContent);
    textOnlyContent = blocks.map(block => block.text).join("\n");
    content = webvttContent;
  }

  const regex = new RegExp(escapeRegex(searchTerm), "gi");
  const matches: number[] = [];
  let match;
  while ((match = regex.exec(textOnlyContent)) !== null) {
    matches.push(match.index);
  }

  findReplaceMatches.value = matches;
  currentFindMatchIndex.value = matches.length > 0 ? 0 : -1;

  if (findReplaceDialogRef.value) {
    findReplaceDialogRef.value.setMatchInfo(
      currentFindMatchIndex.value,
      matches.length
    );
  }

  if (matches.length > 0) {
    scrollToMatch(matches[0], searchTerm.length, false);
  }
};

const escapeRegex = (str: string): string => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};

const findNextMatch = () => {
  if (findReplaceMatches.value.length === 0) return;

  currentFindMatchIndex.value =
    (currentFindMatchIndex.value + 1) % findReplaceMatches.value.length;

  if (findReplaceDialogRef.value) {
    findReplaceDialogRef.value.setMatchInfo(
      currentFindMatchIndex.value,
      findReplaceMatches.value.length
    );
  }

  const matchIndex = findReplaceMatches.value[currentFindMatchIndex.value];
  const searchTerm = findReplaceDialogRef.value?.getSearchTerm() || findReplaceSearchTerm.value;
  scrollToMatch(matchIndex, searchTerm.length, true);
};

const findPreviousMatch = () => {
  if (findReplaceMatches.value.length === 0) return;

  currentFindMatchIndex.value =
    currentFindMatchIndex.value <= 0
      ? findReplaceMatches.value.length - 1
      : currentFindMatchIndex.value - 1;

  if (findReplaceDialogRef.value) {
    findReplaceDialogRef.value.setMatchInfo(
      currentFindMatchIndex.value,
      findReplaceMatches.value.length
    );
  }

  const matchIndex = findReplaceMatches.value[currentFindMatchIndex.value];
  const searchTerm = findReplaceDialogRef.value?.getSearchTerm() || findReplaceSearchTerm.value;
  scrollToMatch(matchIndex, searchTerm.length, true);
};

const scrollToMatch = (index: number, length: number, shouldFocus: boolean = false) => {
  nextTick(() => {
    let textarea: HTMLTextAreaElement | null = null;
    let actualIndex = index;
    
    if (findReplaceMode.value === "text") {
      if (findReplaceTarget.value === "original") {
        textarea = showOriginalSummarized.value
          ? originalSummarizedTextAreaRef.value
          : originalTextAreaRef.value;
      } else {
        textarea = showTranslatedSummarized.value
          ? translatedSummarizedTextAreaRef.value
          : translatedTextAreaRef.value;
      }
    } else {
      const webvttContent = findReplaceTarget.value === "original" 
        ? originalVideoSubtitle.value 
        : translatedVideoSubtitle.value;
      const blocks = parseWebVTTForFindReplace(webvttContent);
      
      let textOffset = 0;
      let webvttOffset = 0;
      const headerLength = webvttContent.startsWith("WEBVTT") ? webvttContent.indexOf("\n\n") + 2 : 0;
      webvttOffset = headerLength;

      for (let i = 0; i < blocks.length; i++) {
        const blockTextLength = blocks[i].text.length;
        
        if (index >= textOffset && index < textOffset + blockTextLength) {
          const relativeIndex = index - textOffset;
          actualIndex = webvttOffset + 
            (i > 0 ? blocks.slice(0, i).reduce((sum, b) => sum + b.fullBlock.length + 2, 0) : 0) +
            String(i + 1).length + 1 +
            blocks[i].timestamp.length + 1 +
            relativeIndex;
          break;
        }
        
        textOffset += blockTextLength + 1;
      }

      textarea = findReplaceTarget.value === "original" 
        ? webvttTextArea1.value
        : webvttTextArea2.value;
    }

    if (textarea) {
      if (shouldFocus) {
        textarea.focus();
      }
      const maxIndex = Math.min(actualIndex, textarea.value.length);
      const maxLength = Math.min(length, textarea.value.length - maxIndex);
      textarea.setSelectionRange(maxIndex, maxIndex + maxLength);
      const lineHeight = parseInt(getComputedStyle(textarea).lineHeight) || 20;
      const lines = textarea.value.substring(0, maxIndex).split("\n").length - 1;
      textarea.scrollTop = Math.max(0, lines * lineHeight - textarea.clientHeight / 2);
      
      if (showFindReplace.value) {
        const dialogOverlay = document.querySelector('.overlay.bg-gray-600.bg-opacity-50');
        const dialogContent = dialogOverlay?.querySelector('.bg-white.rounded-lg.shadow-lg') as HTMLElement;
        const dialogHeight = dialogContent ? dialogContent.offsetHeight + 64 : 0;
        
        const textareaRect = textarea.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const scrollY = window.scrollY;
        
        const desiredTopPosition = dialogHeight + 20;
        const textareaTop = textareaRect.top + scrollY;
        
        const isCoveredByDialog = textareaRect.top < dialogHeight;
        const isNotFullyVisible = textareaRect.bottom > viewportHeight || textareaRect.top < 0;
        
        if (isCoveredByDialog || isNotFullyVisible) {
          const targetScrollY = textareaTop - desiredTopPosition;
          
          window.scrollTo({
            top: Math.max(0, targetScrollY),
            behavior: 'smooth'
          });
        }
      } else {
        const textareaRect = textarea.getBoundingClientRect();
        const isNotFullyVisible = textareaRect.bottom > window.innerHeight || textareaRect.top < 0;
        
        if (isNotFullyVisible) {
          textarea.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    }
  });
};

const replaceCurrentMatch = async (replaceTerm: string) => {
  if (currentFindMatchIndex.value === -1 || findReplaceMatches.value.length === 0) return;

  const searchTerm = findReplaceDialogRef.value?.getSearchTerm() || findReplaceSearchTerm.value;
  if (!searchTerm) return;

  if (findReplaceMode.value === "text") {
    await replaceInText(replaceTerm, searchTerm);
  } else {
    replaceInCaption(replaceTerm, searchTerm);
  }

  performFind(searchTerm, findReplaceTarget.value);
};

const replaceAllMatches = async (replaceTerm: string) => {
  const searchTerm = findReplaceDialogRef.value?.getSearchTerm() || findReplaceSearchTerm.value;
  if (!searchTerm) return;

  if (findReplaceMode.value === "text") {
    await replaceInText(replaceTerm, searchTerm, true);
  } else {
    replaceInCaption(replaceTerm, searchTerm, true);
  }

  findReplaceMatches.value = [];
  currentFindMatchIndex.value = -1;
  if (findReplaceDialogRef.value) {
    findReplaceDialogRef.value.setMatchInfo(-1, 0);
  }
};

const replaceInText = async (replaceTerm: string, searchTerm: string, replaceAll: boolean = false) => {
  if (findReplaceTarget.value === "original") {
    if (showOriginalSummarized.value) {
      if (replaceAll) {
        const regex = new RegExp(escapeRegex(searchTerm), 'g');
        originalSummarizedText.value = originalSummarizedText.value.replace(
          regex,
          replaceTerm
        );
      } else {
        const currentIndex = findReplaceMatches.value[currentFindMatchIndex.value];
        const before = originalSummarizedText.value.substring(0, currentIndex);
        const after = originalSummarizedText.value.substring(currentIndex + searchTerm.length);
        originalSummarizedText.value = before + replaceTerm + after;
      }
    } else {
      if (replaceAll) {
        const regex = new RegExp(escapeRegex(searchTerm), 'g');
        originalText.value = originalText.value.replace(regex, replaceTerm);
      } else {
        const currentIndex = findReplaceMatches.value[currentFindMatchIndex.value];
        const before = originalText.value.substring(0, currentIndex);
        const after = originalText.value.substring(currentIndex + searchTerm.length);
        originalText.value = before + replaceTerm + after;
      }
    }
  } else {
    if (showTranslatedSummarized.value) {
      if (replaceAll) {
        const regex = new RegExp(escapeRegex(searchTerm), 'g');
        translatedSummarizedText.value = translatedSummarizedText.value.replace(
          regex,
          replaceTerm
        );
      } else {
        const currentIndex = findReplaceMatches.value[currentFindMatchIndex.value];
        const before = translatedSummarizedText.value.substring(0, currentIndex);
        const after = translatedSummarizedText.value.substring(currentIndex + searchTerm.length);
        translatedSummarizedText.value = before + replaceTerm + after;
      }
    } else {
      if (replaceAll) {
        const regex = new RegExp(escapeRegex(searchTerm), 'g');
        translatedText.value = translatedText.value.replace(regex, replaceTerm);
      } else {
        const currentIndex = findReplaceMatches.value[currentFindMatchIndex.value];
        const before = translatedText.value.substring(0, currentIndex);
        const after = translatedText.value.substring(currentIndex + searchTerm.length);
        translatedText.value = before + replaceTerm + after;
      }
    }
  }
};

const parseWebVTTForFindReplace = (webvtt: string): Array<{ index: number; timestamp: string; text: string; fullBlock: string }> => {
  const blocks: Array<{ index: number; timestamp: string; text: string; fullBlock: string }> = [];
  const lines = webvtt.split("\n");
  let i = 0;
  let blockIndex = 0;

  if (lines[0]?.trim() === "WEBVTT") {
    i = 1;
  }

  while (i < lines.length) {
    while (i < lines.length && lines[i].trim() === "") {
      i++;
    }
    if (i >= lines.length) break;

    if (/^\d+$/.test(lines[i].trim())) {
      i++;
    }

    const timestampLine = lines[i]?.trim();
    if (!timestampLine || !timestampLine.includes("-->")) {
      i++;
      continue;
    }

    const timestamp = timestampLine;
    i++;

    const textLines: string[] = [];
    while (i < lines.length && lines[i].trim() !== "" && !/^\d+$/.test(lines[i].trim())) {
      if (!lines[i].includes("-->")) {
        textLines.push(lines[i]);
      }
      i++;
    }

    const text = textLines.join("\n");
    const fullBlock = `${blockIndex + 1}\n${timestamp}\n${text}`;

    blocks.push({
      index: blockIndex,
      timestamp,
      text,
      fullBlock,
    });

    blockIndex++;
  }

  return blocks;
};

const reconstructWebVTT = (blocks: Array<{ index: number; timestamp: string; text: string }>): string => {
  let result = "WEBVTT\n\n";
  blocks.forEach((block) => {
    result += `${block.index + 1}\n${block.timestamp}\n${block.text}\n\n`;
  });
  return result;
};

const replaceInCaption = (replaceTerm: string, searchTerm: string, replaceAll: boolean = false) => {
  const content = findReplaceTarget.value === "original" 
    ? originalVideoSubtitle.value 
    : translatedVideoSubtitle.value;

  const blocks = parseWebVTTForFindReplace(content);

  if (replaceAll) {
    const regex = new RegExp(escapeRegex(searchTerm), 'g');
    blocks.forEach((block) => {
      block.text = block.text.replace(regex, replaceTerm);
    });
  } else {
    let currentBlockIndex = -1;
    let textOffset = 0;

    for (let i = 0; i < blocks.length; i++) {
      const blockTextLength = blocks[i].text.length;
      const matchIndex = findReplaceMatches.value[currentFindMatchIndex.value];

      if (matchIndex >= textOffset && matchIndex < textOffset + blockTextLength) {
        currentBlockIndex = i;
        break;
      }

      textOffset += blockTextLength + 1;
    }

    if (currentBlockIndex !== -1) {
      const block = blocks[currentBlockIndex];
      const relativeIndex = findReplaceMatches.value[currentFindMatchIndex.value] - textOffset;
      const before = block.text.substring(0, relativeIndex);
      const after = block.text.substring(relativeIndex + searchTerm.length);
      block.text = before + replaceTerm + after;
    }
  }

  const newWebVTT = reconstructWebVTT(blocks);

  if (findReplaceTarget.value === "original") {
    originalVideoSubtitle.value = newWebVTT;
  } else {
    translatedVideoSubtitle.value = newWebVTT;
  }
};

const updateCurrentCaptions = (currentTime: number) => {
  if (!Array.isArray(ys.captions)) {
    return;
  }

  const newCaptions: CaptionModel[] = [];

  ys.captions.forEach((element) => {
    const start = parseFloat(element.start);
    const end = start + parseFloat(element.dur);
    if (currentTime >= start && currentTime <= end) {
      newCaptions.push(element);
    }
  });

  if (!areCaptionsEqual(newCaptions, currentCaptions.value)) {
    currentCaptions.value = newCaptions;
  }
};

const areCaptionsEqual = (
  caption1: CaptionModel[],
  caption2: CaptionModel[]
): boolean => {
  if (caption1.length !== caption2.length) {
    return false;
  }

  for (let i = 0; i < caption1.length; i++) {
    if (
      caption1[i].start !== caption2[i].start ||
      caption1[i].dur !== caption2[i].dur ||
      caption1[i].text !== caption2[i].text
    ) {
      return false;
    }
  }

  return true;
};

const extractVideoId = (url: string): string | null => {
  const videoIdMatch = url.match(
    /(?:youtube\.com\/(?:shorts\/|(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/))([a-zA-Z0-9_-]{11})/
  );
  return videoIdMatch ? videoIdMatch[1] : null;
};

declare global {
  interface Window {
    YT: {
      Player: any;
    };
  }
}

const fetchTranscription = async (reqId: string) => {
  try {
    ys.isLoading = true;
    currentRequestId.value = reqId;
    const getData = await fetch(`${transcriptYoutubeUrl}?reqId=${reqId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authStore.token}`,
        "ngrok-skip-browser-warning": "69420",
      },
    });

    /* if (!getData.ok) {
      throw new Error(`HTTP error! Status: ${getData.status}`);
    } */
    const data = await getData.json();
    console.log("data ----------->", data);

    if (!getData.ok) {
      switch (data.error) {
        case "Invalid token":
        case "Authorization header missing":
          toast(t("your-session-has-expired-please-log-in-again-to-continue"), {
            autoClose: 2500,
            type: "error",
            theme: "light",
          });
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          break;
        default:
          break;
      }
      return;
    }

    // Handle both array and single object formats (raw transcription) or processed captions
    if (getData.status === 200) {
      // Check if we have processed captions
      if (data.result.captions) {
        // Processed captions format
        ys.captions = [...data.result.captions];
        const newCaptions = JSON.parse(JSON.stringify(ys.captions));
        const index = availableCaptions.value.findIndex(
          (caption) =>
            caption.language ===
              languages.find(
                (language) => language.langCode === data.originalLang
              )?.langName || "English"
        );
        console.log("available caption", index);

        if (index !== -1) {
          availableCaptions.value[index].captions = newCaptions;
        } else {
          availableCaptions.value.push({
            language:
              languages.find(
                (language) => language.langCode === data.originalLang
              )?.langName || "English",
            captions: newCaptions,
          });
        }
        ys.activeCaptionLang = getLanguageName(data.originalLang);
        ys.hasCaption = true;
        ys.originalJsonContent = JSON.stringify(data.result.captions);
        ys.originalText = extractText(data.result.captions);
        ys.defaultOriginalText = extractText(data.result.captions);
        ys.originalVideoSubtitle = subtitleGenerationFromCaption(
          data.result.captions
        );
        ys.defaultOriginalVideoSubtitle = subtitleGenerationFromCaption(
          data.result.captions
        );
        ys.prebuildVideoSubtitle = subtitleGenerationFromCaption(
          data.result.captions
        );
        
        // Parse speaker diarization if raw transcription data is available
        let rawTranscriptionData = null;
        if (data.result && typeof data.result === 'object') {
          if (!data.result.captions) {
            rawTranscriptionData = data.result;
          } else if (data.result.transcription || data.result.raw) {
            rawTranscriptionData = data.result.transcription || data.result.raw;
          }
        }
        
        if (rawTranscriptionData) {
          let resultData = rawTranscriptionData;
          if (Array.isArray(rawTranscriptionData)) {
            if (rawTranscriptionData.length > 0) {
              resultData = rawTranscriptionData[0];
            }
          }
          
          if (isSonioxFormat(resultData)) {
            try {
              ys.parsedCaptionsWithSpeakers = parseSonioxTranscription(resultData);
            } catch (error) {
              console.error("Error parsing Soniox format:", error);
              ys.parsedCaptionsWithSpeakers = [];
            }
          } else {
            try {
              const googleData = Array.isArray(rawTranscriptionData) ? rawTranscriptionData : [rawTranscriptionData];
              ys.parsedCaptionsWithSpeakers = parseTranscriptionWithSpeakers(googleData);
            } catch (error) {
              console.error("Error parsing Google Cloud format:", error);
              ys.parsedCaptionsWithSpeakers = [];
            }
          }
        } else {
          ys.parsedCaptionsWithSpeakers = [];
        }
      } else if (data.result && (Array.isArray(data.result) || (typeof data.result === 'object' && data.result !== null))) {
        // Raw transcription format (Soniox or Google Cloud) - similar to audio component
        // Normalize result to always work with the actual data
        let resultData = data.result;
        if (Array.isArray(data.result)) {
          if (data.result.length > 0) {
            resultData = data.result[0];
          }
        }
        
        ys.hasCaption = true;
        ys.originalJsonContent = JSON.stringify(data.result);
        
        // Extract text based on format
        if (isSonioxFormat(resultData)) {
          // Use Soniox-specific extraction method
          ys.originalText = extractTextFromSoniox(resultData);
          ys.defaultOriginalText = extractTextFromSoniox(resultData);
        } else {
          // Use original method for Google Cloud format
          const extractData = Array.isArray(data.result) ? data.result : [data.result];
          ys.originalText = extractText(extractData);
          ys.defaultOriginalText = extractText(extractData);
        }
        
        // Detect format and use appropriate parser
        if (isSonioxFormat(resultData)) {
          try {
            const sonioxSubtitle = subtitleGenerationSoniox(resultData);
            ys.originalVideoSubtitle = sonioxSubtitle;
            ys.defaultOriginalVideoSubtitle = sonioxSubtitle;
            ys.prebuildVideoSubtitle = sonioxSubtitle;
            
            // Parse captions from WebVTT for display
            const parsedCaptions = parseWebVTTToCaption(sonioxSubtitle);
            ys.captions = parsedCaptions;
            const newCaptions = JSON.parse(JSON.stringify(parsedCaptions));
            const index = availableCaptions.value.findIndex(
              (caption) =>
                caption.language ===
                  languages.find(
                    (language) => language.langCode === data.originalLang
                  )?.langName || "English"
            );
            
            if (index !== -1) {
              availableCaptions.value[index].captions = newCaptions;
            } else {
              availableCaptions.value.push({
                language:
                  languages.find(
                    (language) => language.langCode === data.originalLang
                  )?.langName || "English",
                captions: newCaptions,
              });
            }
            ys.activeCaptionLang = getLanguageName(data.originalLang);
            
            // Parse speaker diarization
            ys.parsedCaptionsWithSpeakers = parseSonioxTranscription(resultData);
          } catch (error) {
            console.error("Error parsing Soniox format:", error);
            ys.parsedCaptionsWithSpeakers = [];
          }
        } else {
          try {
            // Google Cloud format expects an array
            const googleData = Array.isArray(data.result) ? data.result : [data.result];
            const googleSubtitle = subtitleGeneration(googleData);
            ys.originalVideoSubtitle = googleSubtitle;
            ys.defaultOriginalVideoSubtitle = googleSubtitle;
            ys.prebuildVideoSubtitle = googleSubtitle;
            
            // Parse captions from WebVTT for display
            const parsedCaptions = parseWebVTTToCaption(googleSubtitle);
            ys.captions = parsedCaptions;
            const newCaptions = JSON.parse(JSON.stringify(parsedCaptions));
            const index = availableCaptions.value.findIndex(
              (caption) =>
                caption.language ===
                  languages.find(
                    (language) => language.langCode === data.originalLang
                  )?.langName || "English"
            );
            
            if (index !== -1) {
              availableCaptions.value[index].captions = newCaptions;
            } else {
              availableCaptions.value.push({
                language:
                  languages.find(
                    (language) => language.langCode === data.originalLang
                  )?.langName || "English",
                captions: newCaptions,
              });
            }
            ys.activeCaptionLang = getLanguageName(data.originalLang);
            
            // Parse speaker diarization
            ys.parsedCaptionsWithSpeakers = parseTranscriptionWithSpeakers(googleData);
          } catch (error) {
            console.error("Error parsing Google Cloud format:", error);
            ys.parsedCaptionsWithSpeakers = [];
          }
        }
      }
      const orLang = languages.find(
        (language) => language.langCode === data.originalLang
      ) || {
        langName: "English",
        langCode: "en",
        countryCode: "us",
      };
      ys.originalLanguage = { ...orLang };
      if (data.originalLang === translationLanguage.value.langCode) {
        if (data.originalLang === "ar") {
          ys.translationLanguage = {
            langName: "English",
            langCode: "en",
            countryCode: "us",
          };
        } else {
          ys.translationLanguage = {
            langName: "Arabic",
            langCode: "ar",
            countryCode: "sa",
          };
        }
      }
      const videoId = data.videoId;
      ys.userInput = `https://www.youtube.com/watch?v=${videoId}`;
      ys.mountPlayer = true;
      if (player.value && player.value.loadVideoById) {
        player.value.loadVideoById(videoId);
      } else {
        if (!window.YT) {
          const tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";
          const firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
        }
        await initYouTubePlayer(videoId || "");
        player.value.loadVideoById(videoId);
      }
    } else {
      ys.hasCaption = false;
      // show toast that video does not have captions
      if (getData.status === 200 && data.result && data.result.length === 0) {
        toast(t("this-video-doesnt-h"), {
          autoClose: 2500,
          type: "warning",
          theme: "light",
        });
      }
    }
    // Load cached text translations after fetching transcription
    await loadCachedTextTranslations();
  } catch (error) {
    ys.hasCaption = false;
    console.log(`fetchTranscription: ${error}`);
  } finally {
    ys.isLoading = false;
  }
};

const fetchOneTimeResultForYoutube = async (orderId: string) => {
  try {
    console.log("[OneTimeCaption] fetchOneTimeResultForYoutube start orderId=", orderId);
    ys.isLoading = true;
    const res = await fetch(
      `${API_BASE_URL}${ONETIME_AUDIO_RESULT}?orderId=${encodeURIComponent(orderId)}`,
      {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }
    );
    const data = await res.json();
    console.log("[OneTimeCaption] result API response orderId=", orderId, "hasResult=", !!data.result, "hasTranslation=", !!data.translation, "translationSegments=", data.translation?.segments?.length ?? 0, "targetLang=", data.targetLang ?? "n/a", "services=", data.services ?? "n/a");
    if (!res.ok) {
      if (res.status === 202) {
        toast(t("Still processing. Your result is not ready yet."), { autoClose: 3000, type: "info", theme: "light" });
        return;
      }
      throw new Error(data.error || "Failed to load result");
    }
    let resultData = data.result;
    if (Array.isArray(data.result) && data.result.length > 0) {
      resultData = data.result[0];
    }
    if (!resultData) {
      ys.hasCaption = false;
      return;
    }
    ys.hasCaption = true;
    ys.originalJsonContent = JSON.stringify(data.result);
    if (isSonioxFormat(resultData)) {
      ys.originalText = extractTextFromSoniox(resultData);
      ys.defaultOriginalText = extractTextFromSoniox(resultData);
      try {
        const sonioxSubtitle = subtitleGenerationSoniox(resultData);
        ys.originalVideoSubtitle = sonioxSubtitle;
        ys.defaultOriginalVideoSubtitle = sonioxSubtitle;
        ys.prebuildVideoSubtitle = sonioxSubtitle;
        const parsedCaptions = parseWebVTTToCaption(sonioxSubtitle);
        ys.captions = parsedCaptions;
        const newCaptions = JSON.parse(JSON.stringify(parsedCaptions));
        const orLang = languages.find((l) => l.langCode === data.originalLang) || { langName: "English", langCode: "en", countryCode: "us" };
        availableCaptions.value = [{
          language: orLang.langName,
          captions: newCaptions,
        }];
        ys.activeCaptionLang = getLanguageName(data.originalLang);
        ys.parsedCaptionsWithSpeakers = parseSonioxTranscription(resultData);
      } catch (err) {
        console.error("[fetchOneTimeResultForYoutube] Soniox parse error:", err);
        ys.parsedCaptionsWithSpeakers = [];
      }
    }
    const orLang = languages.find((l) => l.langCode === data.originalLang) || { langName: "English", langCode: "en", countryCode: "us" };
    ys.originalLanguage = { ...orLang };
    // Segments must be a list of text (one per caption); normalize if backend sent a single string
    const rawSegments = data.translation?.segments;
    const segmentsList: string[] = Array.isArray(rawSegments)
      ? rawSegments.map((s: any) => (typeof s === "string" ? s : String(s ?? "")))
      : rawSegments != null && rawSegments !== ""
        ? [String(rawSegments)]
        : [];
    if (segmentsList.length > 0) {
      console.log("[OneTimeCaption] translation loaded orderId=", orderId, "segments=", segmentsList.length, "targetLang=", data.targetLang ?? "n/a");
      const translationText = segmentsList.join("\n");
      ys.defaultTranslatedText = translationText;
      ys.translatedText = translationText;
      // Add translated captions (caption translation) so user can switch to target language in captions panel (same pattern as legacy)
      if (data.targetLang && availableCaptions.value.length > 0) {
        const originalCaptions = availableCaptions.value[0].captions || [];
        // Legacy: one translated text per caption. If API sent one blob (old data), split by original caption length ratio.
        let perCaptionTexts = segmentsList;
        if (segmentsList.length === 1 && originalCaptions.length > 1) {
          const oneBlob = segmentsList[0];
          const origLengths = originalCaptions.map((c: any) => (c.text || "").length);
          const total = origLengths.reduce((a: number, b: number) => a + b, 0) || 1;
          perCaptionTexts = [];
          let pos = 0;
          for (let i = 0; i < originalCaptions.length; i++) {
            const ratio = origLengths[i] / total;
            const len = i === originalCaptions.length - 1 ? oneBlob.length - pos : Math.round(oneBlob.length * ratio);
            perCaptionTexts.push(oneBlob.slice(pos, pos + len).trim() || oneBlob);
            pos += len;
          }
        }
        const translatedCaptions = originalCaptions.map((cap: any, i: number) => ({
          ...cap,
          text: perCaptionTexts[i] ?? perCaptionTexts[perCaptionTexts.length - 1] ?? cap.text,
        }));
        const targetLangInfo = languages.find((l) => l.langCode === data.targetLang || (typeof l.langCode === "string" && l.langCode.startsWith((data.targetLang || "").split("-")[0])));
        const targetLangName = targetLangInfo?.langName || data.targetLang;
        // Assign new array so reactivity is guaranteed (legacy pattern)
        availableCaptions.value = [
          ...availableCaptions.value,
          { language: targetLangName, captions: translatedCaptions },
        ];
        // Set translation language so UI shows target language correctly
        if (targetLangInfo) ys.translationLanguage = { ...targetLangInfo };
        // Keep ys.captions in sync with activeCaptionLang (legacy: displayed captions follow selected language)
        const activeEntry = availableCaptions.value.find((cc: any) => cc.language === ys.activeCaptionLang);
        if (activeEntry?.captions) ys.captions = activeEntry.captions;
        // Set translated WebVTT so the second caption text field shows valid WebVTT (fixes "no caption in text field")
        ys.translatedVideoSubtitle = convertCaptionToWebVTT(translatedCaptions);
        ys.defaultTranslatedVideoSubtitle = ys.translatedVideoSubtitle;
        console.log("[OneTimeCaption] translated captions added orderId=", orderId, "targetLang=", targetLangName, "captionCount=", translatedCaptions.length, "availableCaptionsCount=", availableCaptions.value.length);
      } else {
        console.log("[OneTimeCaption] skip adding translated captions orderId=", orderId, "targetLang=", !!data.targetLang, "availableCaptionsLength=", availableCaptions.value.length);
      }
    }
    // Ensure ys.captions is set for the active language so updateCurrentCaptions can display (legacy pattern)
    if (availableCaptions.value.length > 0 && (!ys.captions || ys.captions.length === 0)) {
      const activeEntry = availableCaptions.value.find((cc: any) => cc.language === ys.activeCaptionLang) ?? availableCaptions.value[0];
      if (activeEntry?.captions) ys.captions = activeEntry.captions;
    }
    // Refresh overlay so translated captions show immediately (legacy: timeupdate does this when playing)
    if (ys.captions?.length) updateCurrentCaptions(ys.currentTime ?? 0);
    if (data.voiceOverUrl) {
      ys.audioContentTranslated = data.voiceOverUrl;
    }
    const vidId = data.videoId || (data.youtubeLink ? extractVideoId(data.youtubeLink) : null);
    if (vidId) {
      ys.userInput = data.youtubeLink || `https://www.youtube.com/watch?v=${vidId}`;
      ys.mountPlayer = true;
      if (player.value && player.value.loadVideoById) {
        player.value.loadVideoById(vidId);
      } else {
        if (!window.YT) {
          const tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";
          const firstScriptTag = document.getElementsByTagName("script")[0];
          firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
        }
        await initYouTubePlayer(vidId);
        if (player.value) player.value.loadVideoById(vidId);
      }
    }
    ys.isFromNotification = true;
  } catch (err) {
    ys.hasCaption = false;
    console.error("fetchOneTimeResultForYoutube:", err);
    toast(t("Failed to load result."), { autoClose: 3000, type: "error", theme: "light" });
  } finally {
    ys.isLoading = false;
  }
};

function parseWebVTTToCaption(webvttContent: string): any[] {
  try {
    const captions: any[] = [];
    const webvttLines = webvttContent.split("\n").map((line) => line.trim());
    let index = 0;
    while (index < webvttLines.length) {
      const line = webvttLines[index];
      if (line === "WEBVTT" || line === "" || /^\d+$/.test(line)) {
        index++;
        continue;
      }
      const timeCode = webvttLines[index];
      const [start, dur] = timeCode.split(" --> ");
      const textLines: string[] = [];
      index++;
      while (index < webvttLines.length && webvttLines[index] !== "") {
        textLines.push(webvttLines[index]);
        index++;
      }
      captions.push({
        start: convertTimeToSeconds(start),
        dur: (convertTimeToSeconds(dur) - convertTimeToSeconds(start)).toFixed(
          3
        ),
        text: textLines.join(" "),
      });
      index++;
    }
    return captions;
  } catch (error) {
    console.error("Error parsing WebVTT:", error);
    return [];
  }
}

function parseWebVTT(webvttContent: string): any[] {
  try {
    const captions: any[] = [];
    const webvttLines = webvttContent.split("\n").map((line) => line.trim());
    let index = 0;
    while (index < webvttLines.length) {
      const line = webvttLines[index];
      if (line === "WEBVTT" || line === "" || /^\d+$/.test(line)) {
        index++;
        continue;
      }
      const timeCode = webvttLines[index];
      const [start, dur] = timeCode.split(" --> ");
      const textLines: string[] = [];
      index++;
      while (index < webvttLines.length && webvttLines[index] !== "") {
        textLines.push(webvttLines[index]);
        index++;
      }
      captions.push({
        start: convertTimeToSeconds(start),
        dur: (convertTimeToSeconds(dur) - convertTimeToSeconds(start)).toFixed(
          3
        ),
        text: textLines.join(" "),
      });
      index++;
    }
    return captions;
  } catch (error) {
    console.error("Error parsing WebVTT:", error);
    return [];
  }
}

function convertTimeToSeconds(time: string): number {
  const parts = time.split(":");
  const hours = parseInt(parts[0]);
  const minutes = parseInt(parts[1]);
  const seconds = parseFloat(parts[2].replace(",", "."));
  return hours * 3600 + minutes * 60 + seconds;
}

const downloadFileAs = async (type: string, isOriginal: boolean) => {
  try {
    if (type === "txt") {
      downloadAsTxt(isOriginal);
    } else if (type === "pdf") {
      showPdfPreviewModal(isOriginal);
    } else if (type === "doc") {
      await downloadAsDoc(isOriginal);
    } else if (type === "webvtt") {
      downloadWebVttFile(isOriginal);
    } else if (type === "srt") {
      downloadSrtFile(isOriginal);
    } else if (type === "json") {
      downloadJsonFile();
    } else {
      console.log("Unsupported file type");
    }
  } catch (error) {
    console.log("doenload error: ", error);
  }
};

const downloadSrtFile = (isOriginal: boolean) => {
  if (isOriginal) {
    if (originalVideoSubtitle.value.length == 0) {
      return;
    }
    const srtContent = webVttToSrt(originalVideoSubtitle.value);
    const blob = new Blob([srtContent], { type: "text/srt" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${generateFileName(isOriginal)}.srt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    if (ys.translatedVideoSubtitle.length == 0) {
      return;
    }
    const srtContent = webVttToSrt(ys.translatedVideoSubtitle);
    const blob = new Blob([srtContent], { type: "text/srt" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${generateFileName(isOriginal)}.srt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

const downloadJsonFile = () => {
  const blob = new Blob([originalJsonContent.value], { type: "text/json" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `${generateFileName(true)}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

function webVttToSrt(webVttContent: any) {
  const lines = webVttContent.split("\n");
  let srtContent = "";
  let counter = 1;
  for (let i = 0; i < lines.length; i++) {
    if (lines[i].includes("-->")) {
      srtContent += counter + "\n";
      counter++;
      const timecode = lines[i].replace(".", ",").replace(" --> ", " --> ");
      srtContent += timecode + "\n";
      i++;
      while (i < lines.length && lines[i].trim() !== "") {
        srtContent += lines[i] + "\n";
        i++;
      }
      srtContent += "\n";
    }
  }
  return srtContent;
}

const downloadAsTxt = (isOriginal: boolean) => {
  let text = "";
  if (isOriginal) {
    if (showOriginalSummarized.value) {
      text = originalSummarizedText.value;
    } else {
      text = originalText.value;
    }
  } else {
    if (showTranslatedSummarized.value) {
      text = translatedSummarizedText.value;
    } else {
      text = translatedText.value;
    }
  }
  const blob = new Blob([text], {
    type: "text/plain;charset=utf-8",
  });
  saveAs(blob, `${generateFileName(isOriginal)}.txt`);
};

const normalizeText = (text: string, isArabic: boolean = false) => {
  console.log("=== TEXT NORMALIZATION ===");
  console.log("Input text length:", text.length);
  console.log("Is Arabic:", isArabic);
  console.log("Input preview (first 300 chars):", text.substring(0, 300));
  
  let normalized: string;
  if (isArabic) {
    normalized = text
      .split(/\n+/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0)
      .join("\n\n");
  } else {
    normalized = text
    .split("\n")
    .reduce((acc: any, line) => {
      const trimmedLine = line.trim();
      if (trimmedLine) {
        if (acc.length === 0) {
          return [trimmedLine];
        } else {
          const lastLine = acc[acc.length - 1];
          if (
            lastLine.endsWith(".") ||
            lastLine.endsWith("?") ||
            lastLine.endsWith("!")
          ) {
            return [...acc, trimmedLine];
          } else {
            return [...acc.slice(0, -1), `${lastLine} ${trimmedLine}`];
          }
        }
      }
      return acc;
    }, [])
    .join("\n");
  }
  
  console.log("Normalized text length:", normalized.length);
  console.log("Normalized preview (first 300 chars):", normalized.substring(0, 300));
  console.log("=== END NORMALIZATION ===\n");
  
  return normalized;
};

const preloadFont = async (fontFamily: string): Promise<boolean> => {
  if (fontLoadingCache.has(fontFamily)) {
    return fontLoadingCache.get(fontFamily)!;
  }
  
  const fontCheckString = `16px "${fontFamily}"`;
  let fontLoaded = false;
  
  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready;
  }
  
  if (document.fonts && document.fonts.check) {
    fontLoaded = document.fonts.check(fontCheckString);
  } else {
    fontLoaded = true;
  }
  
  if (!fontLoaded) {
    const maxAttempts = 10;
    let attempts = 0;
    while (!fontLoaded && attempts < maxAttempts) {
      if (document.fonts && document.fonts.check) {
        fontLoaded = document.fonts.check(fontCheckString);
      } else {
        fontLoaded = true;
        break;
      }
      if (!fontLoaded) {
        attempts++;
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }
  }
  
  fontLoadingCache.set(fontFamily, fontLoaded);
  return fontLoaded;
};

const hexToRgb = (hex: string): [number, number, number] => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ]
    : [0, 0, 0];
};

const getUserFriendlyError = (error: Error, pageNumber?: number): { message: string, technical: string } => {
  const technical = error.message || String(error);
  
  if (technical.includes('Cancelled') || technical.includes('cancelled')) {
    return {
      message: pageNumber ? `${t('pdf-generation-cancelled') || 'PDF generation cancelled'} (${t('pdf-page-failed', [pageNumber]) || `Page ${pageNumber}`})` : t('pdf-generation-cancelled') || 'PDF generation cancelled',
      technical
    };
  }
  
  if (technical.includes('Canvas') || technical.includes('canvas')) {
    return {
      message: pageNumber ? t('pdf-page-failed', [pageNumber]) || `Failed to render page ${pageNumber}. Please try again.` : 'Failed to render PDF pages. Please try again.',
      technical
    };
  }
  
  if (technical.includes('font') || technical.includes('Font')) {
    return {
      message: 'Font loading failed. Please try again or use a different font.',
      technical
    };
  }
  
  if (technical.includes('html2canvas') || technical.includes('Failed to load')) {
    return {
      message: 'Failed to load required resources. Please check your internet connection and try again.',
      technical
    };
  }
  
  return {
    message: pageNumber ? `${t('pdf-generation-failed') || 'PDF generation failed'} (${t('pdf-page-failed', [pageNumber]) || `Page ${pageNumber}`})` : t('pdf-generation-failed') || 'PDF generation failed. Please try again.',
    technical
  };
};

const cancelPdfGeneration = () => {
  pdfCancelled.value = true;
  pdfProgress.value.status = 'error';
};

const downloadAsPdfHTML = async (isOriginal: boolean, text: string, fontFamily: string, fontSize: number, color: string, formatting: ParagraphFormat[] = []) => {
  const DEBUG_DOWNLOAD_IMAGES = false;
  
  console.log("=== HTML-TO-PDF GENERATION (Page-by-Page) ===");
  if (DEBUG_DOWNLOAD_IMAGES) {
    console.log("🔍 DEBUG MODE: Will download canvas images instead of PDF");
  }
  console.log("Font:", fontFamily, "Size:", fontSize, "Color:", color);
  
  const isRtl: boolean = isOriginal
    ? originalLanguage.value.langCode === "ar"
    : ys.translationLanguage.langCode === "ar";
  
  isPdfGenerating.value = true;
  pdfCancelled.value = false;
  pdfError.value = null;
  pdfProgress.value = {
    currentPage: 0,
    totalPages: 0,
    percentage: 0,
    status: 'initializing'
  };
  
  const activeContainers: HTMLElement[] = [];
  
  try {
    pdfProgress.value.status = 'initializing';
    
    if (pdfCancelled.value) {
      throw new Error('Cancelled by user');
    }
    
    const fontLoaded = await preloadFont(fontFamily);
    if (!fontLoaded) {
      console.warn(`⚠️ Font "${fontFamily}" may not be fully loaded`);
    } else {
      console.log(`✅ Font "${fontFamily}" is confirmed loaded`);
    }
    
    const ensureHtml2Canvas = async (): Promise<any> => {
      if ((window as any).html2canvas) {
        return (window as any).html2canvas;
      }
      if (html2canvasLoadPromise) {
        await html2canvasLoadPromise;
        return (window as any).html2canvas;
      }
      
      html2canvasLoadPromise = new Promise<void>((resolve, reject) => {
        if ((window as any).html2canvas) {
          resolve();
          return;
        }
        
        const existingScript = document.querySelector('script[src*="html2canvas"]');
        if (existingScript) {
          existingScript.addEventListener('load', () => resolve());
          existingScript.addEventListener('error', () => reject(new Error("Failed to load html2canvas")));
          return;
        }
        
        console.log("Loading html2canvas from CDN...");
        const script = document.createElement("script");
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          html2canvasLoadPromise = null;
          reject(new Error("Failed to load html2canvas"));
        };
        document.head.appendChild(script);
      });
      
      await html2canvasLoadPromise;
      return (window as any).html2canvas;
    };
    
    const html2canvasLib = await ensureHtml2Canvas();
    
    const pageWidthMM = 210;
    const pageHeightMM = 297;
    const marginMM = 20;
    const contentWidthMM = pageWidthMM - (marginMM * 2);
    const dpi = 96;
    const contentWidthPX = Math.round((contentWidthMM / 25.4) * dpi);
    const pageHeightPX = Math.round((pageHeightMM / 25.4) * dpi);
    const marginPX = Math.round((marginMM / 25.4) * dpi);
    const contentHeightPX = pageHeightPX - (marginPX * 2);
    
    if (!text || text.trim().length === 0) {
      console.error("Empty text provided for PDF generation");
      throw new Error("Cannot generate PDF from empty text");
    }
    
    console.log("PDF Generation - Input text length:", text.length);
    console.log("PDF Generation - Formatting provided:", formatting?.length || 0);
    
    let paragraphs: string[] = [];
    let paragraphFormats: ParagraphFormat[] = [];
    
    if (formatting && formatting.length > 0) {
      const validFormats = formatting.filter(f => f && f.text && f.text.trim().length > 0);
      paragraphs = validFormats.map(f => f.text.trim());
      paragraphFormats = validFormats;
      console.log(`Using formatted paragraphs: ${paragraphs.length} paragraphs with formatting`);
      if (paragraphs.length === 0) {
        console.error("All formatted paragraphs are empty!");
        throw new Error("Cannot generate PDF: All paragraphs are empty");
      }
    } else {
      paragraphs = text.split(/\n\n+/).filter((p: string) => p.trim().length > 0);
      if (paragraphs.length === 0) {
        console.warn("No paragraphs found, using full text as single paragraph");
        paragraphs.push(text.trim());
      }
      const defaultAlignment = isRtl ? 'right' : 'left';
      paragraphFormats = paragraphs.map((p: string) => ({
        text: p,
        alignment: defaultAlignment as 'left' | 'center' | 'right' | 'justify',
        bold: false,
        italic: false,
        underline: false,
      }));
      console.log(`Processing ${paragraphs.length} paragraphs for PDF generation`);
    }
    
    console.log("Final paragraphs count:", paragraphs.length);
    console.log("Final formats count:", paragraphFormats.length);
    if (paragraphs.length > 0) {
      console.log("First paragraph preview:", paragraphs[0]?.substring(0, 50));
    }
    
    if (paragraphs.length === 0 || paragraphFormats.length === 0) {
      console.error("No paragraphs to process! paragraphs:", paragraphs.length, "formats:", paragraphFormats.length);
      throw new Error("Cannot generate PDF: No paragraphs found");
    }
    
    // Inject @font-face CSS rule for the selected font if not already present
    const fontFaceId = `pdf-font-face-${fontFamily.replace(/\s+/g, '-').toLowerCase()}`;
    let fontFaceElement = document.getElementById(fontFaceId) as HTMLStyleElement;
    
    if (!fontFaceElement && fontFamily) {
      // Get font URL from fontStore
      const font = fontStore.fonts.find((f: any) => f.name === fontFamily);
      if (font && font.files && font.files.regular) {
        console.log(`Injecting @font-face for "${fontFamily}" with URL: ${font.files.regular}`);
        fontFaceElement = document.createElement('style');
        fontFaceElement.id = fontFaceId;
        fontFaceElement.textContent = `
          @font-face {
            font-family: "${fontFamily}";
            src: url("${font.files.regular}") format("truetype");
            font-weight: normal;
            font-style: normal;
            font-display: swap;
          }
        `;
        document.head.appendChild(fontFaceElement);
        console.log(`✅ @font-face injected for "${fontFamily}"`);
        
        // Wait a bit for the font-face to be processed
        await new Promise(resolve => setTimeout(resolve, 300));
      } else {
        console.warn(`⚠️ Font "${fontFamily}" not found in fontStore, cannot inject @font-face`);
      }
    } else if (fontFaceElement) {
      console.log(`@font-face for "${fontFamily}" already exists`);
    }
    
    if (paragraphs.length !== paragraphFormats.length) {
      console.warn(`Mismatch: ${paragraphs.length} paragraphs but ${paragraphFormats.length} formats. Adjusting...`);
      while (paragraphFormats.length < paragraphs.length) {
        const defaultAlignment = isRtl ? 'right' : 'left';
        paragraphFormats.push({
          text: paragraphs[paragraphFormats.length],
          alignment: defaultAlignment as 'left' | 'center' | 'right' | 'justify',
          bold: false,
          italic: false,
          underline: false,
        });
      }
    }
    
    const doc = DEBUG_DOWNLOAD_IMAGES ? null : new jsPDF("p", "mm", "a4");
    // Track if we've used the first page (jsPDF auto-creates page 1)
    let firstPageUsed = false;
    // Store images for debug download
    const debugImages: Array<{imgData: string, pageNumber: number}> = [];
    
    let currentPageParagraphs: string[] = [];
    let currentPageFormats: ParagraphFormat[] = [];
    let currentPageHeight = 0;
    let currentPageStartIndex = 0; // Track starting paragraph index for current page
    const paragraphSpacingPX = Math.round(fontSize * 0.8); // Reduced spacing to prevent cutting issues
    
    const renderPage = async (pageParagraphs: string[], pageFormats: ParagraphFormat[], startParagraphIndex?: number): Promise<{imgData: string, widthMM: number, heightMM: number, canvasWidth: number, canvasHeight: number}> => {
      console.log(`Rendering page with ${pageParagraphs.length} paragraphs${startParagraphIndex !== undefined ? ` (starting at paragraph index ${startParagraphIndex})` : ''}`);
      
      if (pageParagraphs.length === 0) {
        console.warn("No paragraphs to render, skipping page");
        throw new Error("Cannot render empty page");
      }
      
      const pageContainer = document.createElement("div");
      pageContainer.style.position = "fixed";
      pageContainer.style.top = "0";
      pageContainer.style.left = "0";
      pageContainer.style.width = `${contentWidthPX + (marginPX * 2)}px`;
      pageContainer.style.maxWidth = `${contentWidthPX + (marginPX * 2)}px`;
      pageContainer.style.minWidth = `${contentWidthPX + (marginPX * 2)}px`;
      pageContainer.style.paddingTop = "0";
      pageContainer.style.paddingLeft = "0";
      pageContainer.style.paddingRight = "0";
      pageContainer.style.paddingBottom = "0";
      pageContainer.style.backgroundColor = "#ffffff";
      pageContainer.style.fontFamily = `"${fontFamily}", Arial, sans-serif`;
      pageContainer.style.fontSize = `${fontSize}pt`;
      pageContainer.style.color = color;
      pageContainer.style.direction = isRtl ? "rtl" : "ltr";
      pageContainer.style.lineHeight = "1.6";
      pageContainer.style.wordWrap = "break-word";
      pageContainer.style.overflowWrap = "break-word";
      pageContainer.style.boxSizing = "border-box";
      pageContainer.style.display = "block";
      pageContainer.style.visibility = "visible";
      pageContainer.style.opacity = "1";
      pageContainer.style.pointerEvents = "none";
      pageContainer.style.transform = "translateX(-9999px) translateZ(0)";
      pageContainer.style.overflow = "visible";
      pageContainer.style.zIndex = "-9999";
      
      pageParagraphs.forEach((paragraph: string, index: number) => {
        const trimmedParagraph = paragraph.trim();
        if (trimmedParagraph) {
          const p = document.createElement("p");
          const defaultAlignment = isRtl ? 'right' : 'left';
          const format = pageFormats[index] || {
            text: trimmedParagraph,
            alignment: defaultAlignment as 'left' | 'center' | 'right' | 'justify',
            bold: false,
            italic: false,
            underline: false,
          };
          
          p.style.margin = "0";
          p.style.marginTop = index > 0 ? `${paragraphSpacingPX}px` : "0";
          p.style.marginBottom = "0";
          p.style.padding = "0";
          if (index === pageParagraphs.length - 1) {
            p.style.marginBottom = "0";
            p.style.paddingBottom = "0";
          }
          p.style.wordWrap = "break-word";
          p.style.overflowWrap = "break-word";
          p.style.wordBreak = "break-word";
          p.style.hyphens = "auto";
          p.style.whiteSpace = "normal";
          p.style.display = "block";
          p.style.width = `${contentWidthPX}px`;
          p.style.maxWidth = `${contentWidthPX}px`;
          p.style.minWidth = "0";
          p.style.boxSizing = "border-box";
          p.style.textAlign = format.alignment;
          if (isRtl) {
            p.style.unicodeBidi = "bidi-override";
          }
          p.style.fontFamily = `"${fontFamily}", Arial, sans-serif`;
          p.style.fontWeight = format.bold ? "bold" : "normal";
          p.style.fontStyle = format.italic ? "italic" : "normal";
          p.style.textDecoration = format.underline ? "underline" : "none";
          p.style.lineHeight = "1.2";
          p.style.overflow = "visible";
          p.textContent = trimmedParagraph;
          pageContainer.appendChild(p);
        }
      });
      
      document.body.appendChild(pageContainer);
      activeContainers.push(pageContainer);
      
      console.log(`📄 Page container created with ${pageContainer.children.length} paragraph children`);
      
      await new Promise(resolve => setTimeout(resolve, 100));
      
      const paragraphs = Array.from(pageContainer.querySelectorAll('p')) as HTMLElement[];
      let contentMinX = Infinity;
      let contentMinY = Infinity;
      let contentMaxX = -Infinity;
      let contentMaxY = -Infinity;
      
      if (paragraphs.length > 0) {
        const containerRect = pageContainer.getBoundingClientRect();
        
        paragraphs.forEach((p) => {
          const pRect = p.getBoundingClientRect();
          const relX = pRect.left - containerRect.left;
          const relY = pRect.top - containerRect.top;
          const relRight = relX + pRect.width;
          const elementBottom = pRect.bottom - containerRect.top;
          
          let textWidth = pRect.width;
          try {
            const range = document.createRange();
            range.selectNodeContents(p);
            const textRect = range.getBoundingClientRect();
            
            if (textRect.width > 0) {
              textWidth = textRect.width;
            }
            
            range.detach();
          } catch (error) {
            console.warn(`⚠️ Error using Range API for paragraph width:`, error);
          }
          
          contentMinX = Math.min(contentMinX, relX);
          contentMinY = Math.min(contentMinY, relY);
          contentMaxX = Math.max(contentMaxX, relRight);
          contentMaxY = Math.max(contentMaxY, elementBottom);
        });
        
        const exactContentWidth = Math.ceil(contentMaxX - contentMinX);
        const exactContentHeight = Math.ceil(contentMaxY - contentMinY);
        
        let computedLineHeightPX = fontSize * 1.2;
        if (paragraphs.length > 0) {
          const firstParagraph = paragraphs[0];
          const computedStyle = window.getComputedStyle(firstParagraph);
          const lineHeightValue = computedStyle.lineHeight;
          
          if (lineHeightValue && lineHeightValue !== 'normal') {
            if (lineHeightValue.includes('px')) {
              computedLineHeightPX = parseFloat(lineHeightValue);
            } else {
              const numericValue = parseFloat(lineHeightValue);
              if (!isNaN(numericValue)) {
                computedLineHeightPX = fontSize * numericValue;
              }
            }
          }
        }
        
        const descenderPadding = Math.ceil(fontSize * 0.25);
        const lineHeightSpacing = computedLineHeightPX - fontSize;
        const lineHeightPadding = Math.ceil(lineHeightSpacing / 2);
        const totalPadding = descenderPadding + lineHeightPadding;
        const boundsHeightWithPadding = exactContentHeight + totalPadding;
        const lastLineExtraPadding = Math.ceil(computedLineHeightPX + descenderPadding);
        const boundsHeightWithBuffer = (boundsHeightWithPadding + lastLineExtraPadding) * 1.15;
        
        const containerScrollHeight = pageContainer.scrollHeight;
        const finalHeight = Math.max(boundsHeightWithBuffer, containerScrollHeight * 1.1);
        
        (pageContainer as any).__contentBounds = {
          x: contentMinX,
          y: contentMinY,
          width: exactContentWidth,
          height: finalHeight
        };
      } else {
        const exactContentHeight = pageContainer.scrollHeight;
        (pageContainer as any).__contentBounds = {
          x: 0,
          y: 0,
          width: pageContainer.offsetWidth,
          height: exactContentHeight
        };
      }
      
      if (document.fonts && document.fonts.ready) {
        await document.fonts.ready;
      }
      
      const containerFontCheck = `16px "${fontFamily}"`;
      let containerFontLoaded = false;
      if (document.fonts && document.fonts.check) {
        containerFontLoaded = document.fonts.check(containerFontCheck);
        
        if (!containerFontLoaded) {
          for (let i = 0; i < 5; i++) {
            await new Promise(resolve => setTimeout(resolve, 400));
            containerFontLoaded = document.fonts.check(containerFontCheck);
            if (containerFontLoaded) {
              break;
            }
          }
        }
      }
      
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      try {
        const contentBounds = (pageContainer as any).__contentBounds || {
          x: 0,
          y: 0,
          width: pageContainer.offsetWidth,
          height: pageContainer.offsetHeight
        };
        
        const containerScrollHeight = pageContainer.scrollHeight;
        const captureHeight = Math.max(contentBounds.height, containerScrollHeight * 1.2);
        
        const canvas = await html2canvasLib(pageContainer, {
          scale: 2,
          useCORS: true,
          logging: true,
          backgroundColor: "#ffffff",
          x: contentBounds.x,
          y: contentBounds.y,
          width: contentBounds.width,
          height: captureHeight,
          windowWidth: contentBounds.width,
          windowHeight: captureHeight,
          scrollX: 0,
          scrollY: 0,
          allowTaint: false,
          removeContainer: false,
          onclone: (clonedDoc: any, element: any) => {
            const fontFaceId = `pdf-font-face-${fontFamily.replace(/\s+/g, '-').toLowerCase()}`;
            const originalFontFace = document.getElementById(fontFaceId) as HTMLStyleElement;
            
            if (originalFontFace && clonedDoc) {
              let clonedFontFace = clonedDoc.getElementById(fontFaceId);
              if (!clonedFontFace) {
                const styleElement = clonedDoc.createElement('style');
                styleElement.id = fontFaceId;
                styleElement.textContent = originalFontFace.textContent;
                clonedDoc.head.appendChild(styleElement);
              }
            }
            
            const cloned = element as HTMLElement;
            cloned.style.visibility = "visible";
            cloned.style.opacity = "1";
            cloned.style.position = "absolute";
            cloned.style.top = "0";
            cloned.style.left = "0";
            cloned.style.display = "block";
            cloned.style.overflow = "visible";
            cloned.style.backgroundColor = "#ffffff";
            cloned.style.transform = "translateX(0) translateZ(0)";
            cloned.style.width = `${contentWidthPX + (marginPX * 2)}px`;
            cloned.style.maxWidth = `${contentWidthPX + (marginPX * 2)}px`;
            cloned.style.minWidth = `${contentWidthPX + (marginPX * 2)}px`;
            cloned.style.fontFamily = `"${fontFamily}", Arial, sans-serif`;
            
            const paragraphs = cloned.querySelectorAll("p");
            paragraphs.forEach((p: any, index: number) => {
              p.style.visibility = "visible";
              p.style.opacity = "1";
              p.style.color = color; // Ensure color is applied
              p.style.width = `${contentWidthPX}px`; // Use exact content width
              p.style.maxWidth = `${contentWidthPX}px`; // Prevent overflow
              p.style.fontFamily = `"${fontFamily}", Arial, sans-serif`; // Explicitly set font
              p.style.wordWrap = "break-word";
              p.style.overflowWrap = "break-word";
              p.style.wordBreak = "break-word"; // Additional safeguard
              p.style.hyphens = "auto"; // Better word breaking
              p.style.overflow = "visible";
              p.style.lineHeight = "1.2"; // Restored to 1.2 for better readability
              if (isRtl) {
                p.style.unicodeBidi = "bidi-override"; // Ensure proper RTL rendering
              }
              
              // Log font verification for first paragraph
              const getDocument = (doc: any): Document => doc as Document;
              const docForView = getDocument(clonedDoc);
              if (index === 0) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - html2canvas passes Document, TypeScript incorrectly infers File
                if (docForView.defaultView) {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore - html2canvas passes Document, TypeScript incorrectly infers File
                  const computedStyle = docForView.defaultView.getComputedStyle(p);
                  console.log(`📝 Cloned paragraph ${index} computed font-family: ${computedStyle.fontFamily}`);
                }
              }
            });
            console.log("onclone: Cloned element styled for capture, paragraphs:", paragraphs.length);
          }
        });
        
        if (!canvas || canvas.width === 0 || canvas.height === 0) {
          if (pageContainer && pageContainer.parentNode === document.body) {
            document.body.removeChild(pageContainer);
          }
          throw new Error("Canvas generation failed: empty canvas");
        }
        
        const ctx = canvas.getContext("2d");
        if (ctx) {
          const sampleAreas = [
            { x: 0, y: 0, w: Math.min(canvas.width, 200), h: Math.min(canvas.height, 200) },
            { x: Math.max(0, canvas.width / 2 - 100), y: Math.max(0, canvas.height / 2 - 100), w: 200, h: 200 },
            { x: Math.max(0, canvas.width - 200), y: Math.max(0, canvas.height - 200), w: 200, h: 200 }
          ];
          
          let hasNonWhitePixels = false;
          let hasTextColorPixels = false;
          const colorRgb = hexToRgb(color);
          
          for (const area of sampleAreas) {
            if (area.x >= canvas.width || area.y >= canvas.height) continue;
            
            const actualW = Math.min(area.w, canvas.width - area.x);
            const actualH = Math.min(area.h, canvas.height - area.y);
            if (actualW <= 0 || actualH <= 0) continue;
            
            const imageData = ctx.getImageData(area.x, area.y, actualW, actualH);
            const pixels = imageData.data;
            
            for (let i = 0; i < pixels.length; i += 4) {
              const r = pixels[i];
              const g = pixels[i + 1];
              const b = pixels[i + 2];
              const a = pixels[i + 3];
              
              if (a > 0 && (r < 250 || g < 250 || b < 250)) {
                hasNonWhitePixels = true;
                
                const colorMatch = Math.abs(r - colorRgb[0]) < 50 && 
                                  Math.abs(g - colorRgb[1]) < 50 && 
                                  Math.abs(b - colorRgb[2]) < 50;
                if (colorMatch) {
                  hasTextColorPixels = true;
                  break;
                }
              }
            }
            
            if (hasTextColorPixels) break;
          }
          
          if (!hasNonWhitePixels) {
            console.warn("⚠️ Canvas appears to be all white/transparent - this might indicate a rendering issue");
            console.warn(`Canvas size: ${canvas.width}x${canvas.height}, Container children: ${pageContainer.children.length}`);
          } else if (!hasTextColorPixels) {
            console.warn("⚠️ Canvas has content but no text color pixels detected - might be rendering issue");
          } else {
            console.log("✅ Canvas validation: Contains text color pixels (has content)");
          }
          
          // Canvas post-processing removed - let html2canvas capture naturally
          // Aggressive cropping was causing content to be cut off
        }
        
        const imgData = canvas.toDataURL("image/png");
        const imgDataSizeKB = Math.round(imgData.length / 1024);
        console.log(`Image data length: ${imgData.length} bytes (${imgDataSizeKB} KB)`);
        console.log(`Image data preview: ${imgData.substring(0, 50)}...`);
        console.log(`Image data valid: ${imgData.startsWith('data:image/png')}`);
        
        if (!imgData || imgData === "data:," || imgData.length < 100) {
          console.error("Invalid image data!");
          console.error(`Image data was: ${imgData ? imgData.substring(0, 100) : 'null/undefined'}`);
          if (pageContainer && pageContainer.parentNode === document.body) {
            document.body.removeChild(pageContainer);
          }
          throw new Error("Failed to convert canvas to image data");
        }
        
        // Additional validation: check if image data is not just a white image
        if (imgData.length < 5000) {
          console.warn("⚠️ Image data seems unusually small - might be a white/empty image");
        }
        
        // Debug: Download image for 2nd paragraph (index 1) for verification
        if (startParagraphIndex === 1) {
          try {
            console.log("🔍 DEBUG: Downloading canvas image for 2nd paragraph...");
            const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
            const filename = `debug-paragraph-2-${timestamp}.png`;
            
            // Convert data URL to blob
            const byteString = atob(imgData.split(',')[1]);
            const mimeString = imgData.split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type: mimeString });
            
            // Create download link and trigger download
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            
            console.log(`✅ DEBUG: Downloaded canvas image as ${filename}`);
          } catch (error) {
            console.warn(`⚠️ DEBUG: Failed to download canvas image:`, error);
          }
        }
        
        if (pageContainer && pageContainer.parentNode === document.body) {
          document.body.removeChild(pageContainer);
        }
        
        const scale = 2;
        const dpi = 96;
        const mmPerInch = 25.4;
        const actualCanvasWidth = canvas.width / scale;
        const actualCanvasHeight = canvas.height / scale;
        const imageWidthMM = (actualCanvasWidth / dpi) * mmPerInch;
        const imageHeightMM = (actualCanvasHeight / dpi) * mmPerInch;
        
        return {
          imgData,
          widthMM: imageWidthMM,
          heightMM: imageHeightMM,
          canvasWidth: canvas.width,
          canvasHeight: canvas.height
        };
      } catch (error) {
        if (pageContainer && pageContainer.parentNode === document.body) {
          document.body.removeChild(pageContainer);
        }
        console.error("Error in renderPage:", error);
        throw error;
      }
    };
    
    pdfProgress.value.status = 'rendering';
    console.log(`Starting page splitting for ${paragraphs.length} paragraphs`);
    
    let estimatedPages = 1;
    let tempHeight = 0;
    for (let i = 0; i < Math.min(paragraphs.length, 100); i++) {
      const testContainer = document.createElement("div");
      testContainer.style.position = "absolute";
      testContainer.style.top = "0";
      testContainer.style.left = "0";
      testContainer.style.width = `${contentWidthPX}px`;
      testContainer.style.fontFamily = fontFamily || "Arial";
      testContainer.style.fontSize = `${fontSize}pt`;
      testContainer.style.lineHeight = "1.6";
      testContainer.style.visibility = "hidden";
      testContainer.style.opacity = "0";
      testContainer.textContent = paragraphs[i]?.trim() || '';
      document.body.appendChild(testContainer);
      await new Promise(resolve => setTimeout(resolve, 10));
      const rect = testContainer.getBoundingClientRect();
      const paraHeight = Math.ceil(rect.height);
      document.body.removeChild(testContainer);
      const spacing = tempHeight > 0 ? paragraphSpacingPX : 0;
      const totalH = tempHeight + spacing + paraHeight;
      if (totalH > contentHeightPX && tempHeight > 0) {
        estimatedPages++;
        tempHeight = paraHeight;
      } else {
        tempHeight = totalH;
      }
    }
    estimatedPages = Math.max(estimatedPages, Math.ceil(paragraphs.length / 10));
    
    if (estimatedPages > 50) {
      console.warn(`Large document detected: ${estimatedPages} pages. This may take longer and use more memory.`);
    }
    
    pdfProgress.value.totalPages = estimatedPages;
    pdfProgress.value.status = 'rendering';
    
    let renderedPages = 0;
    
    for (let i = 0; i < paragraphs.length; i++) {
      if (pdfCancelled.value) {
        throw new Error('Cancelled by user');
      }
      const paragraph = paragraphs[i];
      let format = paragraphFormats[i];
      
      if (!paragraph || paragraph.trim().length === 0) {
        continue;
      }
      
      if (!format) {
        const defaultAlignment = isRtl ? 'right' : 'left';
        format = {
          text: paragraph,
          alignment: defaultAlignment as 'left' | 'center' | 'right' | 'justify',
          bold: false,
          italic: false,
          underline: false,
        };
        paragraphFormats[i] = format;
      }
      
      const testContainer = document.createElement("div");
      testContainer.style.position = "absolute";
      testContainer.style.top = "0";
      testContainer.style.left = "0";
      testContainer.style.width = `${contentWidthPX}px`;
      testContainer.style.maxWidth = `${contentWidthPX}px`;
      testContainer.style.minWidth = "0";
      testContainer.style.fontFamily = fontFamily || "Arial";
      testContainer.style.fontSize = `${fontSize}pt`;
      testContainer.style.lineHeight = "1.6";
      testContainer.style.wordWrap = "break-word";
      testContainer.style.overflowWrap = "break-word";
      testContainer.style.wordBreak = "break-word";
      testContainer.style.hyphens = "auto";
      testContainer.style.padding = "0";
      testContainer.style.margin = "0";
      testContainer.style.visibility = "hidden";
      testContainer.style.opacity = "0";
      testContainer.style.pointerEvents = "none";
      testContainer.style.direction = isRtl ? "rtl" : "ltr";
      testContainer.style.textAlign = format?.alignment || (isRtl ? "right" : "left");
      testContainer.style.fontWeight = format?.bold ? "bold" : "normal";
      testContainer.style.fontStyle = format?.italic ? "italic" : "normal";
      testContainer.style.textDecoration = format?.underline ? "underline" : "none";
      testContainer.style.overflow = "hidden";
      testContainer.style.boxSizing = "border-box";
      if (isRtl) {
        testContainer.style.unicodeBidi = "bidi-override";
      }
      testContainer.textContent = paragraph.trim();
      document.body.appendChild(testContainer);
      
      await new Promise(resolve => setTimeout(resolve, 50));
      
      const rect = testContainer.getBoundingClientRect();
      const paragraphHeight = Math.ceil(rect.height);
      
      document.body.removeChild(testContainer);
      
      const spacing = currentPageParagraphs.length > 0 ? paragraphSpacingPX : 0;
      const totalHeight = currentPageHeight + spacing + paragraphHeight;
      
      if (totalHeight > contentHeightPX && currentPageParagraphs.length > 0) {
        if (currentPageParagraphs.length === 0 || currentPageFormats.length === 0) {
          continue;
        }
        
        if (pdfCancelled.value) {
          throw new Error('Cancelled by user');
        }
        
        const pageResult = await renderPage(currentPageParagraphs, currentPageFormats, currentPageStartIndex);
        renderedPages++;
        pdfProgress.value.currentPage = renderedPages;
        pdfProgress.value.percentage = Math.round((renderedPages / estimatedPages) * 100);
        
        if (!pageResult.imgData || pageResult.imgData.length < 100 || !pageResult.imgData.startsWith('data:image/png')) {
          throw new Error("Invalid image data received from renderPage");
        }
        
        const xPosition = marginMM;
        const yPosition = marginMM;
        const imageWidthMM = Math.min(pageResult.widthMM, pageWidthMM);
        const imageHeightMM = Math.min(pageResult.heightMM, pageHeightMM);
        
        if (DEBUG_DOWNLOAD_IMAGES) {
          const pageNumber = debugImages.length + 1;
          debugImages.push({ imgData: pageResult.imgData, pageNumber });
        } else {
          if (!firstPageUsed) {
            doc!.setPage(1);
            doc!.deletePage(1);
            doc!.addPage();
            doc!.addImage(pageResult.imgData, "PNG", xPosition, yPosition, imageWidthMM, imageHeightMM);
            firstPageUsed = true;
          } else {
            doc!.addPage();
            doc!.addImage(pageResult.imgData, "PNG", xPosition, yPosition, imageWidthMM, imageHeightMM);
          }
        }
        
        pageResult.imgData = '';
        
        currentPageParagraphs = [paragraph];
        currentPageFormats = [format];
        currentPageHeight = paragraphHeight;
        currentPageStartIndex = i;
      } else {
        if (currentPageParagraphs.length === 0) {
          currentPageStartIndex = i;
        }
        currentPageParagraphs.push(paragraph);
        currentPageFormats.push(format);
        currentPageHeight = totalHeight;
      }
    }
    
    if (currentPageParagraphs.length > 0 && currentPageFormats.length > 0) {
      try {
        const validParagraphs = currentPageParagraphs.filter(p => p && p.trim().length > 0);
        if (validParagraphs.length === 0) {
          throw new Error("Cannot render page with empty paragraphs");
        }
        
        if (pdfCancelled.value) {
          throw new Error('Cancelled by user');
        }
        
        const pageResult = await renderPage(currentPageParagraphs, currentPageFormats, currentPageStartIndex);
        renderedPages++;
        pdfProgress.value.currentPage = renderedPages;
        pdfProgress.value.totalPages = renderedPages;
        pdfProgress.value.percentage = 100;
        
        if (!pageResult.imgData || pageResult.imgData.length < 100 || !pageResult.imgData.startsWith('data:image/png')) {
          throw new Error("Invalid image data received from renderPage");
        }
        
        const xPosition = marginMM;
        const yPosition = marginMM;
        const imageWidthMM = Math.min(pageResult.widthMM, pageWidthMM);
        const imageHeightMM = Math.min(pageResult.heightMM, pageHeightMM);
        
        if (DEBUG_DOWNLOAD_IMAGES) {
          const pageNumber = debugImages.length + 1;
          debugImages.push({ imgData: pageResult.imgData, pageNumber });
        } else {
          if (!firstPageUsed) {
            doc!.setPage(1);
            doc!.deletePage(1);
            doc!.addPage();
            doc!.addImage(pageResult.imgData, "PNG", xPosition, yPosition, imageWidthMM, imageHeightMM);
            firstPageUsed = true;
          } else {
            doc!.addPage();
            doc!.addImage(pageResult.imgData, "PNG", xPosition, yPosition, imageWidthMM, imageHeightMM);
          }
        }
        
        pageResult.imgData = '';
      } catch (error) {
        console.error("Error rendering final page:", error);
        throw error;
      }
    } else {
      if (!DEBUG_DOWNLOAD_IMAGES && doc && doc.getNumberOfPages() === 0) {
        throw new Error("PDF generation failed: No pages were created");
      }
      if (DEBUG_DOWNLOAD_IMAGES && debugImages.length === 0) {
        throw new Error("Image generation failed: No images were created");
      }
    }
    
    if (DEBUG_DOWNLOAD_IMAGES) {
      console.log(`🔍 DEBUG MODE: Downloading ${debugImages.length} images instead of PDF`);
      
      if (debugImages.length === 0) {
        throw new Error("Failed to generate images: No images created");
      }
      
      for (let i = 0; i < debugImages.length; i++) {
        const { imgData, pageNumber } = debugImages[i];
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
        const fileName = `debug-page-${pageNumber}-${timestamp}.png`;
        
        try {
          const byteString = atob(imgData.split(',')[1]);
          const mimeString = imgData.split(',')[0].split(':')[1].split(';')[0];
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let j = 0; j < byteString.length; j++) {
            ia[j] = byteString.charCodeAt(j);
          }
          const blob = new Blob([ab], { type: mimeString });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.style.display = 'none';
          document.body.appendChild(link);
          await new Promise(resolve => setTimeout(resolve, i * 500));
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        } catch (error) {
          console.error(`❌ DEBUG: Failed to download image for page ${pageNumber}:`, error);
        }
      }
    } else {
      if (!doc || doc.getNumberOfPages() === 0) {
        throw new Error("Failed to generate PDF: No pages created");
      }
      
      const fileName = `${generateFileName(isOriginal)}.pdf`;
      doc.save(fileName);
    }
  } catch (error) {
    console.error("HTML-to-PDF error:", error);
    const errorInfo = getUserFriendlyError(error instanceof Error ? error : new Error(String(error)));
    pdfError.value = {
      message: errorInfo.message,
      technical: errorInfo.technical
    };
    pdfProgress.value.status = 'error';
  } finally {
    activeContainers.forEach(container => {
      if (container && container.parentNode === document.body) {
        try {
          document.body.removeChild(container);
        } catch (e) {
          console.warn('Failed to remove container:', e);
        }
      }
    });
    activeContainers.length = 0;
    
    if (!pdfCancelled.value && !pdfError.value) {
      pdfProgress.value.status = 'complete';
    }
    
    isPdfGenerating.value = false;
  }
};

const showPdfPreviewModal = (isOriginal: boolean) => {
  let val = "";
  if (isOriginal) {
    if (showOriginalSummarized.value) {
      val = originalSummarizedText.value;
    } else {
      val = originalText.value;
    }
  } else {
    if (showTranslatedSummarized.value) {
      val = translatedSummarizedText.value;
    } else {
      val = translatedText.value;
    }
  }

  const isArabic: boolean = isOriginal
    ? originalLanguage.value.langCode === "ar"
    : ys.translationLanguage.langCode === "ar";

  previewText.value = val;
  previewConfig.value = {
    isOriginal,
    fontFamily: fontFamily.value || "Arial",
    fontSize: fontSizeNumber.value || 12,
    color: pickedColor.value || "#000000",
    isRtl: isArabic,
  };
  showPdfPreview.value = true;
};

const closePdfPreview = () => {
  showPdfPreview.value = false;
};

const downloadAsPdfWithFormatting = async (isOriginal: boolean, editedText: string, formatting: ParagraphFormat[]) => {
  const selectedFont = fontFamily.value || "";
  const selectedFontSize = fontSizeNumber.value || 12;
  const selectedColor = pickedColor.value || "#000000";
  
  const isArabic: boolean = isOriginal
    ? originalLanguage.value.langCode === "ar"
    : ys.translationLanguage.langCode === "ar";
  
  await downloadAsPdfHTML(isOriginal, editedText, selectedFont, selectedFontSize, selectedColor, formatting);
};

const exportPdfFromPreview = async (editedText: string, formatting: ParagraphFormat[]) => {
  showPdfPreview.value = false;
  previewFormatting.value = formatting;
  await downloadAsPdfWithFormatting(previewConfig.value.isOriginal, editedText, formatting);
};

const measureTextWidthHTML = (text: string, fontFamily: string, fontSize: number): number => {
  const measureElement = document.createElement("div");
  measureElement.style.position = "absolute";
  measureElement.style.visibility = "hidden";
  measureElement.style.whiteSpace = "nowrap";
  measureElement.style.fontFamily = fontFamily;
  measureElement.style.fontSize = `${fontSize}pt`;
  measureElement.style.direction = "rtl";
  measureElement.style.textAlign = "right";
  measureElement.textContent = text;
  
  document.body.appendChild(measureElement);
  const width = measureElement.offsetWidth * (72 / 96);
  document.body.removeChild(measureElement);
  
  return width;
};

const splitArabicTextByWords = (text: string, maxWidth: number, doc: any, fontName: string, fontSize: number): string[] => {
  console.log("=== CUSTOM ARABIC WORD-BOUNDARY SPLITTING (HTML-based measurement) ===");
  const paragraphs = text.split(/\n\n+/);
  const lines: string[] = [];
  
  doc.setFont(fontName, "normal");
  doc.setFontSize(fontSize);
  
  paragraphs.forEach((paragraph: string, paraIndex: number) => {
    const trimmedParagraph = paragraph.trim();
    if (!trimmedParagraph) return;
    
    console.log(`\n--- Processing Paragraph ${paraIndex + 1} ---`);
    console.log("Paragraph text:", trimmedParagraph.substring(0, 100));
    
    const words = trimmedParagraph.split(/\s+/).filter((w: string) => w.length > 0);
    console.log("Number of words:", words.length);
    console.log("First 10 words:", words.slice(0, 10));
    
    let currentLine = "";
    
    words.forEach((word: string, wordIndex: number) => {
      if (!word || word.trim().length === 0) return;
      
      const testLine = currentLine ? `${currentLine} ${word}` : word;
      
      const htmlWidth = measureTextWidthHTML(testLine, fontName, fontSize);
      const jsPdfWidth = doc.getTextWidth(testLine);
      
      const testWidth = htmlWidth > 0 ? htmlWidth : jsPdfWidth;
      
      if (testWidth > maxWidth && currentLine) {
        console.log(`  Word ${wordIndex}: "${word}" - Line too wide (${testWidth.toFixed(2)}pt > ${maxWidth.toFixed(2)}pt), wrapping`);
        console.log(`    HTML width: ${htmlWidth.toFixed(2)}pt, jsPDF width: ${jsPdfWidth.toFixed(2)}pt`);
        console.log(`    Adding line: "${currentLine}"`);
        if (currentLine.trim()) {
          lines.push(currentLine.trim());
        }
        currentLine = word;
      } else {
        currentLine = testLine;
        if (wordIndex < 5 || wordIndex % 20 === 0) {
          console.log(`  Word ${wordIndex}: "${word}" - Width: ${testWidth.toFixed(2)}pt (HTML: ${htmlWidth.toFixed(2)}pt, jsPDF: ${jsPdfWidth.toFixed(2)}pt), fits in line`);
        }
      }
    });
    
    if (currentLine && currentLine.trim()) {
      console.log(`  Final line: "${currentLine.trim()}"`);
      lines.push(currentLine.trim());
    }
    lines.push("");
  });
  
  if (lines.length > 0 && lines[lines.length - 1] === "") {
    lines.pop();
  }
  
  console.log(`\nTotal lines generated: ${lines.length}`);
  console.log("First 5 lines:", lines.slice(0, 5));
  console.log("=== END CUSTOM SPLITTING ===\n");
  
  return lines;
};

const getJsPdfFontName = (fontName: string): string => {
  if (!fontName || fontName.trim() === "") {
    return "helvetica";
  }
  
  const fontMap: { [key: string]: string } = {
    "arial": "helvetica",
    "helvetica": "helvetica",
    "times new roman": "times",
    "times": "times",
    "courier new": "courier",
    "courier": "courier",
    "roboto": "helvetica",
    "open sans": "helvetica",
    "lato": "helvetica",
    "montserrat": "helvetica",
    "raleway": "helvetica",
    "poppins": "helvetica",
    "source sans pro": "helvetica",
    "oswald": "helvetica",
    "merriweather": "times",
    "playfair display": "times",
    "lora": "times",
    "pt serif": "times",
    "inconsolata": "courier",
    "source code pro": "courier",
    "fira code": "courier",
  };
  
  const lowerFontName = fontName.toLowerCase().trim();
  
  if (fontMap[lowerFontName]) {
    return fontMap[lowerFontName];
  }
  
  for (const [key, value] of Object.entries(fontMap)) {
    if (lowerFontName.includes(key)) {
      return value;
    }
  }
  
  return "helvetica";
};

const downloadAsPdf = async (isOriginal: boolean) => {
  console.log("=== PDF GENERATION START ===");
  console.log("PDF Config:", {
    isOriginal: isOriginal,
    showOriginalSummarized: showOriginalSummarized.value,
    showTranslatedSummarized: showTranslatedSummarized.value,
    originalLanguage: originalLanguage.value?.langCode,
    translationLanguage: ys.translationLanguage?.langCode
  });
  
  try {
    let val = "";
    if (isOriginal) {
      if (showOriginalSummarized.value) {
        val = originalSummarizedText.value;
        console.log("Using original summarized text, length:", val.length);
      } else {
        val = originalText.value;
        console.log("Using original text, length:", val.length);
      }
    } else {
      if (showTranslatedSummarized.value) {
        val = translatedSummarizedText.value;
        console.log("Using translated summarized text, length:", val.length);
      } else {
        val = translatedText.value;
        console.log("Using translated text, length:", val.length);
      }
    }
    
    const isArabic: boolean = isOriginal
      ? originalLanguage.value.langCode === "ar"
      : ys.translationLanguage.langCode === "ar";
    const isChinese = isOriginal
      ? originalLanguage.value.langCode.includes("zh")
      : ys.translationLanguage.langCode.includes("zh");
    const isTurkish = isOriginal
      ? originalLanguage.value.langCode === "tr"
      : ys.translationLanguage.langCode === "tr";
    
    console.log("Language Detection:", {
      isArabic: isArabic,
      isChinese: isChinese,
      isTurkish: isTurkish,
      langCode: isOriginal ? originalLanguage.value.langCode : ys.translationLanguage.langCode
    });
    
    const text = normalizeText(val, isArabic);
    console.log("Text after normalization, length:", text.length);
    
    const selectedFont = fontFamily.value || "";
    const selectedFontSize = fontSizeNumber.value || 12;
    const selectedColor = pickedColor.value || "#000000";
    
    if (isArabic) {
      console.log("=== USING HTML-TO-PDF APPROACH FOR ARABIC ===");
      await downloadAsPdfHTML(isOriginal, text, selectedFont, selectedFontSize, selectedColor, []);
      return;
    }
    
    const doc = new jsPDF("p", "pt", "a4");
    const margin = isArabic ? 72 : 56.7;
    const sideMargin = isArabic ? 72 : 56.7;
    console.log("PDF Document created, page size:", doc.internal.pageSize);
    
    console.log("Font Settings from UI:", {
      selectedFont: selectedFont,
      selectedFontSize: selectedFontSize,
      selectedColor: selectedColor,
      fontFamilyValue: fontFamily.value,
      fontSizeNumberValue: fontSizeNumber.value,
      pickedColorValue: pickedColor.value
    });

    let pdfFontName = "helvetica";
    console.log("=== FONT SELECTION PROCESS ===");

    if (selectedFont) {
      console.log("Custom font selected from UI, processing...");
      console.log("=== CUSTOM FONT PROCESSING ===");
      console.log("Selected font from UI:", selectedFont);
      console.log("Total fonts in store:", fontStore.fonts.length);
      console.log("Available fonts in store:", fontStore.fonts.map((f: any) => ({ name: f.name, hasFiles: !!f.files, hasRegular: !!(f.files && f.files.regular) })));
      
      const font = fontStore.fonts.find((f: any) => f.name === selectedFont);
      console.log("Font search result:", font ? {
        name: font.name,
        hasFiles: !!font.files,
        hasRegular: !!(font.files && font.files.regular),
        regularUrl: font.files?.regular
      } : "NOT FOUND");
      
      if (font && font.files && font.files.regular) {
        try {
          console.log("Attempting to load font from URL:", font.files.regular);
          const startTime = Date.now();
          const fontBase64 = await loadFontBase(selectedFont, font.files.regular, () => {});
          const loadTime = Date.now() - startTime;
          console.log(`Font loading completed in ${loadTime}ms, base64 length:`, fontBase64 ? fontBase64.length : 0);
          
          if (fontBase64) {
            const fontFileName = `${selectedFont.replace(/\s+/g, "-")}-normal.ttf`;
            console.log("Registering font in jsPDF:", {
              fileName: fontFileName,
              fontName: selectedFont,
              base64Length: fontBase64.length
            });
            
            doc.addFileToVFS(fontFileName, fontBase64);
            doc.addFont(fontFileName, selectedFont, "normal");
            doc.setFont(selectedFont, "normal");
            pdfFontName = selectedFont;
            
            const registeredFont = doc.getFont();
            console.log("Font registered successfully. Current font:", registeredFont.fontName, "Style:", registeredFont.fontStyle);
            console.log("Font name matches:", registeredFont.fontName === selectedFont);
          } else {
            console.log("ERROR: Font base64 is null/undefined, falling back to built-in font mapping");
            pdfFontName = getJsPdfFontName(selectedFont);
            console.log("Mapped to built-in font:", pdfFontName);
          }
        } catch (error) {
          console.error("EXCEPTION: Failed to load custom font:", error);
          console.log("Falling back to helvetica");
          pdfFontName = "helvetica";
        }
      } else {
        console.log("Font not found in store or missing files. Details:", {
          fontFound: !!font,
          hasFiles: !!(font && font.files),
          hasRegular: !!(font && font.files && font.files.regular)
        });
        pdfFontName = getJsPdfFontName(selectedFont);
        console.log("Using built-in font mapping:", pdfFontName);
      }
      } else {
        console.log("No font selected, using default helvetica");
        pdfFontName = "helvetica";
      }

    console.log("=== APPLYING FONT SETTINGS ===");
    console.log("Setting font:", pdfFontName, "normal");
    
    if (isArabic) {
      doc.setLanguage("ar");
    }
    
    doc.setFont(pdfFontName, "normal");
    doc.setFontSize(selectedFontSize);
    doc.setLineHeightFactor(1.5);

    const [r, g, b] = hexToRgb(selectedColor);
    doc.setTextColor(r, g, b);
    
    const fontAfterSettings = doc.getFont();
    console.log("Font settings applied:", {
      fontName: fontAfterSettings.fontName,
      fontStyle: fontAfterSettings.fontStyle,
      fontSize: selectedFontSize,
      color: selectedColor,
      rgb: { r, g, b },
      expectedFontName: pdfFontName,
      fontMatches: fontAfterSettings.fontName === pdfFontName
    });

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const maxLineWidth = pageWidth - (sideMargin * 2);
    
    console.log("=== TEXT SPLITTING ===");
    console.log("Page dimensions:", {
      pageWidth: pageWidth,
      pageHeight: pageHeight,
      margin: margin,
      maxLineWidth: maxLineWidth
    });
    
    const currentFontBeforeSplit = doc.getFont();
    console.log("Font before splitTextToSize:", {
      fontName: currentFontBeforeSplit.fontName,
      fontStyle: currentFontBeforeSplit.fontStyle,
      expectedFontName: pdfFontName,
      matches: currentFontBeforeSplit.fontName === pdfFontName
    });
    
    let lines: string[];
    if (isArabic) {
      console.log("=== ARABIC TEXT SPLITTING ===");
      console.log("Original text length:", text.length);
      console.log("Original text preview (first 200 chars):", text.substring(0, 200));
      console.log("Max line width:", maxLineWidth);
      console.log("Font:", pdfFontName, "Size:", selectedFontSize);
      
      lines = splitArabicTextByWords(text, maxLineWidth, doc, pdfFontName, selectedFontSize);
    } else {
      lines = doc.splitTextToSize(text, maxLineWidth);
    }
    console.log("Text split into", lines.length, "lines");
    
    const currentFontAfterSplit = doc.getFont();
    console.log("Font after splitTextToSize:", {
      fontName: currentFontAfterSplit.fontName,
      fontStyle: currentFontAfterSplit.fontStyle,
      expectedFontName: pdfFontName,
      matches: currentFontAfterSplit.fontName === pdfFontName,
      fontChanged: currentFontAfterSplit.fontName !== currentFontBeforeSplit.fontName
    });
    
    if (currentFontAfterSplit.fontName !== pdfFontName) {
      console.log("WARNING: Font changed after splitTextToSize! Resetting...");
      doc.setFont(pdfFontName, "normal");
      doc.setFontSize(selectedFontSize);
    }
    
    const currentFontAfterReset = doc.getFont();
    console.log("Font after reset:", {
      fontName: currentFontAfterReset.fontName,
      fontStyle: currentFontAfterReset.fontStyle,
      expectedFontName: pdfFontName,
      matches: currentFontAfterReset.fontName === pdfFontName
    });

    console.log("=== RENDERING TEXT ===");
    
    let currentHeight = margin;
    let pageNumber = 1;
    let lineNumber = 0;
    let fontMismatchCount = 0;

    lines.forEach((line: string | string[]) => {
      lineNumber++;
      const lineSpacing = 1.5;
      const lineHeight = doc.getLineHeight() * lineSpacing;
      
      if (currentHeight + lineHeight > pageHeight - margin) {
        console.log(`Page ${pageNumber} complete, starting page ${pageNumber + 1}`);
        doc.addPage();
        pageNumber++;
        currentHeight = margin;
      }
      
      if (isArabic) {
        doc.setLanguage("ar");
      }
      doc.setFont(pdfFontName, "normal");
      doc.setFontSize(selectedFontSize);
      doc.setLineHeightFactor(lineSpacing);
      doc.setTextColor(r, g, b);
      
      const fontBeforeText = doc.getFont();
      const fontMatches = fontBeforeText.fontName === pdfFontName;
      
      if (!fontMatches) {
        fontMismatchCount++;
        if (fontMismatchCount <= 5) {
          console.log(`WARNING [Line ${lineNumber}]: Font mismatch before text render. Expected: ${pdfFontName}, Got: ${fontBeforeText.fontName}`);
          console.log(`  Resetting font to: ${pdfFontName}`);
          doc.setFont(pdfFontName, "normal");
        }
      }
      
      const paragraphSpacing = isArabic ? 8 : 6;
      
      if (line === "") {
        currentHeight += paragraphSpacing;
      } else {
        if (isArabic) {
          doc.text(line, pageWidth - sideMargin, currentHeight, { 
            align: "right",
            maxWidth: maxLineWidth
          });
        } else {
          doc.text(line, sideMargin, currentHeight, {
            maxWidth: maxLineWidth
          });
      }
        currentHeight += lineHeight;
      }
      
      const fontAfterText = doc.getFont();
      if (fontAfterText.fontName !== pdfFontName && !isArabic && !isChinese && !isTurkish) {
        if (fontMismatchCount <= 5) {
          console.log(`WARNING [Line ${lineNumber}]: Font changed after text render. Expected: ${pdfFontName}, Got: ${fontAfterText.fontName}`);
        }
      }
    });
    
    console.log("=== RENDERING COMPLETE ===");
    console.log("Summary:", {
      totalLines: lines.length,
      totalPages: pageNumber,
      fontMismatches: fontMismatchCount,
      finalFont: doc.getFont().fontName,
      expectedFont: pdfFontName
    });
    
    const fileName = `${generateFileName(isOriginal)}.pdf`;
    console.log("Saving PDF as:", fileName);
    doc.save(fileName);
    console.log("=== PDF GENERATION COMPLETE ===");
  } catch (error) {
    console.error("=== PDF GENERATION ERROR ===");
    console.error("Error details:", error);
    console.error("Error stack:", error instanceof Error ? error.stack : "No stack trace");
    console.log("downloadAsPdf error: ", error);
  }
};
const downloadAsDoc = async (isOriginal: boolean) => {
  let text = "";
  if (isOriginal) {
    if (showOriginalSummarized.value) {
      text = originalSummarizedText.value;
    } else {
      text = originalText.value;
    }
  } else {
    if (showTranslatedSummarized.value) {
      text = translatedSummarizedText.value;
    } else {
      text = translatedText.value;
    }
  }
  const docxFontSizeHalfPoints = getDocxExportFontSizeHalfPoints();
  const doc = new Document({
    sections: [
      {
        children: [
          new Paragraph({
            children: [
              new TextRun({
                text,
                size: docxFontSizeHalfPoints,
              }),
            ],
          }),
        ],
      },
    ],
  });
  const blob = await Packer.toBlob(doc);
  saveAs(blob, `${generateFileName(isOriginal)}.docx`);
};

const removeParentheses = (langName: string) => {
  return langName.replace(/\s*\(.*?\)\s*/g, "").trim();
};

function getCapitalizedFontName(fontFamily: string): string {
  const fontName = fontFamily.split(",")[0].replace(/['"]+/g, "").trim();
  return fontName
    .replace(/-/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

const tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
const firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
const fontFamilies = [
  "Aclonica",
  "arimo",
  "calligraffitti",
  "cherrycreamsoda",
  "chewy",
  "comingsoon",
  "cousine",
  "craftygirls",
  "creepstercaps",
  "serif",
  "sans-serif",
  "monospace",
  "cursive",
  "fantasy",
  "system-ui",
  "math",
];
const supportFileDownloadTypes = ["txt", "pdf", "doc", "json"];
const supportFileDownloadSRTTypes = ["webvtt", "srt"];
</script>
